import Vue from "vue";
import Vuex from "vuex";
import tr from "vue2-datepicker/locale/es/tr";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        menuCtrl: {
            popupState: '',
        },
        clinicalProducts: {
            oral: {
                title: "Пероральне харчування",
                slug: "oral",
                products: [
                    //2
                    {
                        titlePreviev: "Нутрідрінк Протеїн зі смаком лісових плодів",
                        titleSingle: "Нутрідрінк Протеїн зі смаком лісових плодів",
                        titleSingleEn: "Nutridrink Protein Berries flavour",
                        image: ["new_berries.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики",
                                content: [
                                    "<strong>Харчовий продукт для спеціальних медичних цілей:</strong> <br> ентеральне харчування Нутрідрінк Протеїн зі смаком лісових плодів / Nutridrink Protein Berries flavour – суміш рідка, готова до вживання, з високим вмістом білка та енергії, для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів від 3 років і старше та дорослих.",
                                ],
                                list: [
                                    "• Збалансований за складом.",
                                    "• Високий вміст білка у малому об’ємі: 18 г на 125 мл.",
                                    "• Високий вміст енергії: 300 ккал у 125 мл.",
                                    "• Не містить харчових волокон.",
                                    "• Без глютену.",
                                    " • Запаковано в захисному середовищі. Продукт стерилізовано при ультрависокій температурі.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування*",
                                content: [
                                    "<p>При станах, пов'язаних із втратою апетиту та/або відмовою від прийому їжі: онкологічних захворюваннях, неврологічних захворюваннях, психічних розладах, хворобах печінки, серцево-легеневій недостатності, ВІЛ-інфекції на стадії СНІДу, в похилому віці. У випадку захворювань шлунково-кишкового тракту (ШКТ): мукозитів, ентеритів різної етіології, зокрема спричинених променевою та хіміотерапією (холециститу, панкреатиту, фістул). За наявності часткових перешкод для проходження їжі: пухлин та травм голови і шиї, порушення жування і ковтання (дисфагії).</p>",
                                    "<p>Під час підготовки до операції, у післяопераційний період та період реабілітації.</p>",
                                    "<p>Під час підготовки до діагностичних процедур у травному тракті, наприклад, для колоноскопії.</p>",
                                    "<p>При наявності опіків, травм, пролежнів. </p>",
                                    "<p>При підвищеній потребі в білку та енергії. У випадку муковісцидозу, бульозного епідермолізу.</p>",
                                    "<p>При нутритивній недостатності (мальнутриції). **</p>",
                                ],
                                links: [
                                    '<strong>* </strong>відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href="https://www.espen.org/guidelines-home">https://www.espen.org/guidelines-home</a>',
                                    "<strong>** </strong>Cawood A.L ea al. Ageing Research Reviews 11 (2012) 278– 296.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, білки з коров'ячого <strong>молока</strong>, мальтодекстрин, цукор, рослинні олії (рапсова олія, соняшникова олія), гідроортофосфат магнію,   ароматизатор, емульгатор (<strong>соєвий</strong> лецитин), хлорид  холіну, барвник  (кармінова кислота), L-аскорбат натрію, цитрат калію, гідроортофосфат калію, барвник (цукровий колер IV), лактат заліза (II), ацетат DL-альфа токоферолу, ретинілацетат, глюконат міді, сульфат цинку, сульфат марганцю (II), D-пантотенат кальцію, селеніт натрію, D-біотин, хлорид  хрому (III),  холекальциферол, гідрохлорид тіаміну, фолієва кислота,   гідрохлорид піридоксину,  нікотинамід, йодид калію,  рибофлавін, молібдат натрію,   фторид натрію, ціанокобаламін, фітоменадіон. Без ГМО. Без глютену.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                      <table>
                      <thead>
                          <tr>
                          <th>
                              Енергетична
                              цінність
                          </th>
                          <th>
                              кДж/<br>ккал
                          </th>
                          <th>
                              1010/240
                          </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Жири, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          9,4
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span>– насичені<span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0,9</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Вуглеводи, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          24,4
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – цукри</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>13,3</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – лактоза</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0,3</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Харчові волокна
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Білки
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          14,4
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Сіль
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0,10
                          </td>
                          </tr>
                      </tbody>
                      </table>
                      `,
                                        `
                      <table>
                      <thead>
                          <tr>
                          <th colspan="3">Вітаміни</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Вітамін А
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          260
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін D
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          2,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін Е
                          </td>
                          <td>
                          мг <br>(α-TE)
                          </td>
                          <td>
                          3,7
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін К
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          16
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Тіамін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,45
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Рибофлавін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,50
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Ніацин
                          </td>
                          <td>
                          мг NE/
                          мг
                          </td>
                          <td>
                          3,6/
                          0,59
                          </td>
                          </tr>
                          <tr>
                            <td>
                            Пантотенова кислота
                            </td>
                            <td>
                            мг
                            </td>
                            <td>
                            1,6
                            </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В <sub>6</sub>
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,53
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фолієва кислота
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          80
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В<sub>12</sub>
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          1,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Біотин
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          12
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін С
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          30
                          </td>
                          </tr>
                      </tbody>
                      </table>
                      `,
                                        `
                      <table>
                      <thead>
                          <th colspan="3">Мінеральні речовини</th>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Натрій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          40
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Калій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          105
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хлориди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          60
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Кальцій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          350
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фосфор
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          300
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Магній
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          55
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Залізо
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Цинк
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,4
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Мідь
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,35
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Марганець
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,63
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фториди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,19
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Молібден
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          20
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Селен
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          14
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хром
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          13
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Йод
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          46
                          </td>
                          </tr>
                      </tbody>
                      </table>
                      `,
                                        `
                      <table>
                      <thead>
                          <tr>
                          <th colspan="3">Інші</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Холін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          110
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Осмолярність
                          </td>
                          <td>
                          мОсмоль/л
                          </td>
                          <td>
                          570
                          </td>
                          </tr>
                      </tbody>
                      </table>
                      `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                    <strong>Важлива інформація: </strong><br>
                    Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Не може бути використане як єдине джерело харчування. Не використовувати для дітей віком до 3 років. З обережністю застосовувати для дітей віком від 3 до 6 років. Слід постійно контролювати споживання рідини для забезпечення адекватної гідратації. Не є лікарським засобом.
                    `,
                                ],
                                list: [
                                    "<strong> Протипоказання </strong> ",
                                    "•	Алергія на білки коров'ячого молока.",
                                    "•	Індивідуальна непереносимість компонентів.",
                                    "•	Галактоземія.",
                                    "•	Вік від 0 до 3 років.",
                                ],
                                content2: [
                                    `
                  <p>
                  <strong>Форма випуску:</strong> <br>
                  Рідка суміш у пластиковий пляшечці, 4 пляшечки у картонній коробці об'ємом <br>
                  4х125 мл <strong>e</strong> (500 мл). <br>
                  </p>
                  `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                  <strong>Спосіб застосування.</strong><br>
                  <p>Перед застосуванням добре збовтати. Готовий до вживання, найкраще смакує охолодженним.</p>
                  <strong>Рекомендації щодо споживання*:</strong>
                  <p>Може використовуватися як додаткове джерело харчування.</p>
                  <p>Нутрідрінк Протеїн зі смаком лісових плодів необхідно пити повільно через його високу осмолярність і пов’язаний з нею ризик виникнення діареї, особливо під час першого застосування: 1 пляшечку протягом від 20 хвилин до 1 години маленькими ковтками.</p>
                  <p>Рекомендовано споживати 1-2 пляшечки (300-600 ккал) на день, в якості доповнення до раціону, якщо ваш лікар не порекомендував вам інше.</p>
                  <p>Нутрідрінк Протеїн зі смаком лісових плодів слід приймати регулярно. Регулярність і безперервність прийому згідно рекомендацій лікаря дозволять правильно живити організм і постачати його енергією та харчовими речовинами, необхідними для боротьби з хворобою. Оптимальна тривалість споживання обговорюється лікарем.</p>
                  <p>Оптимальна тривалість споживання Нутрідрінк Протеїн зі смаком лісових плодів становить 2 пляшечки на день протягом як мінімум 14 днів, в якості додаткового харчування, якщо ваш лікар не порекомендував вам інше.</p>
                  <p>Добова потреба в продукті індивідуальна та визначається з урахуванням віку, маси тіла та стану здоров'я.</p>
                  `,
                                ],
                                links: [
                                    "<strong>*</strong> A.L. Cawood,E.R. Walters,T.R. Smith, R.J. Stratton Systematic review and meta-analysis of the effects of high protein oral nutritional supplements. Clinical Nutrition.  Vol.37. 1. S305. 2018 (https://www.clinicalnutritionjournal.com/issue/S0261-5614(18)X0006-5)",
                                ],
                            },
                        ],
                    },
                    //5
                    {
                        titlePreviev: "Нутрідрінк Протеїн зі смаком мокко",
                        titleSingle: "Нутрідрінк Протеїн зі смаком мокко",
                        titleSingleEn: "Nutridrink Protein Mocha flavour",
                        image: ["new_mocha.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики",
                                content: [
                                    "<p><strong>Харчовий продукт для спеціальних медичних цілей:</strong><br> ентеральне харчування Нутрідрінк Протеїн зі смаком мокко / Nutridrink Protein Mocha flavour – суміш рідка, готова до вживання, з високим вмістом білка та енергії, для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів від 3 років і старше та дорослих.</p>",
                                ],
                                list: [
                                    "• Збалансоване за складом.",
                                    "• Високий вміст білка у малому об’ємі: 18 г на 125 мл.",
                                    "• Високий вміст енергії: 300 ккал у 125 мл.",
                                    "• Містить вітаміни та мікроелементи (селен, хром, тощо).",
                                    "• Не містить харчових волокон.",
                                    "• Безглютеновий продукт.",
                                    "• Запаковано в захисному середовищі. Продукт стерилізовано при ультрависокій температурі.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування* ",
                                content: [
                                    "<p>При станах, пов'язаних із втратою апетиту та/або відмовою від прийому їжі: онкологічних захворюваннях, неврологічних захворюваннях, психічних розладах, хворобах печінки, серцево-легеневій недостатності, ВІЛ інфекції на стадії СНІДу, у похилому віці. У випадку захворювань шлунково-кишкового тракту (ШКТ): мукозитів, ентеритів різної етіології, зокрема спричинених променевою та хіміотерапією (холециститу, панкреатиту, фістул). За наявності часткових перешкод для проходження їжі: пухлин та травм голови і шиї, порушення ковтання і жування (дисфагії), стриктур та обструкції різних відділів шлунково-кишкового тракту.</p>",
                                    "<p>Під час підготовки до операції, у післяопераційний період та у період реабілітації.</p>",
                                    "<p>Під час підготовки до діагностичних процедур на травному тракті, наприклад, для колоноскопії.</p>",
                                    "<p>При наявності опіків, травм, пролежнів.</p>",
                                    "<p>При підвищеній потребі в білку та енергії. У випадку муковісцидозу, бульозного епідермолізу.</p>",
                                    "<p>При нутритивній недостатності (мальнутриції).</p>",
                                ],
                                links: [
                                    '<strong>* </strong>відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href="https://www.espen.org/guidelines-home">https://www.espen.org/guidelines-home</a>',
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, білки з коров'ячого <strong>молока</strong>, мальтодекстрин, цукор, рослинні олії (рапсова олія, соняшникова олія), гідроортофосфат магнію, емульгатор (<strong>соєвий</strong> лецитин), ароматизатор, хлорид холіну, L-аскорбат натрію, цитрат калію, барвник (цукровий колер IV), гідроортофосфат калію, лактат заліза (II), ацетат DL-альфа токоферолу, ретинілацетат, глюконат міді, сульфат цинку, сульфат марганцю (II), D-пантотенат кальцію, селеніт натрію, D-біотин, хлорид хрому (III), холекальциферол, гідрохлорид тіаміну, фолієва кислота, гідрохлорид піридоксину, нікотинамід, йодид калію, рибофлавін, молібдат натрію, фторид натрію, ціанокобаламін, фітоменадіон. Без ГМО. Без глютену.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th>
                              Енергетична
                              цінність
                          </th>
                          <th>
                              кДж/<br>ккал
                          </th>
                          <th>
                              1010/240
                          </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Жири, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          9,4
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span>– насичені<span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0,9</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Вуглеводи, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          24,4
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – цукри</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>13,3</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – лактоза</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td><span>
                          <span>0,3</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Харчові волокна
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Білки
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          14,4
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Сіль
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0,10
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="3">Вітаміни</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Вітамін А
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          260
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін D
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          2,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін Е
                          </td>
                          <td>
                          мг <br>(α-TE)
                          </td>
                          <td>
                          3,7
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін К
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          16
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Тіамін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,45
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Рибофлавін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,50
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Ніацин
                          </td>
                          <td>
                          мг NE/
                          мг
                          </td>
                          <td>
                          3,6/
                          0,59
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Пантотенова кислота
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          1,6
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В <sub>6</sub>
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,53
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фолієва кислота
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          80
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В<sub>12</sub>
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          1,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Біотин
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          12
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін С
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          30
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <th colspan="3">Мінеральні речовини</th>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Натрій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          40
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Калій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          105
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хлориди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          60
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Кальцій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          350
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фосфор
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          300
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Магній
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          55
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Залізо
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Цинк
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,4
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Мідь
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,35
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Марганець
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,63
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фториди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,19
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Молібден
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          20
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Селен
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          14
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хром
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          13
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Йод
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          46
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="3">Інші</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Холін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          110
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Осмолярність
                          </td>
                          <td>
                          мОсмоль/л
                          </td>
                          <td>
                          570
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                    <strong>Важлива інформація: </strong><br>
                    Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Не може бути використане як єдине джерело харчування. Не використовувати для дітей віком до 3 років. З обережністю застосовувати для дітей віком від 3 до 6 років. Слід постійно контролювати споживання рідини для забезпечення адекватної гідратації. Не є лікарським засобом.
                    `,
                                ],
                                list: [
                                    "<strong> Протипоказання </strong> ",
                                    "•	Алергія на білки коров'ячого молока.",
                                    "•	Індивідуальна непереносимість компонентів.",
                                    "•	Галактоземія.",
                                    "•	Вік від 0 до 3 років.",
                                ],
                                content2: [
                                    `
                  <p>
                  <strong>Форма випуску:</strong> <br>
                  Рідка суміш у пластиковий пляшечці, 4 пляшечки у картонній коробці об'ємом <br>
                  4х125 мл <strong>e</strong> (500 мл). <br>
                  </p>
                  `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                    <strong>Спосіб застосування.</strong> <br>
                    <p>Перед застосуванням добре збовтати. Готовий до вживання, найкраще смакує охолодженним.</p>
                    <p>Пити повільно, 1 пляшечку протягом приблизно 20-30 хвилин.</p>
                    <p>Можна вживати в якості доповнення до дієти чи застосовувати як добавку до їжі.</p>
                    <strong>Рекомендації щодо споживання*:</strong>
                    <p>Нутрідрінк Протеїн зі смаком мокко необхідно пити повільно через його високу осмолярність і пов’язаний з нею ризик виникнення діареї, особливо під час першого застосування: 1 пляшечку протягом від 20 хвилин до 1 години маленькими ковтками.</p>
                    <p>Рекомендовано споживати 1-2 пляшечки (300-600 ккал) на день, в якості доповнення до раціону, якщо ваш лікар не порекомендував вам інше.</p>
                    <p>Нутрідрінк Протеїн зі смаком мокко слід приймати регулярно. Регулярність і безперервність прийому згідно рекомендацій лікаря дозволять правильно живити організм і постачати його енергією та харчовими речовинами, необхідними для боротьби з хворобою. Оптимальна тривалість споживання обговорюється лікарем. Оптимальна тривалість споживання Нутрідрінк Протеїн зі смаком мокко становить 2 пляшечки на день протягом як мінімум 14 днів, в якості додаткового харчування, якщо ваш лікар не порекомендував вам інше.</p>
                    `,
                                ],
                                links: [
                                    "<strong>*</strong> A.L. Cawood,E.R. Walters,T.R. Smith, R.J. Stratton Systematic review and meta-analysis of the effects of high protein oral nutritional supplements. Clinical Nutrition.  Vol.37. 1. S305. 2018 (https://www.clinicalnutritionjournal.com/issue/S0261-5614(18)X0006-5)",
                                ],
                            },
                        ],
                    },
                    //7
                    {
                        titlePreviev: "Нутрідрінк Протеїн зі смаком полуниці",
                        titleSingle: "Нутрідрінк Протеїн зі смаком полуниці",
                        titleSingleEn: "Nutridrink Protein Strawberry flavour",
                        image: ["new_strawberry.jpg"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики",
                                content: [
                                    "<p><strong>Харчовий продукт для спеціальних медичних цілей:</strong><br> ентеральне харчування Нутрідрінк Протеїн зі смаком полуниці / Nutridrink Protein Strawberry flavour – суміш рідка, готова до вживання, з високим вмістом білка та енергії, для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів від 3 років і старше та дорослих.</p>",
                                ],
                                list: [
                                    "• Збалансований за складом.",
                                    "• Високий вміст білка у малому об’ємі: 18 г на 125 мл.",
                                    "• Високий вміст енергії: 300 ккал в 125 мл.",
                                    "• Містить вітаміни та мікроелементи (селен, хром, тощо).",
                                    "• Не містить харчових волокон.",
                                    "• Безглютеновий продукт.",
                                    "• Запаковано в захисному середовищі. Продукт стерилізовано при ультрависокій температурі.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування* ",
                                content: [
                                    "<p>При станах, пов'язаних із втратою апетиту та/або відмовою від прийому їжі: онкологічних захворюваннях, неврологічних захворюваннях, психічних розладах, хворобах печінки, серцево-легеневій недостатності, ВІЛ-інфекції на стадії СНІДу, в похилому віці. У випадку захворювань шлунково-кишкового тракту (ШКТ): мукозитів, ентеритів різної етіології, зокрема спричинених променевою та хіміотерапією (холециститу, панкреатиту, фістул). При наявності часткових перешкод для проходження їжі: пухлин та травм голови і шиї, порушення ковтання і жування (дисфагії), стриктур та обструкції різних відділів шлунково-кишкового тракту.</p>",
                                    "<p>Під час підготовки до операції, у післяопераційний період та в період реабілітації.</p>",
                                    "<p>Під час підготовки до діагностичних процедур у травному тракті, наприклад, для колоноскопії.</p>",
                                    "<p>При наявності опіків, травм, пролежнів.</p>",
                                    "<p>При підвищеній потребі в білку та енергії. У випадку муковісцидозу, бульозного епідермолізу.</p>",
                                    "<p>При нутритивній недостатності (мальнутриції).</p>",
                                ],
                                links: [
                                    '<strong>* </strong>відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href="https://www.espen.org/guidelines-home">https://www.espen.org/guidelines-home</a>',
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, білки з коров'ячого <strong>молока</strong>, мальтодекстрин, цукор, рослинні олії (рапсова олія, соняшникова олія), гідроортофосфат магнію, емульгатор (<strong>соєвий</strong> лецитин), ароматизатор, хлорид холіну, барвник (кармінова кислота), L-аскорбат натрію, цитрат калію, гідроортофосфат калію, лактат заліза (II), ацетат DL-альфа токоферолу, ретинілацетат, глюконат міді, сульфат цинку, сульфат марганцю (II), D-пантотенат кальцію, селеніт натрію, D-біотин, хлорид хрому (III), холекальциферол, гідрохлорид тіаміну, фолієва кислота, гідрохлорид піридоксину, нікотинамід, йодид калію, рибофлавін, молібдат натрію, фторид натрію, ціанокобаламін, фітоменадіон. Без ГМО. Без глютену.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th>
                              Енергетична
                              цінність
                          </th>
                          <th>
                              кДж/<br>ккал
                          </th>
                          <th>
                              1010/240
                          </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Жири, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          9,4
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span>– насичені<span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0,9</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Вуглеводи, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          24,4
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – цукри</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>13,3</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – лактоза</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0,3</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Харчові волокна
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Білки
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          14,4
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Сіль
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0,10
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="3">Вітаміни</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Вітамін А
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          260
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін D
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          2,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін Е
                          </td>
                          <td>
                          мг <br>(α-TE)
                          </td>
                          <td>
                          3,7
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін К
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          16
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Тіамін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,45
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Рибофлавін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,50
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Ніацин
                          </td>
                          <td>
                          мг NE/
                          мг
                          </td>
                          <td>
                          3,6/
                          0,59
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Пантотенова кислота
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          1,6
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В <sub>6</sub>
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,53
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фолієва кислота
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          80
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В<sub>12</sub>
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          1,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Біотин
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          12
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін С
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          30
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <th colspan="3">Мінеральні речовини</th>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Натрій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          40
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Калій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          105
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хлориди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          60
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Кальцій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          350
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фосфор
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          300
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Магній
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          55
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Залізо
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Цинк
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,4
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Мідь
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,35
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Марганець
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,63
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фториди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,19
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Молібден
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          20
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Селен
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          14
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хром
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          13
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Йод
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          46
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="3">Інші</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Холін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          110
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Осмолярність
                          </td>
                          <td>
                          мОсмоль/л
                          </td>
                          <td>
                          570
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                    <strong>Важлива інформація: </strong><br>
                    Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Не може бути використане як єдине джерело харчування. Не використовувати для дітей віком до 3 років. З обережністю застосовувати для дітей віком від 3 до 6 років. Слід постійно контролювати споживання рідини для забезпечення адекватної гідратації. Не є лікарським засобом.
                    `,
                                ],
                                list: [
                                    "<strong> Протипоказання:</strong> ",
                                    "•	Алергія на білки коров'ячого молока.",
                                    "•	Індивідуальна непереносимість компонентів.",
                                    "•	Галактоземія.",
                                    "•	Вік від 0 до 3 років.",
                                ],
                                content2: [
                                    `
                    <p>
                    <strong>Форма випуску:</strong> <br>
                    Рідка суміш у пластиковий пляшечці, 4 пляшечки у картонній коробці об'ємом <br>
                    4х125 мл <strong>e</strong> (500 мл). <br>
                    </p>
                `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                    <strong> Спосіб застосування. </strong> <br>
                    <p>Перед застосуванням добре збовтати. Готовий до вживання, найкраще смакує охолодженним.</p>
                    <p>Пити повільно, 1 пляшечку протягом приблизно 20-30 хвилин.</p>
                    <p>Можна вживати в якості доповнення до дієти чи застосовувати як добавку до їжі.</p>
                    <strong>Рекомендації щодо споживання*:</strong>
                    <p>Нутрідрінк Протеїн зі смаком полуниці необхідно пити повільно через його високу осмолярність і пов’язаний з нею ризик виникнення діареї, особливо під час першого застосування: 1 пляшечку протягом від 20 хвилин до 1 години маленькими ковтками.</p>
                    <p>Рекомендовано споживати 1-2 пляшечки (300-600 ккал) на день, в якості доповнення до раціону, якщо ваш лікар не порекомендував вам інше.</p>
                    <p>Нутрідрінк Протеїн зі смаком полуниці слід приймати регулярно. Регулярність і безперервність прийому згідно рекомендацій лікаря дозволять правильно живити організм і постачати його енергією та харчовими речовинами, необхідними для боротьби з хворобою. Оптимальна тривалість споживання обговорюється лікарем.</p>
                    <p>Оптимальна тривалість споживання Нутрідрінк Протеїн зі смаком полуниці становить 2 пляшечки на день протягом як мінімум 14 днів, в якості додаткового харчування, якщо ваш лікар не порекомендував вам інше.</p>
                    `,
                                ],
                                links: [
                                    "<strong>*</strong> A.L. Cawood,E.R. Walters,T.R. Smith, R.J. Stratton Systematic review and meta-analysis of the effects of high protein oral nutritional supplements. Clinical Nutrition.  Vol.37. 1. S305. 2018 (https://www.clinicalnutritionjournal.com/issue/S0261-5614(18)X0006-5)",
                                ],
                            },
                        ],
                    },
                    //8
                    {
                        titlePreviev: "Нутрідрінк Протеїн зі смаком ванілі",
                        titleSingle: "Нутрідрінк Протеїн зі смаком ванілі",
                        titleSingleEn: "Nutridrink Protein Vanilla flavour",
                        image: ["new_vanilla.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики",
                                content: [
                                    "<p><strong>Харчовий продукт для спеціальних медичних цілей:</strong><br> ентеральне харчування Нутрідрінк Протеїн зі смаком ванілі / Nutridrink Protein Vanilla flavour – суміш рідка, готова до вживання, з високим вмістом білка та енергії, для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів від 3 років і старше та дорослих.</p>",
                                ],
                                list: [
                                    "• Збалансований за складом.",
                                    "• Високий вміст білка у малому об’ємі: 18 г на 125 мл.",
                                    "• Високий вміст енергії: 300 ккал в 125 мл.",
                                    "• Містить вітаміни та мікроелементи (селен, хром, тощо).",
                                    "• Не містить харчових волокон.",
                                    "• Безглютеновий продукт.",
                                    "• Запаковано в захисному середовищі. Продукт стерилізовано при ультрависокій температурі.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування* ",
                                content: [
                                    "<p>При станах, пов'язаних із втратою апетиту та/або відмовою від прийому їжі: онкологічних захворюваннях, неврологічних захворюваннях, психічних розладах, хворобах печінки, серцево-легеневій недостатності, ВІЛ-інфекції на стадії СНІДу, в похилому віці. У випадку захворювань шлунково-кишкового тракту (ШКТ): мукозитів, ентеритів різної етіології, зокрема спричинених променевою та хіміотерапією (холециститу, панкреатиту, фістул). При наявності часткових перешкод для проходження їжі: пухлин та травм голови і шиї, порушення ковтання і жування (дисфагії), стриктур та обструкції різних відділів шлунково-кишкового тракту.</p>",
                                    "<p>Під час підготовки до операції, у післяопераційний період та в період реабілітації.</p>",
                                    "<p>Під час підготовки до діагностичних процедур у травному тракті, наприклад, для колоноскопії.</p>",
                                    "<p>При наявності опіків, травм, пролежнів.</p>",
                                    "<p>При підвищеній потребі в білку та енергії. У випадку муковісцидозу, бульозного епідермолізу.</p>",
                                    "<p>При нутритивній недостатності (мальнутриції).</p>",
                                ],
                                links: [
                                    '<strong>* </strong>відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href="https://www.espen.org/guidelines-home">https://www.espen.org/guidelines-home</a>',
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, білки з коров'ячого <strong>молока</strong>, мальтодекстрин, цукор, рослинні олії (рапсова олія, соняшникова олія), гідроортофосфат магнію,  емульгатор (<strong>соєвий</strong> лецитин), ароматизатор, хлорид холіну, L-аскорбат натрію, цитрат калію, гідроортофосфат калію, лактат  заліза (II), ацетат DL-альфа токоферолу, ретинілацетат, глюконат міді, сульфат цинку, сульфат марганцю (II), D-пантотенат кальцію, селеніт натрію, D-біотин, хлорид хрому (III), холекальциферол, гідрохлорид тіаміну, фолієва   кислота, гідрохлорид піридоксину, нікотинамід, йодид калію, рибофлавін, молібдат натрію, фторид натрію, ціанокобаламін, фітоменадіон. Без ГМО. Без глютену.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th>
                              Енергетична
                              цінність
                          </th>
                          <th>
                              кДж/<br>ккал
                          </th>
                          <th>
                              1010/240
                          </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Жири, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          9,4
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span>– насичені<span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0,9</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Вуглеводи, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          24,4
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – цукри</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>13,3</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – лактоза</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0,3</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Харчові волокна
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Білки з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          14,4
                          </td>
                          </tr>


                          <tr>
                          <td>
                          Сіль
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0,10
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="3">Вітаміни</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Вітамін А
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          260
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін D
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          2,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін Е
                          </td>
                          <td>
                          мг <br>(α-TE)
                          </td>
                          <td>
                          3,7
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін К
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          16
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Тіамін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,45
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Рибофлавін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,50
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Ніацин
                          </td>
                          <td>
                          мг NE/
                          мг
                          </td>
                          <td>
                          3,6/
                          0,59
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Пантотенова кислота
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          1,6
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В <sub>6</sub>
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,53
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фолієва кислота
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          80
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В<sub>12</sub>
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          1,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Біотин
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          12
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін С
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          30
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <th colspan="3">Мінеральні речовини</th>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Натрій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          40
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Калій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          105
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хлориди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          60
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Кальцій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          350
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фосфор
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          300
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Магній
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          55
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Залізо
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Цинк
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,4
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Мідь
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,35
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Марганець
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,63
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фториди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,19
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Молібден
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          20
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Селен
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          14
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хром
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          13
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Йод
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          46
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="3">Інші</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Холін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          110
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Осмолярність
                          </td>
                          <td>
                          мОсмоль/л
                          </td>
                          <td>
                          570
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                    <strong>Важлива інформація: </strong><br>
                    Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Не може бути використане як єдине джерело харчування. Не використовувати для дітей віком до 3 років. З обережністю застосовувати для дітей віком від 3 до 6 років. Слід постійно контролювати споживання рідини для забезпечення адекватної гідратації. Не є лікарським засобом.
                    `,
                                ],
                                list: [
                                    "<strong> Протипоказання:</strong> ",
                                    "•	Алергія на білки коров'ячого молока.",
                                    "•	Індивідуальна непереносимість компонентів.",
                                    "•	Галактоземія.",
                                    "•	Вік від 0 до 3 років.",
                                ],
                                content2: [
                                    `
                    <p>
                    <strong>Форма випуску:</strong> <br>
                    Рідка суміш у пластиковий пляшечці, 4 пляшечки у картонній коробці об'ємом <br>
                    4х125 мл <strong>e</strong> (500 мл). <br>
                    </p>
                  `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                    <strong> Спосіб застосування. </strong> <br>
                    <p>Перед застосуванням добре збовтати. Готовий до вживання, найкраще смакує охолодженним.</p>
                    <p>Пити повільно, 1 пляшечку протягом приблизно 20-30 хвилин.</p>
                    <p>Можна вживати в якості доповнення до дієти чи застосовувати як добавку до їжі.</p>
                    <strong>Рекомендації щодо споживання*:</strong>
                    <p>Нутрідрінк Протеїн зі смаком ванілі необхідно пити повільно через його високу осмолярність і пов’язаний з нею ризик виникнення діареї, особливо під час першого застосування: 1 пляшечку протягом від 20 хвилин до 1 години маленькими ковтками.</p>
                    <p>Рекомендовано споживати 1-2 пляшечки (300-600 ккал) на день, в якості доповнення до раціону, якщо ваш лікар не порекомендував вам інше.</p>
                    <p>Нутрідрінк Протеїн зі смаком ванілі слід приймати регулярно. Регулярність і безперервність прийому згідно рекомендацій лікаря дозволять правильно живити організм і постачати його енергією та харчовими речовинами, необхідними для боротьби з хворобою. Оптимальна тривалість споживання обговорюється лікарем.</p>
                    <p>Оптимальна тривалість споживання Нутрідрінк Протеїн зі смаком ванілі становить 2 пляшечки на день протягом як мінімум 14 днів, в якості додаткового харчування, якщо ваш лікар не порекомендував вам інше.</p>
                    `,
                                ],
                                links: [
                                    "<strong>*</strong> A.L. Cawood,E.R. Walters,T.R. Smith, R.J. Stratton Systematic review and meta-analysis of the effects of high protein oral nutritional supplements. Clinical Nutrition.  Vol.37. 1. S305. 2018 (https://www.clinicalnutritionjournal.com/issue/S0261-5614(18)X0006-5)",
                                ],
                            },
                        ],
                    },
                    //3
                    {
                        titlePreviev:
                            "Нутрідрінк Протеїн охолоджуючий зі смаком червоних плодів",
                        titleSingle:
                            "Нутрідрінк Протеїн охолоджуючий зі смаком червоних плодів",
                        titleSingleEn: "Nutridrink Protein Cool Red Fruits flavour",
                        image: ["new_red_fruits.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p><strong>Харчовий продукт для спеціальних медичних цілей:</strong><br> ентеральне харчування Нутрідрінк Протеїн охолоджуючий зі смаком червоних плодів / Nutridrink Protein Cool Red Fruits flavour – суміш рідка, готова до вживання, з високим вмістом білка та енергії, для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів від 3 років і старше та дорослих.</p>",
                                ],
                                list: [
                                    "• Високий вміст білка у малому об’ємі: 18 г на 125 мл.",
                                    "• Розроблено для онкологічних хворих. Рекомендується для використання в якості додаткового харчування під час хіміотерапії, променевої терапії та хірургії, між циклами хіміотерапії та променевої терапії, під час одужання, за надання паліативної допомоги.",
                                    "• Інноваційні, розроблені компанією Nutricia смаки Нутрідрінк Протеїн (Червоні плоди – охолоджуючий; Тропічні фрукти та імбир – зігріваючий; Нейтральний) рекомендується застосовувати для пацієнтів, що проходять хіміотерапію та променеву терапію, особливо за наявності побічних ефектів, пов’язаних з протипухлинною терапією, зокрема інверсії смаку (зміни смакових відчуттів).",
                                    "• Не містить харчових волокон.",
                                    "• Безглютеновий продукт.",
                                    "• Запаковано в захисному середовищі. Продукт стерилізовано при ультрависокій температурі.",
                                ],
                                links: [
                                    '<strong>* </strong>відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href="https://www.espen.org/guidelines-home">https://www.espen.org/guidelines-home</a>',
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування",
                                content: [
                                    "<p>За станів, пов'язаних із втратою апетиту та/або відмовою від прийому їжі.</p>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, мальтодекстрин, білки з коров’ячого <strong>молока</strong>, цукор, рослинні олії (рапсова олія, соняшникова олія), ароматизатори, гідроортофосфат магнію, емульгатор (<strong>соєвий</strong> лецитин), хлорид холіну, барвник (кармін), L-аскорбат натрію, цитрат калію, гідроортофосфат калію, лактат заліза (II), ацетат DL-альфа токоферолу, глюконат міді, сульфат цинку, сульфат марганцю (II), D-пантотенат кальцію, гідрохлорид тіаміну, гідрохлорид піридоксину, нікотинамід, рибофлавін, ретинілацетат, фторид натрію, фолієва кислота, хлорид хрому (III), молібдат натрію, селеніт натрію, D-біотин, фітоменадіон, йодид калію, холекальциферол, ціанокобаламін. Без ГМО. Без глютену.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th>
                              Енергетична
                              цінність
                          </th>
                          <th>
                              кДж/<br>ккал
                          </th>
                          <th>
                              1030/245
                          </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Жири, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          9,6
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span>– насичені<span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0,87</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Вуглеводи, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          25,3
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – цукри</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>13,6</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – лактоза</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0,30</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Харчові волокна
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Білки
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          14,6
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Сіль
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0,08
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="3">Вітаміни</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Вітамін А
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          288
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін D
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          2,08
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін Е
                          </td>
                          <td>
                          мг <br>(α-TE)
                          </td>
                          <td>
                          5,21
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін К
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          13,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Тіамін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,52
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Рибофлавін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,57
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Ніацин
                          </td>
                          <td>
                          мг NE/
                          мг
                          </td>
                          <td>
                          3,97/
                          0,70
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Пантотенова кислота
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          1,53
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Вітамін В <sub>6</sub>
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,61
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фолієва кислота
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          80,9
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В<sub>12</sub>
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          0,90
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <th colspan="3">Мінеральні речовини</th>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Натрій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          31,5
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Калій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          98,3
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хлориди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          52,9
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Кальцій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          350
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фосфор
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          279
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Магній
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          54,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Залізо
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,21
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Цинк
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,58
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Мідь
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,35
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Марганець
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,64
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фториди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,19
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Молібден
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          22,8
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Селен
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          15,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хром
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          15,4
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Йод
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          49,9
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="3">Інші</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Холін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          99,4
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Осмолярність
                          </td>
                          <td>
                          мОсмоль/л
                          </td>
                          <td>
                          570
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                  <strong>Важлива інформація: </strong><br>
                  Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Не може бути використане як єдине джерело харчування. Не використовувати для дітей віком до 3 років. З обережністю застосовувати для дітей віком від 3 до 6 років. Слід постійно контролювати споживання рідини для забезпечення адекватної гідратації. Не є лікарським засобом.
                  `,
                                ],
                                list: [
                                    "<strong> Протипоказання </strong> ",
                                    "•	Алергія на білки коров'ячого молока.",
                                    "•	Індивідуальна непереносимість компонентів.",
                                    "•	Галактоземія.",
                                    "•	Вік від 0 до 3 років.",
                                ],
                                content2: [
                                    `
                  <p>
                  <strong>Форма випуску:</strong> <br>
                  Рідка суміш у пластиковий пляшечці, 4 пляшечки у картонній коробці об'ємом <br>
                  4х125 мл <strong>e</strong> (500 мл). <br>
                  </p>
                  `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                  <strong> Спосіб застосування. </strong> <br>
                  <p>Перед застосуванням добре збовтати. Готовий до вживання, найкраще смакує охолодженним.</p>
                  <p>Пити повільно, 1 пляшечку протягом приблизно 20-30 хвилин.</p>
                  <p>Можна вживати в якості доповнення до дієти чи застосовувати як добавку до їжі.</p>
                  <strong>Рекомендації щодо споживання*:</strong>
                  <p>Може використовуватися як додаткове джерело харчування.</p>
                  <p>Нутрідрінк Протеїн охолоджуючий зі смаком червоних плодів необхідно пити повільно через його високу осмолярність і пов’язаний з нею ризик виникнення діареї, особливо під час першого застосування: 1 пляшечку протягом від 20 хвилин до 1 години маленькими ковтками.</p>
                  <p>Рекомендовано споживати 1-2 пляшечки (300-600 ккал) на день, в якості доповнення до раціону, якщо ваш лікар не порекомендував вам інше.</p>
                  <p>Оптимальна тривалість споживання Нутрідрінк Протеїн охолоджуючий зі смаком червоних плодів становить 2 пляшечки на день протягом як мінімум 14 днів, в якості додаткового харчування, якщо ваш лікар не порекомендував вам інше.</p>
                  <p>Добова потреба в продукті індивідуальна та визначається з урахуванням віку, маси тіла та стану здоров'я.</p>
                  `,
                                ],
                                links: [
                                    "<strong>*</strong> A.L. Cawood,E.R. Walters,T.R. Smith, R.J. Stratton Systematic review and meta-analysis of the effects of high protein oral nutritional supplements. Clinical Nutrition.  Vol.37. 1. S305. 2018 (https://www.clinicalnutritionjournal.com/issue/S0261-5614(18)X0006-5)",
                                ],
                            },
                        ],
                    },
                    //6
                    {
                        titlePreviev: "Нутрідрінк Протеїн з нейтральним смаком",
                        titleSingle: "Нутрідрінк Протеїн з нейтральним смаком",
                        titleSingleEn: "Nutridrink Protein Neutral flavour",
                        image: ["new_neutral.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p><strong>Харчовий продукт для спеціальних медичних цілей:</strong> ентеральне харчування Нутрідрінк Протеїн з нейтральним смаком / Nutridrink Protein Neutral flavour – суміш рідка, готова до вживання, з високим вмістом білка та енергії, для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів від 3 років і старше та дорослих.</p>",
                                ],
                                list: [
                                    "• Високий вміст білка у малому об’ємі: 18 г на 125 мл.",
                                    "• Розроблено для онкологічних хворих. Рекомендується для використання в якості додаткового харчування під час хіміотерапії, променевої терапії та хірургії, між циклами хіміотерапії та променевої терапії, під час одужання, за надання паліативної допомоги.",
                                    "• Інноваційні, розроблені компанією Nutricia смаки Нутрідрінк Протеїн (Червоні плоди – охолоджуючий; Тропічні фрукти та імбир – зігріваючий; Нейтральний) рекомендується застосовувати для пацієнтів, що проходять хіміотерапію та променеву терапію, особливо за наявності побічних ефектів, пов’язаних з протипухлинною терапією, зокрема інверсії смаку (зміни смакових відчуттів).",
                                    "• Не містить харчових волокон.",
                                    "• Безглютеновий продукт.",
                                    "• Запаковано в захисному середовищі. Продукт стерилізовано при ультрависокій температурі.",
                                ],
                                links: [
                                    '<strong>* </strong>відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href="https://www.espen.org/guidelines-home">https://www.espen.org/guidelines-home</a>',
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування",
                                content: [
                                    "<p>При станах, пов'язаних із втратою апетиту та/або відмовою від прийому їжі.</p>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, мальтодекстрин, білки з коров’ячого <strong>молока</strong>, цукор, рослинні олії (рапсова олія, соняшникова олія), ароматизатор, гідроортофосфат магнію, емульгатор (<strong>соєвий</strong> лецитин), хлорид холіну, L-аскорбат натрію, цитрат калію, гідроортофосфат калію, лактат заліза (II), ацетат DL-альфа токоферолу, глюконат міді, сульфат цинку, сульфат марганцю (II), D-пантотенат кальцію, гідрохлорид тіаміну, гідрохлорид піридоксину, нікотинамід, рибофлавін, ретинілацетат, фторид натрію, фолієва кислота, хлорид хрому (III), молібдат натрію, селеніт натрію, D-біотин, фітоменадіон, йодид калію, холекальциферол, ціанокобаламін. Без ГМО. Без глютену.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th>
                              Енергетична
                              цінність
                          </th>
                          <th>
                              кДж/<br>ккал
                          </th>
                          <th>
                              1030/245
                          </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Жири, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          9,6
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span>– насичені<span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0,87</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Вуглеводи, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          25,3
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – цукри</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>13,6</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – лактоза</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0,30</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Харчові волокна
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Білки
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          14,6
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Сіль
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0,08
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="3">Вітаміни</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Вітамін А
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          288
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін D
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          2,08
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін Е
                          </td>
                          <td>
                          мг <br>(α-TE)
                          </td>
                          <td>
                          5,21
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін К
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          13,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Тіамін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,52
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Рибофлавін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,57
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Ніацин
                          </td>
                          <td>
                          мг NE/
                          мг
                          </td>
                          <td>
                          3,97/
                          0,70
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Пантотенова кислота
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          1,53
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В <sub>6</sub>
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,61
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фолієва кислота
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          80,9
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В<sub>12</sub>
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          0,90
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Біотин
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          10,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін С
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          30,9
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <th colspan="3">Мінеральні речовини</th>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Натрій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          31,5
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Калій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          98,3
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хлориди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          52,9
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Кальцій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          350
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фосфор
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          279
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Магній
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          54,1
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Залізо
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,21
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Цинк
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,58
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Мідь
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,35
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Марганець
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,64
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фториди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,19
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Молібден
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          22,8
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Селен
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          15,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хром
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          15,4
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Йод
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          49,9
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="3">Інші</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Холін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          99,4
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Осмолярність
                          </td>
                          <td>
                          мОсмоль/л
                          </td>
                          <td>
                          570
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                    <strong>Важлива інформація: </strong><br>
                    Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Не може бути використане як єдине джерело харчування. Не використовувати для дітей віком до 3 років. З обережністю застосовувати для дітей віком від 3 до 6 років. Слід постійно контролювати споживання рідини для забезпечення адекватної гідратації. Не є лікарським засобом.
                    `,
                                ],
                                list: [
                                    "<strong> Протипоказання </strong> ",
                                    "•	Алергія на білки коров'ячого молока.",
                                    "•	Індивідуальна непереносимість компонентів.",
                                    "•	Галактоземія.",
                                    "•	Вік від 0 до 3 років.",
                                ],
                                content2: [
                                    `
                  <p>
                  <strong>Форма випуску:</strong> <br>
                  Рідка суміш у пластиковий пляшечці, 4 пляшечки у картонній коробці об'ємом <br>
                  4х125 мл <strong>e</strong> (500 мл). <br>
                  </p>
                  `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                    <strong> Спосіб застосування. </strong><br>
                    <p>Перед застосуванням добре збовтати. Готовий до вживання, найкраще смакує охолодженним.</p>
                    <p>Пити повільно, 1 пляшечку протягом приблизно 20-30 хвилин.</p>
                    <p>Можна вживати в якості доповнення до дієти чи застосовувати як добавку до їжі.</p>
                    <strong>Рекомендації щодо споживання*:</strong>
                    <p>Може використовуватися як додаткове джерело харчування.</p>
                    <p>Нутрідрінк Протеїн з нейтральним смаком необхідно пити повільно через його високу осмолярність і пов’язаний з нею ризик виникнення діареї, особливо під час першого застосування: 1 пляшечку протягом від 20 хвилин до 1 години маленькими ковтками.</p>
                    <p>Рекомендовано споживати 1-2 пляшечки (300-600 ккал) на день, в якості доповнення до раціону, якщо ваш лікар не порекомендував вам інше.</p>
                    <p>Нутрідрінк Протеїн з нейтральним смаком слід приймати регулярно. Регулярність і безперервність прийому згідно рекомендацій лікаря дозволять правильно живити організм і постачати його енергією та харчовими речовинами, необхідними для боротьби з хворобою. Оптимальна тривалість споживання обговорюється лікарем.</p>
                    <p>Оптимальна тривалість споживання Нутрідрінк Протеїн з нейтральним смаком  становить 2 пляшечки на день протягом як мінімум 14 днів, в якості додаткового харчування, якщо ваш лікар не порекомендував вам інше.</p>
                    <p>Добова потреба в продукті індивідуальна та визначається з урахуванням віку, маси тіла та стану здоров'я.</p>
                    `,
                                ],
                                links: [
                                    "<strong>*</strong> A.L. Cawood,E.R. Walters,T.R. Smith, R.J. Stratton Systematic review and meta-analysis of the effects of high protein oral nutritional supplements. Clinical Nutrition.  Vol.37. 1. S305. 2018 (https://www.clinicalnutritionjournal.com/issue/S0261-5614(18)X0006-5)",
                                ],
                            },
                        ],
                    },
                    //4
                    {
                        titlePreviev:
                            "Нутрідрінк Компакт з харчовими волокнами",
                        titleSingle:
                            "Нутрідрінк Компакт з харчовими волокнами",
                        titleSingleEn: "Суміш рідка Nutridrink Compact Fibre",
                        image: ["4.1.png", "4.2.png", "4.3.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p><strong>Харчовий продукт для спеціальних медичних цілей:</strong><br> ентеральне харчування Нутрідрінк Компакт з харчовими волокнами  / Nutridrink Compact Fibre  – суміш рідка, готова до вживання, з високим вмістом енергії, повноцінна для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів від 3 років і старше та дорослих.</p>",
                                ],
                                list: [
                                    "• Високий вміст енергії (300 ккал на порцію 125 мл) у малому об’ємі. Вміст білка - 12 г на 125 мл.",
                                    "• Повноцінний продукт, може бути використаний в якості єдиного джерела харчування.",
                                    "• Містить пребіотики (галактоолігосахариди та фруктоолігосахариди – 1,9 г на 100 мл) для покращення функцій шлунково-кишкового тракту – нормалізують перистальтику кишківника (профілактика діареї), забезпечують пребіотичний ефект. Продукт підходить для пацієнтів, що не мають обмежень для прийому харчових волокон.",
                                    "• Продукт містить комплекс вітамінів B, C, Е, D та мікроелементів (хром, селен, мідь) – забезпечує антиоксидантний захист.",
                                    "• Основним джерелом білку в Нутрідрінк Компакт з харчовими волокнами є казеїн. Загальний вміст білку в Нутрідрінк Компакт з харчовими волокнами складає 11,87 г на порцію 125 мл (15,8% енергії). Це значно більше, ніж вміст білку в свіжому цільному молоці (4,4 г на порцію 125 мл). Білок в раціоні є джерелом незамінних амінокислот та забезпечує наявність азоту для синтезу інших амінокислот та важливих для організму  азотовмісних сполук. ",
                                    "• Містить комбінацію розчинних харчових волокон – 4,5 г на 125 мл. Вони забезпечують пребіотичний ефект, оскільки є поживним середовищем для нормальної мікрофлори кишківника, яка синтезує коротколанцюгові жирні кислоти (місцевий трофічний ефект – прискорення регенерації та загоєння слизової оболонки кишківника). Продукт підходить для пацієнтів, що не мають обмежень щодо прийому харчових волокон.",
                                    "• Безглютеновий продукт.",
                                    "• Запаковано в захисному середовищі. Продукт стерилізовано при ультрависокій температурі.",
                                    "• Доступні смаки: ваніль, полуниця, мокко.",
                                    "<strong>Переваги ентеральних сумішей, збагачених харчовими волокнами:</strong>",
                                    "• Нормалізація моторики шлунка і кишківника",
                                    "• Нормалізація процесів всмоктування поживних речовин",
                                    "• Поліпшення трофіки тонкої кишки",
                                    "• Стабілізація бар'єрної функції 'кишкової трубки'",
                                    "• Регенерація епітелію товстої кишки",
                                    "• Біфідогенний ефект-нормалізація флори товстої кишки",
                                    "• Зниження швидкості всмоктування глюкози",
                                ],


                                links: [
                                    '<strong>* </strong>відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href="https://www.espen.org/guidelines-home">https://www.espen.org/guidelines-home</a>',
                                    "MacBurney M.M., Russel C. and Young L.S. Formulas. In: Rombeau J.L. and Caldwell M.D. (eds). Clinical Nutrition. Enteral and Tube Feeding, 2nd ed. W.B. Saunders Co., Philadelphia, 1990, 149-173",
                                    "Heimburger DC, Young VR, Bistrian BR, Ettinger WH, Lipschitz DA, Rudman D. The role of protein in",
                                    "nutrition, with particular reference to the composition and use of enteral feeding formulas. J Parenter Enteral",
                                    "Nutr 1986; 10: 425-430.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування",
                                content: [
                                    "<p>• при мальнутриції (недостатності харчування): при станах, пов'язаних із втратою апетиту та/або відмовою від прийому їжі: анорексії, онкологічних захворюваннях, неврологічних захворюваннях, психічних розладах, хворобах печінки, серцево-легеневій недостатності, ВІЛ-інфекції на стадії СНІДу, в похилому віці.</p>",
                                    "<p>• у випадку захворювань шлунково-кишкового тракту (ШКТ): мукозитів, ентеритів різної етіології, зокрема спричинених променевою та хіміотерапією (холециститу, панкреатиту, фістул).</p>",
                                    "<p>• при наявності часткових перешкод для проходження їжі: пухлин та травм голови і шиї, порушення ковтання і жування (дисфагії), стриктур та обструкції різних відділів шлунково-кишкового тракту.</p>",
                                    "<p>• під час підготовки до операції, у післяопераційний період та в період реабілітації.</p>",
                                    "<p>• при підвищеній потреби в білку та енергії. У випадку муковісцидозу, синдрому короткої кишки .</p>",
                                ],
                                links: [
                                    '<strong>*</strong>відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки визначених лікарем. https://www.espen.org/guidelines-home',
                                    "Cawood A.L ea al. Ageing Research Reviews 11 (2012) 278– 296.",
                                    "Keele A. Bray M. Emery P. Silk D. Two phase randomised controlled clinical trial of postoperative oral dietary supplements in surgical patients. Gut. 1997 Vol. 40",
                                    "Smit, J. Mulder, N. Sleijfer, D. Bouman, J. Veeger, W. Schraffordt Koops, H. The effect of continuous enteral tube feeding on various nutritional parameters in patients with disseminated malignant melanoma during intensive chemotherapy. Clinical Nutrition. 1983 Vol. 1.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p><strong>Склад продукту зі смаком ванілі:</strong> вода, глюкозний сироп, білки з коров'ячого <strong>молока</strong>, рослинні олії (рапсова, соняшникова), харчові волокна (олігофруктоза, галактоолігосахариди (з коров'ячого <strong>молока</strong>), пектин, фруктоолігосахариди), трегалоза*, цитрат калію, емульгатор (<strong>соєвий лецитин</strong>), ароматизатор (ваніль), гідроортофосфат магнію, хлорид холіну, хлорид калію, цитрат натрію, L-аскорбат натрію, лактат заліза (II), сульфат цинку, нікотинамід, барвник (куркумін), ацетат DL-альфа-токоферолу, ретинілацетат, глюконат міді, селеніт натрію, сульфат марганцю (II), хлорид хрому (III), D-пантотенат кальцію, D-біотин, холекальциферол, гідрохлорид тіаміну, фолієва кислота, гідрохлорид піридоксину, молібдат натрію, фторид натрію, рибофлавін, йодид калію, фітоменадіон, ціанокобаламін. Без ГМО. Без глютену. *Трегалоза є джерелом глюкози.</p>",
                                    "<p><strong>Склад продукту зі смаком полуниці:</strong> вода, глюкозний сироп, білки з коров'ячого <strong>молока</strong>, рослинні олії (рапсова, соняшникова), харчові волокна (олігофруктоза, галактоолігосахариди (з коров'ячого <strong>молока</strong>), пектин, фруктоолігосахариди), трегалоза*, цитрат калію, емульгатор (<strong>соєвий лецитин</strong>), ароматизатор (полуниця), гідроортофосфат магнію, хлорид холіну, хлорид калію, барвник (кармінова кислота), цитрат натрію, L-аскорбат натрію, лактат заліза (II), сульфат цинку, нікотинамід, ацетат DL-альфа-токоферолу, ретинілацетат, глюконат міді, селеніт натрію, сульфат марганцю (II), хлорид хрому (III), D-пантотенат кальцію, D-біотин, холекальциферол, гідрохлорид тіаміну, фолієва кислота, гідрохлорид піридоксину, молібдат натрію, фторид натрію, рибофлавін, йодид калію, фітоменадіон, ціанокобаламін. Без ГМО. Без глютену. *Трегалоза є джерелом глюкози.</p>",
                                    "<p><strong>Склад продукту зі смаком мокко:</strong> вода, глюкозний сироп, білки з коров'ячого <strong>молока</strong>, рослинні олії (рапсова, соняшникова), харчові волокна (олігофруктоза, галактоолігосахариди (з коров'ячого <strong>молока</strong>), пектин, фруктоолігосахариди), трегалоза*, цитрат калію, емульгатор (<strong>соєвий лецитин</strong>), ароматизатор (мокко), гідроортофосфат магнію, хлорид холіну, хлорид калію, цитрат натрію, L-аскорбат натрію, барвник (цукровий колер IV), лактат заліза (II), сульфат цинку, нікотинамід, ацетат DL-альфа-токоферолу, ретинілацетат, глюконат міді, селеніт натрію, сульфат марганцю (II), хлорид хрому (III), D-пантотенат кальцію, D-біотин, холекальциферол, гідрохлорид тіаміну, фолієва кислота, гідрохлорид піридоксину, молібдат натрію, фторид натрію, рибофлавін, йодид калію, фітоменадіон, ціанокобаламін. Без ГМО. Без глютену. *Трегалоза є джерелом глюкози.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th>
                              Енергетична
                              цінність
                          </th>
                          <th>
                              кДж/<br>ккал
                          </th>
                          <th>
                              1005/240
                          </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Жири, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          10,4
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span>– насичені<span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>1,1</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Вуглеводи, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          25,2*
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – цукри</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>14,1</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – лактоза</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0,6</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Харчові волокна
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          3,6
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Білки
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          9,5
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Сіль
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0,21
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="3">Вітаміни</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Вітамін А
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          240
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін D
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          1,8
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін Е
                          </td>
                          <td>
                          мг <br>(α-TE)
                          </td>
                          <td>
                          3,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін К
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          13,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Тіамін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,40
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Рибофлавін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,40
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Ніацин (преформований)
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,2
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Ніацин (включаючи триптофан)
                          </td>
                          <td>
                          мг NE
                          </td>
                          <td>
                          4,3
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Пантотенова кислота
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          1,3
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В <sub>6</sub>
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,40
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фолієва кислота
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          64
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін В<sub>12</sub>
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          0,50
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Біотин
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          9,6
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вітамін С
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          24,0
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <th colspan="3">Мінеральні речовини</th>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Натрій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          83,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Калій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          229,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хлориди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          91,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Кальцій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          174,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фосфор
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          174,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фосфати
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          534
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Магній
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          33,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Залізо
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          3,8
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Цинк
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          2,9
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Мідь
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,43
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Марганець
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,80
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Фториди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          0,20
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Молібден
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          24,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Селен
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          14,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хром
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          16,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Йод
                          </td>
                          <td>
                          мкг
                          </td>
                          <td>
                          32,0
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="3">Інші</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Холін
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          88,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Осмолярність
                          </td>
                          <td>
                          мОсмоль/л
                          </td>
                          <td>
                          790,0
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Вода
                          </td>
                          <td>
                          мл
                          </td>
                          <td>
                          63,0
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                    ],
                                    links: [
                                        "<p>*25,3 г вуглеводів для продукту зі смаком мокко.</p>",
                                        "Містить галактоолігосахариди (ГОС) и фруктоолігосахариди (ФОС) – 1,9 g (г) на 100 ml (мл).",
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                    <strong>Важлива інформація: </strong><br>
                    Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Продукт може бути використаним в якості єдиного джерело харчування.Не використовувати для дітей віком до 3 років. З обережністю застосовувати для дітей віком від 3 до 6 років. Слід постійно контролювати споживання рідини для забезпечення адекватної гідратації. Не є лікарським засобом.
                    `,
                                ],
                                list: [
                                    "<strong> Протипоказання </strong> ",
                                    "•	Алергія на білки коров'ячого молока.",
                                    "•	Індивідуальна непереносимість компонентів.",
                                    "•	Галактоземія.",
                                    "•	Вік від 0 до 3 років.",
                                    "•  Не слід застосовувати пацієнтам, які потребують дієти без вмісту харчових волокон.",
                                ],
                                content2: [
                                    `
                  <p>
                  <strong>Форма випуску:</strong> <br>
                  Рідка суміш у пластиковий пляшечці, 4 пляшечки у картонній коробці об'ємом <br>
                  4х125 мл <strong>e</strong> (500 мл). <br>
                  </p>
                  `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                    <strong>Спосіб застосування.</strong> <br>
                    <p>Перед застосуванням добре збовтати. Продукт готовий до вживання, найкраще смакує охолодженим. Пити повільно маленькими ковтками протягом щонайменше 30 хвилин.</p>
                    <strong>Рекомендації щодо споживання*:</strong>
                    <p>1-3 пляшечки на добу в якості додаткового джерела харчування, 5-7 пляшечок на добу як єдине джерело харчування, якщо інше не призначено лікарем.</p>
                    <strong>Рекомендований строк споживання:</strong>
                    <p>строк споживання узгоджується з лікарем</p>
                    `,
                                ],
                                links: [
                                    "<strong>*</strong> A.L. Cawood,E.R. Walters,T.R. Smith, R.J. Stratton Systematic review and meta-analysis of the effects of high protein oral nutritional supplements. Clinical Nutrition.  Vol.37. 1. S305. 2018 (https://www.clinicalnutritionjournal.com/issue/S0261-5614(18)X0006-5)",
                                ],
                            },
                        ],
                    },
                    //10
                    {
                        titlePreviev: "Нутрідрінк Паудер ",
                        titleSingle: "Нутрідрінк Паудер ",
                        titleSingleEn: "Nutridrink Powder ",
                        image: ["10.png", "10.2.png", "10.3.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p><strong>Харчовий продукт для спеціальних медичних цілей:</strong><br> ентеральне харчування Нутрідрінк Паудер  / Nutridrink Powder  – суміш суха, з високим вмістом білка та енергії, повноцінна, збалансована вітамінами та мінералами для дієтичного харчування при мальнутриції (нутритивній недостатності) для дорослих.</p>",
                                ],
                                list: [
                                    "• Повноцінна, збалансована вітамінами та мінералами суміш.",
                                    "• В 200 мл готової суміші (8 мірних ложок) – 1 порція -  міститься 200 ккал, 10 г білка, 1,2 г харчових волокон.",
                                    "• Може бути використана в якості єдиного джерела харчування.",
                                    "• Високий вміст білка: 5 г на 100 мл готової суміші.",
                                    "• Низький вміст лактози (0,2 г на 100 мл готової суміші) -  полегшує травлення, знижує газоутворення в кишківнику у випадку наявності лактазної недостатності у пацієнта.",
                                    "• Модифікований склад білка: поєднання молочних (казеїн – 36%) та рослинних (64% соєвий) білків сприяє швидкому опорожненню шлунку та доброму засвоєнню.",
                                    "• Соєвий білок має позитивний вплив на обмін речовин у пацієнтів з порушеною толерантністю до глюкози, при гіперглікемії та цукровому діабеті.",
                                    "• Казеїн у складі Нутрідрінк Паудер (1,8 г на 100 мл) відіграє важливу роль в метаболізмі, формуванні імунної відповіді, має високу біологічну цінність 72-74%.",
                                    "(Казеїн має високу біологічну цінність 72-74% * і на 65% складається з незамінних амінокислот. Казеїн є джерелом глутаміну. Глутамін - умовно незамінна амінокислота, відіграє важливу роль у метаболізмі, використовується в якості «палива» для ентероцитів у шлунково-кишковому тракті, а також для лімфоцитів і макрофагів, які беруть участь у імунній відповіді.)",
                                    "• Містить пребіотики (галактоолігосахариди та фруктоолігосахариди – 1,06 г на 100 мл) для покращення функцій шлунково-кишкового тракту – нормалізують перистальтику кишківника (профілактика діареї), забезпечують пребіотичний ефект. Продукт підходить для пацієнтів, що не мають обмежень для прийому харчових волокон.",
                                    "• Продукт містить комплекс вітамінів B, C, Е, D та мікроелементів (хром, селен, мідь) – забезпечує антиоксидантний захист.",
                                    "• Не містить глютену.",
                                    "• Запаковано в захисному середовищі.",
                                    "• Доступні смаки: нейтральний, ваніль, полуниця.",
                                ],
                                links: [
                                    "<strong>* </strong>Відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                                    "<strong>1.</strong> MacBurney M.M., Russel C. and Young L.S. Formulas. In: Rombeau J.L. and Caldwell M.D. (eds). Clinical Nutrition. Enteral and Tube Feeding, 2nd ed. W.B. Saunders Co., Philadelphia, 1990, 149-173.",
                                    "<strong>2.</strong> International Society for the Study of Fatty Acids and Lipids (ISSFAL) Report of th sub-committee on recommendations for intake of polysaturated fatty acids in healthy adults. June 2004.",
                                    "<strong>3.</strong> Food and Agriculture Organization (FAO). Fats and fatty acids in human nutrition; report of an expert consultation. 10-14 November 2008; Geneva. FAO Food ans Nutrition Paper; 91.",
                                    "<strong>4.</strong> Kuyumcu S, Menne D, Curcic J, et al. Noncoagulating enteral formula can empty faster from the stomach: A double-blind, randomized crossover trial using magnetic resonance imaging. Journal of Parenteral and Enteral Nutrition. 2015; 39:544-551.",
                                    "<strong>5.</strong> Van den Braak CC, Klebach M, Abrahamse E, et al. A novel protein mixture containing vegetable proteins renders enteral nutrition products non-coagulating after in vitro gastric digestion. Clinical Nutrition. 2013; 32:765-771.",
                                    "<strong>6.</strong> Klebach M, Hofman Z, Bluemal S, et al. Effect of protein type in enteral nutrition formulas on coagulation in the stomach in vivo: Post hoc analyses of a randomized  controlled trial with MRI. Abstract presented  at Clinical Nutrition Week, January 16-19; Austin, Tx. Journal of Parenteral and Enteral Nutrition. 2016; 40:134(21).",
                                    "<strong>** </strong>MacBurney M.M., Russel C. and Young L.S. Formulas. In: Rombeau J.L. and Caldwell M.D. (eds). Clinical Nutrition. Enteral and Tube Feeding, 2nd ed. W.B. Saunders Co., Philadelphia, 1990, 149-173."
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування* ",
                                // content: [
                                //   "<p>Кубітан – це харчовий продукт для медичних цілей, призначений для харчової терапії. Він живить організм хворої людини, забезпечуючи його поживними речовинами . Правильне харчування допомагає організму відновити сили під час хвороби, покращити м’язову силу, якість життя та вирішити проблеми з харчуванням, пов’язані із хворобою.</p>",
                                //   "<p>Харчування має значення!</p>",
                                //   "<p>Кубітан багатий на білки та вітаміни А, С та Е, які рекомендується вживати людям з пролежнями та ранами, що важко загоюються. Адекватне харчування пацієнтів із ранами, що важко загоюються, а також пролежнями є важливим елементом ефективного догляду за пацієнтами.**</p>",
                                //   "<p>Крім того, Кубітан  підтримує лікування пацієнтів після променевої терапії. Збільшена кількість білка у поєднанні з аргініном зменшує прояв побічних дій після опромінення.** </p>",
                                // ],
                                list: [
                                    "<strong>Стани, що пов'язані із втратою апетиту та/або відмовою від прийому їжі:</strong>  ",
                                    "• онкологічних та неврологічних захворюваннях",
                                    "• психічних розладах",
                                    "• хворобах печінки",
                                    "• серцево-легеневій недостатності",
                                    "• ВІЧ-інфекції на стадії СНІДу",
                                    "• в похилому віці",
                                    "• при дисфагії та анорексії",
                                    "• при мальнутриції (недостатності харчування)",
                                    "• пацієнтам при підвищених потребах в білку та енергії",
                                ],
                                links: [
                                    "<strong>* </strong>в соответствии с общедоступными рекомендациями Европейской Ассоциации Парентерального и Энтерального питания (ESPEN), которые касаются подобных категорий продуктов и населения с дополнительными потребностями в нутритивной поддержке, определенных врачом. https://www.espen.org/guidelines-home",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p><strong>Склад продукту з нейтральним смаком:</strong> глюкозний сироп, білок із <strong>сої</strong>, рослинні олії (пальмова, соняшникова, рапсова), казеїнат (з коров’ячого <strong>молока</strong>), галактоолігосахариди (з коров'ячого <strong>молока</strong>), цитрат калію, карбонат кальцію, пектин, гідроортофосфат магнію, хлорид натрію, штучний ароматизатор (вершки), фруктоолігосахариди, емульгатор (<strong>соєвий</strong> лецитин), хлорид холіну, хлорид калію, L-аскорбінова кислота, L-аскорбат натрію, сульфат заліза (ІІ), сульфат цинку, нікотинамід, сульфат марганцю (II), ацетат DL-альфа токоферолу, D-пантотенат кальцію, сульфат міді (II), ретинілацетат, D-біотин, фолієва кислота, ціанокобаламін, гідрохлорид піридоксину, гідрохлорид тіаміну, рибофлавін, фторид натрію, ретинілпальмітат, DL-альфа-токоферол, холекальциферол, хлорид хрому (III), молібдат натрію, йодид калію, селеніт натрію, фітоменадіон. Без глютену. Без ГМО.</p>",
                                    "<p><strong>Склад продукту зі смаком ванілі:</strong> глюкозний сироп, білок із <strong>сої</strong>, рослинні олії (пальмова, соняшникова, рапсова), сахароза, казеїнат білка з коров’ячого <strong>молока</strong>, галактоолігосахариди (з коров'ячого <strong>молока</strong>), цитрат калію, карбонат кальцію, пектин, ароматизатор, гідроортофосфат магнію, хлорид натрію, ароматизатор, фруктоолігосахариди, емульгатор (<strong>соєвий</strong> лецитин), хлорид холіну, хлорид калію, L-аскорбінова кислота, L-аскорбат натрію, сульфат заліза (ІІ), сульфат цинку, нікотинамід, сульфат марганцю (II), ацетат DL-альфа-токоферолу, D-пантотенат кальцію, сульфат міді (II), ретинілацетат, D-біотин, фолієва кислота, ціанокобаламін, гідрохлорид піридоксину, гідрохлорид тіаміну, рибофлавін, фторид натрію, ретинілпальмітат, DL-альфа-токоферол, холекальциферол, хлорид хрому (III), молібдат натрію, йодид калію, селеніт натрію, фітоменадіон. Без глютену. Без ГМО.</p>",
                                    "<p><strong>Склад продукту зі смаком полуниці:</strong> глюкозний сироп, білок із <strong>сої</strong>, рослинні олії (пальмова, соняшникова, рапсова), сахароза, казеїнат білка з коров’ячого <strong>молока</strong>, галактоолігосахариди (з коров'ячого <strong>молока</strong>), цитрат калію, карбонат кальцію, пектин, барвник (червоний буряк), гідроортофосфат магнію, хлорид натрію, ароматизатори, фруктоолігосахариди, емульгатор (<strong>соєвий</strong> лецитин), хлорид холіну, хлорид калію, L-аскорбінова кислота, L-аскорбат натрію, сульфат заліза (ІІ), сульфат цинку, нікотинамід, сульфат марганцю (II), ацетат DL-альфа-токоферолу, D-пантотенат кальцію, сульфат міді (II), ретинілацетат, D-біотин, фолієва кислота, ціанокобаламін, гідрохлорид піридоксину, гідрохлорид тіаміну, рибофлавін, фторид натрію, ретинілпальмітат, DL-альфа-токоферол, холекальциферол, хлорид хрому (III), молібдат натрію, йодид калію, селеніт натрію, фітоменадіон. Без глютену. Без ГМО.</p>",
                                ],
                                tables: {
                                    title: null,
                                    list: [
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th colspan="2">Поживна цінність (для продукту з нейтральним смаком)</th>
                        <th>на 100 г</th>
                        <th style="border: 1px solid rgba(172, 152, 197, 0.3); border-right: none;">на 100 мл <br>
                        (23 г порошку)
                        </th>
                      </tr>
                      <tr>
                        <th>
                          Енергетична
                          цінність
                        </th>
                        <th>
                          кДж/<br>ккал
                        </th>
                        <th>
                          1830/435
                        </th>
                        <th style="border: 1px solid rgba(172, 152, 197, 0.3); border-right: none;">
                          420/100
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Жири, з них:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        14,4
                        </td>
                        <td>
                        3,3
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span>– насичені<span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>3,4</span>
                        </td>
                        <td>
                        <span>0,8</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span>– фосфоліпіди<span>
                        </td>
                        <td>
                        <span>мг</span>
                        </td>
                        <td>
                        <span>126</span>
                        </td>
                        <td>
                        <span>29</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Вуглеводи, з них:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                          53,4
                        </td>
                        <td>
                          12,3
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span> – цукри</span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>8,6</span>
                        </td>
                        <td>
                        <span>2,0</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span> – лактоза</span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>0,9</span>
                        </td>
                        <td>
                        <span>0,2</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Харчові волокна
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        2,6
                        </td>
                        <td>
                        0,6
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Білки, з них:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        21,8
                        </td>
                        <td>
                        5,0
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span> – казеїн</span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>7,8</span>
                        </td>
                        <td>
                        <span>1,8</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Білок із сої
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        14
                        </td>
                        <td>
                        3,2
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Сіль
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        0,79
                        </td>
                        <td>
                        0,18
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th colspan="4">Вітаміни</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Вітамін А
                        </td>
                        <td>
                        мкгRE
                        </td>
                        <td>
                        419
                        </td>
                        <td>
                        96
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін D3
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        6,5
                        </td>
                        <td>
                        1,5
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін Е
                        </td>
                        <td>мг <br>(α-TE)</td>
                        <td>
                        5,2
                        </td>
                        <td>
                        1,2
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін К
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        23
                        </td>
                        <td>
                        5,2
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Тіамін
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,58
                        </td>
                        <td>
                        0,13
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Рибофлавін
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,73
                        </td>
                        <td>
                        0,17
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Ніацин<br> <span>(преформований)</span>
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        4,2
                        </td>
                        <td>
                        0,97
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Ніацин <br><span>(включаючи триптофан)</span>
                        </td>
                        <td>
                        мг NE
                        </td>
                        <td>
                        9,0
                        </td>
                        <td>
                        2,1
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Пантотенова кислота
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        2,3
                        </td>
                        <td>
                        0,53
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін В<sub>6</sub>
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,73
                        </td>
                        <td>
                        0,17
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фолієва кислота
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        112
                        </td>
                        <td>
                        26
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін В<sub>12</sub>
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        1,2
                        </td>
                        <td>
                        0,27
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Біотин
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        12
                        </td>
                        <td>
                        2,7
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін С
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        44
                        </td>
                        <td>
                        10
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <th colspan="4">Мінеральні речовини</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Натрій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        314
                        </td>
                        <td>
                        72
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Калій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        693
                        </td>
                        <td>
                        159
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Хлориди
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        392
                        </td>
                        <td>
                        90
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Кальцій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        519
                        </td>
                        <td>
                        119
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фосфор
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        281
                        </td>
                        <td>
                        65
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Магній
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        74
                        </td>
                        <td>
                        17
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Залізо
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        7,0
                        </td>
                        <td>
                        1,6
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Цинк
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        5,2
                        </td>
                        <td>
                        1,2
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Мідь
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,8
                        </td>
                        <td>
                        0,2
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Марганець
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        1,3
                        </td>
                        <td>
                        0,30
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фториди
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,45
                        </td>
                        <td>
                        0,10
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Молібден
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        44
                        </td>
                        <td>
                        10
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Селен
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        26
                        </td>
                        <td>
                        6,0
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Хром
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        20
                        </td>
                        <td>
                        4,6
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Йод
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        56
                        </td>
                        <td>
                        13
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th colspan="4">Інші</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Холін
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        150
                        </td>
                        <td>
                        34
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Осмолярність
                        </td>
                        <td colspan="2">
                        мОсмоль/л
                        </td>
                        <td>
                        330
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Осмолярність
                        </td>
                        <td colspan="2">
                        мОсмоль/кг води
                        </td>
                        <td>
                        380
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                  <strong>Важлива інформація: </strong><br>
                  Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Може бути використане як єдине джерело харчування. Підходить тільки для дорослих. <strong>Не є лікарським засобом.</strong>
                  `,
                                ],
                                // list: [
                                //   "<strong> Протипоказання </strong> ",
                                //   "•	Алергія на білки коров'ячого молока.",
                                //   "•	Індивідуальна непереносимість компонентів.",
                                //   "•	Галактоземія.",
                                //   "•	Вік від 0 до 3 років.",
                                // ],
                                content2: [
                                    `
                  <p>
                  <strong>Форма випуску:</strong> <br>
                  Порошкоподібна суміш в металевій банці масою 335 г <strong>e</strong>.
                  </p>
                `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                  <strong> Спосіб застосування: </strong>
                  <p>•	Використовуйте тільки мірну ложечку, що входить до пакування. Кожна мірна ложка  Нутрідрінк Паудер  містить 5,7 г порошку. </p>
                  <p>•	Перед застосуванням ретельно вимийте руки, використовуйте чистий або стерильний посуд.</p>
                  <p>•	Переконайтесь, що верхня частина пакування чиста.</p>
                  <p>•	Додайте до готової страви (наприклад, до супу або пюре) до 8 мірних ложок Нутрідрінк Паудер , ретельно перемішайте.</p>
                  <p>•	Продукт також можна розчинити в молоці або інших напоях – теплих або холодних.</p>
                  <p>•	Змішайте 150 мл рідини з 8 мірними ложками порошку та ретельно перемішайте до його повного розчинення.</p>
                  <p>•	Додайте необхідну кількість рідини, щоб довести порцію до об’єму 200 мл.</p>
                  <p>•	Готову суміш використати протягом 2 годин.</p>
                  <p>•	Завжди викидайте залишки невикористаної суміші.</p>
                  `,
                                ],
                            },
                        ],
                    },
                    //1
                    {
                        titlePreviev: "Кубітан",
                        titleSingle: "Кубітан",
                        titleSingleEn: "Cubitan",
                        image: ["1.png", "1.2.png", "1.3.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p><strong>Харчовий продукт для спеціальних медичних цілей:</strong><br> ентеральне харчування Кубітан / Cubitan – суміш рідка, готова до вживання, з високим вмістом білка та енергії, містить аргінін і відповідні вітаміни та мікроелементи. Для дієтичного харчування пацієнтів з хронічними ранами від 3 років і старше та дорослих.</p>",
                                    "<p>Кубітан призначено для дієтотерапії дорослих пацієнтів і дітей від 3 років з опіками, синдромом діабетичної стопи, трофічними виразками, великими ранами, важкими травмами, а також для пацієнтів хірургічного профілю, з додатковою потребою у загоєнні ран. Рідка, готова до вживання суміш з високим вмістом білка та енергії, містить доданий аргінін і відповідні вітаміни та мікроелементи для кращого загоєння ран.</p>",
                                ],
                                list: [
                                    "• Високий вміст білка, що позитивно впливає на процес одужання пацієнтів з інсультом, синдромом діабетичної стопи, а також на процес загоєння ран, включаючи пролежні.",
                                    "• Містить аргінін – важливий імунокомпонент, що регулює імунні функції організму та прискорює процес загоєння ран, зокрема пролежнів.",
                                    "• Містить інгредієнти, важливі для процесу загоєння ран (каротиноїди, вітаміни С та Е, цинк).",
                                    "• Низький вміст насичених жирів.",
                                    "• Містить здебільшого LCT жири (довголанцюгові тригліцериди).",
                                    "• Низький глікемічний індекс, що дорівнює 34.",
                                    "• Безглютеновий продукт.",
                                    "• Запаковано в захисному середовищі. Ультрапастеризований продукт.",
                                ],
                                links: [
                                    "<strong>* </strong>Згідно з науковими дослідженнями та рекомендаціями для дієтичного харчування пацієнтів з хронічними ранами, цей перелік не є вичерпним:",
                                    "<strong>1.</strong> Cereda et al. A nutritional formula enriched with arginine, zinc, and antioxidants for the healing of pressure ulcers: a randomized trial, Annals of Internal Medicine, 2015; 162:167-174.",
                                    "<strong>2.</strong> Aquilani et al., Effect of calorie-protein supplementation on the cognitive recovery of patients with subacute stroke, NutritionalNeuroscience 2008 Vol. 11: 235-240.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування* ",
                                content: [
                                    "<p>Кубітан – це харчовий продукт для медичних цілей, призначений для харчової терапії. Він живить організм хворої людини, забезпечуючи його поживними речовинами. Правильне харчування допомагає організму відновити сили під час хвороби, покращити м’язову силу, якість життя та вирішити проблеми з харчуванням, пов’язані із хворобою.</p>",
                                    "<p>Харчування має значення!</p>",
                                    "<p>Кубітан багатий на білки та вітаміни А, С та Е, які рекомендується вживати людям з пролежнями та ранами, що важко загоюються. Адекватне харчування пацієнтів із ранами, що важко загоюються, а також пролежнями є важливим елементом ефективного догляду за пацієнтами.**</p>",
                                    "<p>Крім того, Кубітан  підтримує лікування пацієнтів після променевої терапії. Збільшена кількість білка у поєднанні з аргініном зменшує прояв побічних дій після опромінення.** </p>",
                                ],
                                list: [
                                    "<strong>Стани, що пов'язані із втратою апетиту та/або відмовою від прийому їжі, особливо:</strong>  ",
                                    "• лежачі хворі з пролежнями",
                                    "• з порушеннями загоєння ран",
                                    "• після інсульту в хронічній фазі та під час одужання",
                                    "• пацієнти з синдромом діабетичної стопи",
                                    "• після операції та в період реабілітації",
                                    "• з підвищеною потребою в білку та енергії",
                                    "• у випадку бульозного епідермолізу",
                                    "• за нутритивної недостатності (мальнутриції)",
                                ],
                                links: [
                                    "<strong>* </strong>згідно з науковими дослідженнями та рекомендаціями для дієтичного харчування пацієнтів з хронічними ранами, цей перелік не є вичерпним:",
                                    "<strong>1.</strong> Cereda et al. A nutritional formula enriched with arginine, zinc, and antioxidants for the healing of pressure ulcers: a randomized trial, Annals of Internal Medicine, 2015; 162:167-174.",
                                    "<strong>2.</strong> Aquilani et al., Effect of calorie-protein supplementation on the cognitive recovery of patients with subacute stroke, NutritionalNeuroscience 2008 Vol. 11: 235-240.",
                                    "** Shukla J1, Chatterjee S, Thakur VS, Premachandran S, Checker R, Poduval TB. L-Arginine reverses radiation-induced immune dysfunction: the need for optimum treatment window. Radiat Res. 2009 Feb;171(2):180-7. doi: 10.1667/RR1241.1.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p><strong>Склад для продукту зі смаком полуниці: молочний</strong> білок (з коров'ячого <strong>молока</strong>), вода, мальтодекстрин, цукор, рослинні олії (рапсова олія, соняшникова олія), L-аргінін, регулятор кислотності (лимонна кислота), L-аскорбат натрію, каротиноїди (містить <strong>сою</strong>) (β-каротин, екстракт лікопену з томатів, лютеїн), гідроортофосфат магнію, барвник (кармінова кислота), ароматизатор (полуниця), емульгатор (<strong>соєвий лецитин</strong>), хлорид холіну, гідроортофосфат калію, DL-альфа-токоферол, хлорид калію, цитрат калію, гідроксид магнію, лактат заліза (II), сульфат цинку, гідроксид калію, глюконат міді, сульфат марганцю (II), хлорид натрію, нікотинамід, D-пантотенат кальцію, гідрохлорид піридоксину, рибофлавін, гідрохлорид тіаміну, фторид натрію, ретинілацетат, фолієва кислота, селеніт натрію, хлорид хрому (III), молібдат натрію, йодид калію, фітоменадіон, D-біотин, холекальциферол, ціанокобаламін. Без ГМО. Без глютену.</p>",
                                    "<p><strong>Склад для продукту зі смаком ванілі: молочний</strong> білок (з коров'ячого <strong>молока</strong>), вода, мальтодекстрин, цукор, рослинні олії (рапсова олія, соняшникова олія), L-аргінін, регулятор кислотності (лимонна кислота), ароматизатор (ваніль), L-аскорбат натрію, каротиноїди (містить <strong>сою</strong>) (β-каротин, екстракт лікопену із томатів, лютеїн), гідроортофосфат магнію, емульгатор (<strong>соєвий лецитин</strong>), хлорид холіну, гідроортофосфат калію, DL-альфа-токоферол, хлорид калію, цитрат калію, гідроксид магнію, лактат заліза(II), сульфат цинку, гідроксид калію, глюконат міді, сульфат марганцю(II), хлорид натрію, нікотинамід, D-пантотенат кальцію, гідрохлорид піридоксину, рибофлавін, гідрохлорид тіаміну, фторид натрію, ретинілацетат, фолієва кислота, селеніт натрію, хлорид хрому(III), молібдат натрію, йодид калію, фітоменадіон, D-біотин, холекальциферол, ціанокобаламін. Без ГМО. Без глютену.</p>",
                                    "<p><strong>Склад для продукту зі смаком шоколаду: молочний</strong> білок (з коров'ячого <strong>молока</strong>), вода, мальтодекстрин, цукор, рослинні олії (рапсова олія, соняшникова олія), L-аргінін, какао порошок, регулятор кислотності (лимонна кислота), L-аскорбат натрію, каротиноїди (містить <strong>сою</strong>) (β-каротин, екстракт лікопену із томатів, лютеїн), гідроортофосфат магнію, ароматизатор (ваніль), емульгатор (<strong>соєвий лецитин</strong>), хлорид холіну, DL-альфа-токоферол, хлорид калію, цитрат калію, фосфат кальцію, лактат заліза (II), стабілізатор (каррагінан), сульфат цинку, хлорид натрію, глюконат міді, сульфат марганцю (II), нікотинамід, D-пантотенат кальцію, гідрохлорид піридоксину, рибофлавін, гідрохлорид тіаміну, фторид натрію, ретинілацетат, фолієва кислота, хлорид хрому (III), селеніт натрію, молібдат натрію, йодид калію, фітоменадіон, D-біотин, холекальциферол, ціанокобаламін. Без ГМО. Без глютену.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th>
                          Енергетична
                          цінність
                        </th>
                        <th>
                          кДж/<br>ккал
                        </th>
                        <th>
                          520/124
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Жири, з них:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        3,5
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span>– насичені<span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>0,5</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Вуглеводи, з них:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        14,5
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span> – цукри</span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span> 7,1</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span> – лактоза</span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>1,7</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Харчові волокна
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        <0,5
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Білки:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        8,8
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span> – L-аргінін </span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>1,51</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Сіль
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        0,13
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th colspan="3">Вітаміни</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Вітамін А
                        </td>
                        <td>
                        мкгRE
                        </td>
                        <td>
                        119
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін D
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        1,3
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін Е
                        </td>
                        <td>мг <br>(α-TE)</td>
                        <td>
                        19
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін К
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        10
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Тіамін
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,28
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Рибофлавін
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,63
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Ніацин<br> <span>(преформований)</span>
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        1,5
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Ніацин <br><span>(включаючи триптофан)</span>
                        </td>
                        <td>
                        мг NE
                        </td>
                        <td>
                        3,4
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Пантотенова кислота
                        </td>
                        <td>
                        м
                        </td>
                        <td>
                        1,0
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін В <sub>6</sub>
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,65
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фолієва кислота
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        100
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін В<sub>12</sub>
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        0,79
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Біотин
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        7,5
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін С
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        125
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <th colspan="3">Мінеральні речовини</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Натрій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        50
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Калій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        150
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Хлориди
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        80
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Кальцій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        225
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фосфор
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        182
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Магній
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        42
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Залізо
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        3,0
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Цинк
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        4,5
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Мідь
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,68
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Марганець
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        1,3
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фториди
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,19
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Молібден
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        19
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Селен
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        32
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Хром
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        18
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Йод
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        25
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th colspan="3">Інші</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Каротиноїди
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,75
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Холін
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        69
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Осмолярність
                        </td>
                        <td>
                        мОсмоль/л
                        </td>
                        <td>
                        490
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вода
                        </td>
                        <td>
                        мл
                        </td>
                        <td>
                        80
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                  <strong>Важлива інформація: </strong><br>
                  Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Не може бути використане як єдине джерело харчування. Не використовувати для дітей віком до 3 років. З обережністю застосовувати для дітей та підлітків віком від 3 до 17 років. Не рекомендується для застосування критично хворим пацієнтам. Не є лікарським засобом.
                  `,
                                ],
                                list: [
                                    "<strong> Протипоказання </strong> ",
                                    "•	Алергія на білки коров'ячого молока.",
                                    "•	Індивідуальна непереносимість компонентів.",
                                    "•	Галактоземія.",
                                    "•	Вік від 0 до 3 років.",
                                ],
                                content2: [
                                    `
                  <p>
                  <strong>Форма випуску:</strong> <br>
                  Рідка суміш у пластиковий пляшечці, 4 пляшечки у картонній коробці об'ємом <br>
                  4х200 мл <strong>e</strong> (800 мл).
                  </p>
                `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                  <strong> Спосіб застосування. </strong>
                  <p>Перед застосуванням добре збовтати. </p>
                  <p>Готовий до вживання, найкраще смакує охолодженим.</p>
                  <p>Кубітан необхідно пити повільно через його високу осмолярність і пов’язаний з нею ризик виникнення діареї, особливо під час першого застосування: 1 пляшечку протягом щонайменше 30 хвилин маленькими ковтками.</p>
                  <strong>Рекомендований строк споживання*:</strong>
                  <p>Найчастіше рекомендовано споживати 1-3 пляшечки (248 - 744 ккал) Кубітана на день протягом 14 днів чи більше, якщо ваш лікар не порекомендував вам інше.</p>
                  `,
                                ],
                                links: [
                                    '<p>* A.L. Cawood,E.R. Walters,T.R. Smith, R.J. Stratton Systematic review and meta-analysis of the effects of high protein oral nutritional supplements. Clinical Nutrition. Vol.37.  1. S305. 2018</p>'
                                ]
                            },
                        ],
                    },
                    // 12
                    {
                        titlePreviev: "Діасіп зі смаком ванілі",
                        titleSingle: "Діасіп зі смаком ванілі",
                        titleSingleEn: "Diasip Vanilla flavour",
                        image: ["22.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p><strong>Харчовий продукт для спеціальних медичних цілей:</strong><br><br> ентеральне харчування Діасіп зі смаком ванілі / Diasip Vanilla flavour – для дієтичного харчування при мальнутриції (нутритивній недостатності) пацієнтів від 3 років і старше та дорослих, хворих на цукровий діабет та гіперглікемію. Продукт містить харчові волокна, цукри та підсолоджувачі.</p>",
                                ],
                                list: [
                                    "• Готова до вживання рідка суміш з високим вмістом мононенасичених жирних кислот, зменшеною кількістю вуглеводів, збагачена харчовими волокнами та антиоксидантами.",
                                    "• Цей продукт спеціально розроблений для дієтичного харчування хворих на цукровий діабет та пацієнтів з порушенням толерантності до глюкози.",
                                    "• Має низький глікемічний індекс – 35.",
                                    "• Повноцінний продукт, може бути використаний як єдине джерело харчування пацієнтів від 3 років.",
                                    "• Діасіп має спеціальний склад білка: поєднання сироваткового (49%) та рослинного (51% соєвого) білків сприяє контролю глюкози в крові, жирів та нутритивного статусу пацієнтів.",
                                    "• Соєвий білок має позитивний вплив на обмін речовин у пацієнтів з порушеною толерантністю до глюкози, при гіперглікемії та цукровому діабеті, впливає на всмоктування глюкози1, знижує рівень холестерину2, а також сприяє зниженню артеріального тиску<sup>3</sup>.",
                                    "• Продукт містить комбінацію розчинних і нерозчинних харчових волокон. Вони забезпечують пребіотичний ефект, оскільки є поживним середовищем для нормальної мікрофлори кишківника, яка синтезує коротколанцюгові жирні кислоти (місцевий трофічний ефект – прискорення регенерації та загоєння слизової оболонки кишківника)<sup>4</sup>. Продукт підходить для пацієнтів, що не мають обмежень щодо прийому харчових волокон.",
                                    "• Діасіп містить комплекс вітамінів B, C, Е, D та мікроелементів (хром, селен, мідь) – забезпечує антиоксидантний захист<sup>5,6,7</sup>.",
                                    "• Містить цукри та підсолоджувачі. Згідно рекомендацій Групи з вивчення діабету та харчування (DNSG – Diabetes Nutrition Study Group of the European Association for the Study of Diabetes (EASD)) Європейської асоціації з вивчення діабету (EASD) споживання вуглеводів у хворих на діабет має складати 45-60% від загальної енергії.",
                                    "• Містить Хром (Сr) та Селен (Se) в кількостях, рекомендованих для пацієнтів з цукровим діабетом (Хром позитивно впливає на рівень глюкози, інсуліну та холестерину у хворих із діабетом 2го типу)<sup>8,9</sup>.",
                                    "• Запаковано в захисному середовищі.",
                                    "• Не містить ГМО та глютену.",
                                ],

                                links: [
                                    "<strong>1.</strong> C. Lavigne, A. Marette and H. Jacques. Cod and soy proteins compared with casein improve glucose tolerance and insulin sensitivity in rats. Am J Physiol Endocrinol Metab. 2000;278:E491-500.",
                                    "<strong>2.</strong> L. Azadbakht, R. Shakerhosseini, S. Atabak, et al. Beneficiary effect of dietary soy protein on lowering plasma levels of lipid and improving kidney function in type II diabetes with nephropathy. Eur J Clin Nutr. 2003;57:1292-4.",
                                    "<strong>3.</strong> H. J. Teede, F. S. Dalais, D. Kotsopoulos, et al. Dietary soy has both beneficial and potentially adverse cardiovascular effects: a placebo-controlled study in men and postmenopausal women. 2001;86:3053-60.",
                                    "<strong>4.</strong> Green CJ. Fibre in enteral nutrition. Clin Nutr 2001; 20 (Suppl.): 23-39.",
                                    "<strong>5.</strong> R. Valdés-Ramos, G.-L. Ana Laura, M.-C. Beatriz Elina, et al. Vitamins and type 2 diabetes mellitus. 2015;15:54-63.",
                                    "<strong>6.</strong> R. Avena, S. Arora, B. J. Carmody, et al. Thiamine (Vitamin B1) protects against glucose- and insulin-mediated proliferation of human infragenicular arterial smooth muscle cells. Ann Vasc Surg. 2000;14:37-43.",
                                    "<strong>7.</strong> M. M. Alam, S. Iqbal, I. J. A. o. b. Naseem, et al. Ameliorative effect of riboflavin on hyperglycemia, oxidative stress and DNA damage in type-2 diabetic mice: Mechanistic and therapeutic strategies. 2015;584:10-19.",
                                    "<strong>8.</strong> K. Rajendran, S. Manikandan, L. D. Nair, et al. Serum chromium levels in type 2 diabetic patients and its association with glycaemic control. 2015;9:OC05.",
                                    "<strong>9.</strong> EFSA NDA Panel (EFSA Panel on Dietetic Products Nutrition and Allergies). Scientific Opinion on Dietary Reference Values for selenium. 2014. Report No.: 1831-4732 Contract No.: 11.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування* ",
                                content: [
                                    "<p>Діасіп призначається пацієнтам, хворим на цукровий діабет та гіперглікемію з функціонуючим шлунково-кишковим трактом, які не можуть або не бажають їсти достатню кількість звичайних продуктів для задоволення своїх щоденних потреб і яким потрібно контролювати рівень глюкози в крові. </p>",
                                ],
                                // list: [],
                                // links: [],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>вода, ізомальтулоза*, харчові волокна (галактоолігосахариди (з коров'ячого <strong>молока</strong>), стійкий декстрин, целюлоза), рослинні олії (рапсова, соняшникова), крохмаль, лактоза (з коров'ячого <strong>молока</strong>), білки з коров'ячого <strong>молока</strong>, ізолят <strong>соєвого</strong> білка, ароматизатор, регулятор кислотності (лимонна кислота, гідроксид калію), барвник (кармін), <strong>риб’ячий</strong> жир, цитрат калію, хлорид холіну, гідроксид магнію, гідроортофосфат калію, фосфат кальцію, хлорид кальцію, цитрат натрію, L-аскорбат натрію, підсолоджувач (ацесульфам К, сахарин натрію), лактат заліза (II), карбонат кальцію, сульфат цинку, ацетат DL-альфа-токоферолу, каротиноїди (містять сою) (β-каротин, лютеїн, живиця лікопену із томатів), глюконат міді, D-пантотенат кальцію, хлорид хрому (III), сульфат марганцю (II), селеніт натрію, гідрохлорид тіаміну, гідрохлорид піридоксину, рибофлавін, нікотинамід, молібдат натрію, фторид натрію, ретинілацетат, фолієва кислота, йодид калію, D-біотин, фітоменадіон, холекальциферол, ціанокобаламін. Без ГМО. Без глютену.*Ізомальтулоза є носієм глюкози та фруктози.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th>
                          Енергетична
                          цінність
                        </th>
                        <th>
                          кДж/<br>ккал
                        </th>
                        <th>
                          438/104
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Жири, з них:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                          3,8
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span>– насичені<span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>0,44</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Вуглеводи, з них:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        11,5
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span> – цукри</span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>8,4</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span> – лактоза</span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>3,54</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Харчові волокна
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        2,5
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Білки:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        4,9
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Сіль
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        0,13
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th colspan="3">Вітаміни</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Вітамін А
                        </td>
                        <td>
                        мкгRE
                        </td>
                        <td>
                        79,1
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін D
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        1,29
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін Е
                        </td>
                        <td>мг <br>(α-TE)</td>
                        <td>
                        2,50
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Альфа-токоферол
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        3,08
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін К
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        5,52
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Тіамін
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,40
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Рибофлавін
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,26
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Ніацин<br> <span>(преформований)</span>
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,23
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Ніацин <br><span>(включаючи триптофан)</span>
                        </td>
                        <td>
                        мг NE
                        </td>
                        <td>
                        1,90
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Пантотенова кислота
                        </td>
                        <td>
                        м
                        </td>
                        <td>
                        0,91
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін В <sub>6</sub>
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,34
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фолієва кислота
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        38,0
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін В<sub>12</sub>
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        0,55
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Біотин
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        6,38
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін С
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        15,0
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <th colspan="3">Мінеральні речовини</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Натрій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        50,1
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Калій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        99,6
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Хлориди
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        42,8
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Кальцій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        53,5
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фосфор
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        49,6
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фосфати
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        152
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Магній
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        22,2
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Залізо
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        1,65
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Цинк
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        1,27
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Мідь
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,20
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Марганець
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,33
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фториди
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,10
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Молібден
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        10,0
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Селен
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        7,50
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Хром
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        12,0
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Йод
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        15,7
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th colspan="3">Інші</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Каротиноїди
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,16
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Холін
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        49,8
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Осмолярність
                        </td>
                        <td>
                        мОсмоль/л
                        </td>
                        <td>
                        365
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вода
                        </td>
                        <td>
                        мл
                        </td>
                        <td>
                        83
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                  <strong>Важлива інформація: </strong><br>
                  Тільки для ентерального застосування!<br>
                  Не застосовувати парентерально!</br>
                  <strong>Застосовувати тільки під наглядом лікаря!</strong></br>
                  Може бути використане як єдине джерело харчування.<br>
                  Не використовувати для дітей віком до 3 років.<br>
                  З обережністю застосовувати для дітей віком від 3 до 6 років.<br>
                  Не використовувати хворим на фруктоземію.<br>
                  Не є лікарським засобом.<br>
                  `,
                                ],
                                list: [
                                    "<strong> Протипоказання </strong> ",
                                    "•	Алергія до білків коров’ячого молока, галактоземія, фруктоземія. ",
                                    "•	Індивідуальна непереносимість компонентів.",
                                    "•	Вік від 0 до 3 років.",
                                    "•	Діасіп містить лактозу (3,54 g (г) / 100 ml (мл)). Не рекомендується пацієнтам з непереносимістю лактози.",
                                    "•  Не слід застосовувати пацієнтам, які потребують дієти без вмісту харчових волокон.",
                                ],
                                content2: [
                                    `
                  <p>
                  <strong>Форма випуску:</strong> <br>
                  Рідка суміш у пластиковий пляшечці <br>
                  200 мл <strong>e</strong>.
                  </p>
                `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                  <p><strong> Спосіб застосування. </strong>
                  <p>Перед застосуванням добре збовтати. Продукт готовий до вживання, найкраще смакує охолодженим.</p>
                  <p>Пити повільно маленькими ковтками протягом щонайменше 30 хвилин.</p></p><br>
                  <p><strong>Дозування:</strong>
                  <p>1-3 пляшечки на добу в якості додаткового джерела харчування, 7-10 пляшечок на добу як єдине джерело харчування, якщо інше не призначено лікарем.</p></p>
                  `,
                                ],
                                links: []
                            },
                        ],
                    },
                    // 12
                    {
                        titlePreviev: "Діасіп зі смаком полуниці",
                        titleSingle: "Діасіп зі смаком полуниці",
                        titleSingleEn: "Diasip Strawberry flavour",
                        image: ["21.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики",
                                content: [
                                    "<p><strong>Харчовий продукт для спеціальних медичних цілей:</strong></p>",
                                    "<p>ентеральне харчування Діасіп зі смаком полуниці / Diasip Strawberry flavour – для дієтичного харчування при мальнутриції (нутритивній недостатності) пацієнтів від 3 років і старше та дорослих, хворих на цукровий діабет та гіперглікемію. Продукт містить харчові волокна, цукри та підсолоджувачі.</p>"
                                ],
                                list: [
                                    "• Готова до вживання рідка суміш з високим вмістом мононенасичених жирних кислот, зменшеною кількістю вуглеводів, збагачена харчовими волокнами та антиоксидантами.",
                                    "• Цей продукт спеціально розроблений для дієтичного харчування хворих на цукровий діабет та пацієнтів з порушенням толерантності до глюкози.",
                                    "• Має низький глікемічний індекс – 35.",
                                    "• Повноцінний продукт, може бути використаний як єдине джерело харчування пацієнтів від 3 років.",
                                    "• Діасіп має спеціальний склад білка: поєднання сироваткового (49%) та рослинного (51% соєвого) білків сприяє контролю глюкози в крові, жирів та нутритивного статусу пацієнтів.",
                                    "• Соєвий білок має позитивний вплив на обмін речовин у пацієнтів з порушеною толерантністю до глюкози, при гіперглікемії та цукровому діабеті, впливає на всмоктування глюкози<sup>1</sup>, знижує рівень холестерину<sup>2</sup>, а також сприяє зниженню артеріального тиску<sup>3</sup>.",
                                    "• Продукт містить комбінацію розчинних і нерозчинних харчових волокон. Вони забезпечують пребіотичний ефект, оскільки є поживним середовищем для нормальної мікрофлори кишківника, яка синтезує коротколанцюгові жирні кислоти (місцевий трофічний ефект – прискорення регенерації та загоєння слизової оболонки кишківника)<sup>4</sup>. Продукт підходить для пацієнтів, що не мають обмежень щодо прийому харчових волокон.",
                                    "• Діасіп містить комплекс вітамінів B, C, Е, D та мікроелементів (хром, селен, мідь) – забезпечує антиоксидантний захист<sup>5,6,7</sup>.",
                                    "• Містить цукри та підсолоджувачі. Згідно рекомендацій Групи з вивчення діабету та харчування (DNSG – Diabetes Nutrition Study Group of the European Association for the Study of Diabetes (EASD)) Європейської асоціації з вивчення діабету (EASD) споживання вуглеводів у хворих на діабет має складати <nobr>45-60%</nobr> від загальної енергії.",
                                    "• Містить Хром (Сr) та Селен (Se) в кількостях, рекомендованих для пацієнтів з цукровим діабетом (Хром позитивно впливає на рівень глюкози, інсуліну та холестерину у хворих із діабетом 2го типу)<sup>8,9</sup>.",
                                    "• Запаковано в захисному середовищі.",
                                    "• Не містить ГМО та глютену.",
                                ],

                                links: [
                                    "<strong>1.</strong> C. Lavigne, A. Marette and H. Jacques. Cod and soy proteins compared with casein improve glucose tolerance and insulin sensitivity in rats. Am J Physiol Endocrinol Metab. 2000;278:E491-500.",
                                    "<strong>2.</strong> L. Azadbakht, R. Shakerhosseini, S. Atabak, et al. Beneficiary effect of dietary soy protein on lowering plasma levels of lipid and improving kidney function in type II diabetes with nephropathy. Eur J Clin Nutr. 2003;57:1292-4.",
                                    "<strong>3.</strong> H. J. Teede, F. S. Dalais, D. Kotsopoulos, et al. Dietary soy has both beneficial and potentially adverse cardiovascular effects: a placebo-controlled study in men and postmenopausal women. 2001;86:3053-60.",
                                    "<strong>4.</strong> Green CJ. Fibre in enteral nutrition. Clin Nutr 2001; 20 (Suppl.): 23-39.",
                                    "<strong>5.</strong> R. Valdés-Ramos, G.-L. Ana Laura, M.-C. Beatriz Elina, et al. Vitamins and type 2 diabetes mellitus. 2015;15:54-63.",
                                    "<strong>6.</strong> R. Avena, S. Arora, B. J. Carmody, et al. Thiamine (Vitamin B1) protects against glucose- and insulin-mediated proliferation of human infragenicular arterial smooth muscle cells. Ann Vasc Surg. 2000;14:37-43.",
                                    "<strong>7.</strong> M. M. Alam, S. Iqbal, I. J. A. o. b. Naseem, et al. Ameliorative effect of riboflavin on hyperglycemia, oxidative stress and DNA damage in type-2 diabetic mice: Mechanistic and therapeutic strategies. 2015;584:10-19.",
                                    "<strong>8.</strong> K. Rajendran, S. Manikandan, L. D. Nair, et al. Serum chromium levels in type 2 diabetic patients and its association with glycaemic control. 2015;9:OC05.",
                                    "<strong>9.</strong> EFSA NDA Panel (EFSA Panel on Dietetic Products Nutrition and Allergies). Scientific Opinion on Dietary Reference Values for selenium. 2014. Report No.: 1831-4732 Contract No.: 11.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування",
                                content: [
                                    "<p>Діасіп призначається пацієнтам, хворим на цукровий діабет та гіперглікемію з функціонуючим шлунково-кишковим трактом, які не можуть або не бажають їсти достатню кількість звичайних продуктів для задоволення своїх щоденних потреб і яким потрібно контролювати рівень глюкози в крові. </p>",
                                ],
                                // list: [],
                                // links: [],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Bода, ізомальтулоза*, харчові волокна (галактоолігосахариди (з коров'ячого <strong>молока</strong>), стійкий декстрин, целюлоза), рослинні олії (рапсова, соняшникова), крохмаль, лактоза (з коров'ячого <strong>молока</strong>), білки з коров'ячого <strong>молока</strong>, ізолят <strong>соєвого</strong> білка, ароматизатор, регулятор кислотності (лимонна кислота, гідроксид калію), барвник (кармін), <strong>риб’ячий</strong> жир, цитрат калію, хлорид холіну, гідроксид магнію, гідроортофосфат калію, фосфат кальцію, хлорид кальцію, цитрат натрію, L-аскорбат натрію, підсолоджувач (ацесульфам К, сахарин натрію), лактат заліза (II), карбонат кальцію, сульфат цинку, ацетат DL-альфа-токоферолу, каротиноїди (містять <strong>сою</strong>) (β-каротин, лютеїн, живиця лікопену із томатів), глюконат міді, D-пантотенат кальцію, хлорид хрому (III), сульфат марганцю (II), селеніт натрію, гідрохлорид тіаміну, гідрохлорид піридоксину, рибофлавін, нікотинамід, молібдат натрію, фторид натрію, ретинілацетат, фолієва кислота, йодид калію, D-біотин, фітоменадіон, холекальциферол, ціанокобаламін. Без ГМО. Без глютену.</p>",
                                ],
                                links: [
                                    "<p><strong>*</strong> Ізомальтулоза є носієм глюкози та фруктози.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th>
                          Енергетична
                          цінність
                        </th>
                        <th>
                          кДж/<br>ккал
                        </th>
                        <th>
                          438/104
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Жири, з них:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                          3,8
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span>– насичені<span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>0,44</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Вуглеводи, з них:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        11,5
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span> – цукри</span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>8,4</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span> – лактоза</span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>3,54</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Харчові волокна
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        2,5
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Білки:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        4,9
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Сіль
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        0,12
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th colspan="3">Вітаміни</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Вітамін А
                        </td>
                        <td>
                        мкг RE
                        </td>
                        <td>
                        79,1
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін D
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        1,29
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін Е
                        </td>
                        <td>мг <br>(α-TE)</td>
                        <td>
                        2,50
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Альфа-токоферол
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        3,08
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін К
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        5,52
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Тіамін
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,40
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Рибофлавін
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,26
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Ніацин<br> <span>(преформований)</span>
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,23
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Ніацин <br><span>(включаючи триптофан)</span>
                        </td>
                        <td>
                        мг NE
                        </td>
                        <td>
                        1,90
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Пантотенова кислота
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,91
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін В<sub>6</sub>
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,34
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фолієва кислота
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        38,0
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін В<sub>12</sub>
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        0,55
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Біотин
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        6,38
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вітамін С
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        15,0
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <th colspan="3">Мінеральні речовини</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Натрій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        49,7
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Калій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        98,5
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Хлориди
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        42,8
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Кальцій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        53,5
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фосфор
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        49,6
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фосфати
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        152
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Магній
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        22,2
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Залізо
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        1,65
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Цинк
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        1,27
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Мідь
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,20
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Марганець
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,33
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Фториди
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,10
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Молібден
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        10,0
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Селен
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        7,50
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Хром
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        12,0
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Йод
                        </td>
                        <td>
                        мкг
                        </td>
                        <td>
                        15,7
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th colspan="3">Інші</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Каротиноїди
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        0,16
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Холін
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        49,8
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Осмолярність
                        </td>
                        <td>
                        мОсмоль/л
                        </td>
                        <td>
                        365
                        </td>
                      </tr>
                      <tr>
                        <td>
                        Вода
                        </td>
                        <td>
                        мл
                        </td>
                        <td>
                        83
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                  <strong>Важлива інформація: </strong><br>
                  Тільки для ентерального застосування!<br>
                  Не застосовувати парентерально!</br>
                  <strong>Застосовувати тільки під наглядом лікаря!</strong></br>
                  Може бути використане як єдине джерело харчування.<br>
                  Не використовувати для дітей віком до 3 років.<br>
                  З обережністю застосовувати для дітей віком від 3 до 6 років.<br>
                  Не використовувати хворим на фруктоземію.<br>
                  Не є лікарським засобом.<br>
                  `,
                                ],
                                list: [
                                    "<strong> Протипоказання:</strong> ",
                                    "•	Алергія до білків коров’ячого молока, галактоземія, фруктоземія. ",
                                    "•	Індивідуальна непереносимість компонентів.",
                                    "•	Вік від 0 до 3 років.",
                                    "•	Діасіп містить лактозу (3,54 g (г) / 100 ml (мл)). Не рекомендується пацієнтам з непереносимістю лактози.",
                                    "•  Не слід застосовувати пацієнтам, які потребують дієти без вмісту харчових волокон.",
                                ],
                                content2: [
                                    `
                  <p>
                  <strong>Форма випуску:</strong> <br>
                  Рідка суміш у пластиковій пляшечці <br>
                  200 мл <strong>e</strong>.
                  </p>
                `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                  <p><strong> Спосіб застосування: </strong>
                  <p>Перед застосуванням добре збовтати. Продукт готовий до вживання, найкраще смакує охолодженим.</p>
                  <p>Пити повільно маленькими ковтками протягом щонайменше 30 хвилин.</p></p><br>
                  <p><strong>Дозування:</strong>
                  <p>1-3 пляшечки на добу в якості додаткового джерела харчування, 7-10 пляшечок на добу як єдине джерело харчування, якщо інше не призначено лікарем.</p></p>
                  `,
                                ],
                                links: [],
                            },
                        ],
                    },
                    //9
                    {
                        titlePreviev: "Нутіліс Клір",
                        titleSingle: "Нутіліс Клір",
                        titleSingleEn: "Nutilis Clear",
                        image: ["9.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики",
                                content: [
                                    "<p><strong>Харчовий продукт для спеціальних медичних цілей:</strong><br> розчинний загущувач для рідин та напоїв Нутіліс Клір / Nutilis Clear на основі ксантанової камеді – порошок білого кольору, без смаку та запаху, швидко загущує рідини. Призначений для регулювання густини напоїв та їжі – для дієтичного харчування при дисфагії для пацієнтів віком від 3 років і старше та дорослих.</p>",
                                ],
                                list: [
                                    "•	Порошкоподібна суміш білого кольору без запаху, з нейтральним смаком.",
                                    "•	Зберігає колір рідин та продуктів, що загущуються. ",
                                    "•	Зберігає прозорість рідин при їх загущенні. ",
                                    "•	Зберігає свою консистенцію в ротовій порожнині завдяки компонентам, що є стійкими  до амілаз ротової порожнини.",
                                    "•	Запаковано в захисному середовищі.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Мальтодекстрин, <br>ксантанова камідь,<br> гуарова камідь.</p>",
                                    "<p>Без ГМО. Без глютену та лактози.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th>
                              Енергетична
                              цінність
                          </th>
                          <th>
                              кДж/<br>ккал
                          </th>
                          <th>
                              1230/290
                          </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Жири, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span>– насичені<span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>0</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Вуглеводи, з них:
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          57,6
                          </td>
                          </tr>

                          <tr>
                          <td>
                          <span> – цукри</span>
                          </td>
                          <td>
                          <span>г</span>
                          </td>
                          <td>
                          <span>10,9</span>
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Харчові волокна
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          28
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Білковий еквівалент
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          0,8
                          </td>
                          </tr>

                          <tr>
                          <td>
                          Сіль
                          </td>
                          <td>
                          г
                          </td>
                          <td>
                          3,8
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                          <th colspan="3">Мінеральні речовини</th>
                      </thead>
                      <tbody>
                          <tr>
                          <td>
                          Натрій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          1500
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Калій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          40
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Хлориди
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          30
                          </td>
                          </tr>
                          <tr>
                          <td>
                          Кальцій
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          <20
                          </td>
                          </tr>
                          <tr>
                            <td>
                              Фосфор
                            </td>
                            <td>
                              мг
                            </td>
                            <td>
                              50
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Фосфати (PO4)
                            </td>
                            <td>
                              мг
                            </td>
                            <td>
                              153
                            </td>
                          </tr>
                          <tr>
                          <td>
                          Магній
                          </td>
                          <td>
                          мг
                          </td>
                          <td>
                          <20
                          </td>
                          </tr>
                      </tbody>
                      </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                    <strong>Важлива інформація: </strong><br>
                    Тільки для ентерального застосування! Не застосовувати парентерально! Застосовувати тільки під наглядом лікаря! Використовувати виключно в якості загущувача страв та /або рідин.<br>
                    Не може бути використане як єдине джерело харчування. <br>
                    Не підходить для дітей віком до 3 років.<br>
                    Застосовувати з обережністю пацієнтам, що знаходяться на дієті з обмеженням натрію.<br><br>
                    <strong>Додаткова інформація: </strong><br>
                    Для забезпечення більш безпечного ковтання Нутіліс Клір / Nutilis Clear містить компоненти, стійкі до амілази ротової порожнини. В результаті напої, загущені Нутіліс Клір / Nutilis Clear, краще зберігають свою консистенцію в ротовій порожнині.
                    <img style=\"display: block;\" width=\"131\" height=\"106\" src=\"data:image/png;base64,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\">
                    `,
                                ],
                                content2: [
                                    `
                  <p>
                  <strong>Форма випуску:</strong> <br>
                  Порошкоподібна суміш в <br>
                  металевій банці масою 175 г <strong>e</strong>. <br>
                  </p>
                  `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                    <strong> Спосіб застосування. </strong> <br>
                    <p>Використовуйте тільки мірну ложку, що додається. Перед застосуванням ретельно вимийте руки, використовуйте чистий або стерильний посуд. Переконайтесь, що верхня частина банки чиста.</p>
                    <p>Призначену лікарем кількість порошку покладіть в склянку або миску. Повільно додайте напій або рідину, постійно перемішуючи. Перемішувати потрібно до повного розчинення порошку.</p>
                    <p>Додавайте порошок до досягнення необхідної консистенції пюре. Готову суміш використати протягом 2 годин. Завжди викидайте залишки невикористаної суміші.</p>
                    <p>Кількість мірних ложок Нутіліс Клір / Nutilis Clear для загущення* (1 мірна ложка = 1,25 g (г) порошку):</p>
                    `,
                                ],
                                list: [],
                                tables: {
                                    title: null,
                                    list: [
                                        `
                    <table>
                      <thead>
                          <tr>
                          <th colspan="2">Кількість мірних ложок Нутіліс Клір / Nutilis Clear на 200 ml (мл) готової страви або напою</th>
                          </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>Рівень 1. </strong>  Легке загущення
                          </td>
                          <td>
                            1
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Рівень 2. </strong>  Помірне загущення
                          </td>
                          <td>
                            2
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Рівень 3. </strong>  Середнє загущення
                          </td>
                          <td>
                            3
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Рівень 4. </strong>  Значне загущення
                          </td>
                          <td>
                            7
                          </td>
                        </tr>
                        <tr>
                          <td colspan="2">
                            <span><strong>*</strong> Кількість використовуваного Нутіліс Клір / NutilisClear може дещо відрізнятися в залежності від температури або щільності рідини та її в'язкості.</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                    ],
                                },
                            },
                        ],
                    },
                    //11
                    {
                        titlePreviev: "Ліквіджен",
                        titleSingle: "Ліквіджен",
                        titleSingleEn: "Liquigen",
                        image: ["11.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики",
                                content: [
                                    "<p><strong>Харчовий продукт для спеціальних медичних цілей:</strong><br> жирова емульсія з середньоланцюговими тригліцеридами Ліквіджен / Liquigen - для дієтотерапії при станах, пов’язаних із порушенням всмоктування жирів або метаболізму довголанцюгових тригліцеридів, при яких призначаються середньоланцюгові тригліцериди для пацієнтів від 3х років і старше та дорослих.</p>",
                                ],
                                list: [
                                    "• Високоенергетична жирова емульсія (містить 454 ккал / 100 мл).",
                                    "• Нутритивно не збалансована емульсія, що складається приблизно з 50% олій з середньоланцюговими тригліцеридами та 50% води.",
                                    "• Використовується для дієтотерапії при станах, пов’язаних із порушенням всмоктування жирів або метаболізму довголанцюгових тригліцеридів.",
                                    "• Може бути використаний для підвищення харчової цінності напоїв та продуктів, для збільшення енергетичної цінності зондового та перорального харчування.",
                                    "• Може використовуватись для дієтотерапії середньоланцюговими тригліцеридами при кетогенній дієті.",
                                    "• Без запаху.",
                                    "• Запаковано в захисному середовищі. Пастеризований продукт.",
                                ],
                                // links: [
                                //   "<strong>* </strong>Відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                                //   "<strong>1.</strong> MacBurney M.M., Russel C. and Young L.S. Formulas. In: Rombeau J.L. and Caldwell M.D. (eds). Clinical Nutrition. Enteral and Tube Feeding, 2nd ed. W.B. Saunders Co., Philadelphia, 1990, 149-173.",
                                //   "<strong>2.</strong> International Society for the Study of Fatty Acids and Lipids (ISSFAL) Report of th sub-committee on recommendations for intake of polysaturated fatty acids in healthy adults. June 2004.",
                                //   "<strong>3.</strong> Food and Agriculture Organization (FAO). Fats and fatty acids in human nutrition; report of an expert consultation. 10-14 November 2008; Geneva. FAO Food ans Nutrition Paper; 91.",
                                //   "<strong>3.</strong> Kuyumcu S, Menne D, Curcic J, et al. Noncoagulating enteral formula can empty faster from the stomach: A double-blind, randomized crossover trial using magnetic resonance imaging. Journal of Parenteral and Enteral Nutrition. 2015; 39:544-551.",
                                //   "<strong>3.</strong> Van den Braak CC, Klebach M, Abrahamse E, et al. A novel protein mixture containing vegetable proteins renders enteral nutrition products non-coagulating after in vitro gastric digestion. Clinical Nutrition. 2013; 32:765-771.",
                                //   "<strong>3.</strong> Klebach M, Hofman Z, Bluemal S, et al. Effect of protein type in enteral nutrition formulas on coagulation in the stomach in vivo: Post hoc analyses of a randomized  controlled trial with MRI. Abstract presented  at Clinical Nutrition Week, January 16-19; Austin, Tx. Journal of Parenteral and Enteral Nutrition. 2016; 40:134(21).",
                                //   "<strong>* </strong>MacBurney M.M., Russel C. and Young L.S. Formulas. In: Rombeau J.L. and Caldwell M.D. (eds). Clinical Nutrition. Enteral and Tube Feeding, 2nd ed. W.B. Saunders Co., Philadelphia, 1990, 149-173."
                                // ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування* ",
                                // content: [
                                //   "<p>Кубітан – це харчовий продукт для медичних цілей, призначений для харчової терапії. Він живить організм хворої людини, забезпечуючи його поживними речовинами . Правильне харчування допомагає організму відновити сили під час хвороби, покращити м’язову силу, якість життя та вирішити проблеми з харчуванням, пов’язані із хворобою.</p>",
                                //   "<p>Харчування має значення!</p>",
                                //   "<p>Кубітан багатий на білки та вітаміни А, С та Е, які рекомендується вживати людям з пролежнями та ранами, що важко загоюються. Адекватне харчування пацієнтів із ранами, що важко загоюються, а також пролежнями є важливим елементом ефективного догляду за пацієнтами.**</p>",
                                //   "<p>Крім того, Кубітан  підтримує лікування пацієнтів після променевої терапії. Збільшена кількість білка у поєднанні з аргініном зменшує прояв побічних дій після опромінення.** </p>",
                                // ],
                                list: [
                                    // "<strong>Стани, що пов'язані із втратою апетиту та/або відмовою від прийому їжі:</strong>  ",
                                    "• захворювання печінки та ШКТ: хронічні панкреатити, гепатити, відновлювальний період після гострого панкреатиту, після операцій на ШКТ",
                                    "• може призначатись онкологічним пацієнтам, що потребують додаткової легкозасвоюваної енергії ",
                                    "• спадкові хвороби: мітохондріальні хвороби, спадкові дефекти бета-окислення середньо- та довголанцюгових жирних кислот та інші синдроми, що супроводжуються затримкою росту та розвитку",
                                ],
                                links: [
                                    "<strong>* </strong>Відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                                    "<strong>1.</strong> Mott CB, Sarles H, Tiscornia O. Action differente des triglycerides a chaines courtes, moyennes ou longues, sur la secretion pacreatique exocrine de l’homme. Biol Gastro-enterol 1972;5:79-84.",
                                    "<strong>2.</strong> Dixon M, Stafford J, White F, Clayton N, Gallagher J (2015) Disorders of Mitochondrial Energy Metabolism, Lipid Metabolism and other Disorders In:Clinical Paediatric dietetics. 4th edition, Dixon et al. (Shaw V, Ed). p590. Chichester: Wiley Blackwell.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Рафіновані рослинні олії (середньоланцюгові тригліцериди (кокосова та/або пальмова олія)), вода, емульгатори (E472c, E471), регулятор кислотності (лимонна кислота). Країна походження олій з середньоланцюговими тригліцеридами -  США. Без ГМО.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                  <table>
                    <thead>
                      <tr>
                        <th>
                          Енергетична
                          цінність
                        </th>
                        <th>
                          кДж/<br>ккал
                        </th>
                        <th>
                          1865/454
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Жири, з них:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        50,4
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span>– насичені<span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>50,4</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span>– Середньоланцюгові тригліцериди<span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>49,1</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span>– Довголанцюгові тригліцериди<span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>1,3</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Вуглеводи, з них:
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                          0
                        </td>
                      </tr>

                      <tr>
                        <td>
                        <span> – цукри</span>
                        </td>
                        <td>
                        <span>г</span>
                        </td>
                        <td>
                        <span>0</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Харчові волокна
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        0
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Сіль
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        0,01
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Білки
                        </td>
                        <td>
                        г
                        </td>
                        <td>
                        0
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                        `
                  <table>
                    <thead>
                      <th colspan="3">Мінеральні речовини</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        Натрій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        5,0
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Кальцій
                        </td>
                        <td>
                        мг
                        </td>
                        <td>
                        1,0
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Осмолярність
                        </td>
                        <td>
                        мОсмоль/л
                        </td>
                        <td>
                        42
                        </td>
                      </tr>

                      <tr>
                        <td>
                        Вода
                        </td>
                        <td>
                        мл
                        </td>
                        <td>
                        47
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    `
                  <strong>Важлива інформація: </strong><br>
                  Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Не може бути використане  як єдине джерело харчування. Підходить тільки для дорослих. Підходить тільки для дітей від 3 років та дорослих.  Не використовувати для дітей віком до 3 років. <strong>Не є лікарським засобом.</strong>
                  `,
                                ],
                                list: [
                                    "<strong>Застереження щодо застосування:</strong> ",
                                    "•	Продукт рекомендовано вводити в раціон повільно, так як швидке всмоктування великої кількості продукту може спричинити блювання або діарею.",
                                ],
                                content2: [
                                    `
                  <p>
                  <strong>Форма випуску:</strong> <br>
                  Рідка суміш у пластиковій пляшечці 250 мл <sup><strong>e</strong></sup>.
                  </p>
                `,
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    `
                  <strong> Рекомендоване споживання: </strong>
                  <p>Кількість суміші та її розведення визначаються тільки лікарем в залежності від віку, ваги тіла і стану здоров’я пацієнта. Для дітей молодше 5 років продукт може потребувати розведення. Ліквіджен  може бути використаний для підвищення харчової цінності напоїв та продуктів, для збільшення енергетичної цінності зондового та перорального харчування. Продукт можна споживати безпосередньо з пляшечки або додавати до молочного коктейлю.</p> <br>
                  <p>Будь ласка, використовуйте інший посуд, якщо плануєте зберігати залишки продукту в пляшечці для подальшого споживання. При споживанні безпосередньо із пляшечки залишки продукту заборонено використовувати для подальшого споживання.</p> <br>
                  <strong> Спосіб застосування: </strong>
                  <p>•	Перед застосуванням добре збовтати.</p>
                  `,
                                ],
                            },
                        ],
                    },

                ],
            },
            probe: {
                title: "Зондове харчування",
                slug: "probe",
                products: [
                    // 11
                    {
                        titlePreviev: "Нутрізон Едванст Діазон ВП Енергія",
                        titleSingle: "Нутрізон Едванст Діазон ВП Енергія",
                        titleSingleEn:
                            "Nutrison Advanced Diason Energy HP / Зі смаком ванілі",
                        image: ["11.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p>Харчовий продукт для спеціальних медичних цілей: ентеральне харчування Нутрізон Едванст Діазон ВП Енергія  / Nutrison Advanced Diason Energy HP – суміш рідка, повноцінна, збалансована, з високим вмістом енергії та білка, з харчовими волокнами, готова до вживання для годування через зонд. Для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів з цукровим діабетом або гіперглікемією з підвищеними потребами в білку та енергії  від 12 років і старше та дорослих.</p>",
                                ],
                                list: [
                                    "• 	Висококалорійний, повноцінний, збалансований продукт для зондового харчування (1,5 ккал/мл).",
                                    "• 	Високобілкова суміш (7,69 г білка на 100 мл).",
                                    "• 	Низький вміст вуглеводів, що відповідає рекомендаціям ADA<sup>1</sup> та EASD<sup>2</sup> з нутритивної підтримки у пацієнтів з гіперглікемією<sup>3,5</sup>.",
                                    "•	Містить ізомальтулозу, яка повільно розщеплюється  та всмоктується<sup>4,5</sup>, не викликаючи виражених коливань глюкози під час та після введення, та мальтодекстрин<sup>6</sup>, який не викликає вираженого підйому рівня глюкози крові.",
                                    "•	Наявність харчових волокон (MF6) забезпечує контроль над швидкістю всмоктування вуглеводів<sup>7</sup>.",
                                    "•	Підвищений вміст хрому сприяє  підвищенню чутливості до інсуліну та покращує метаболізм глюкози<sup>8,9</sup>.",
                                    "•	Клінічно доведено, що Нутрізон Едванст Діазон ВП Енергія дозволяє досягнути кращого контролю  над рівнем глюкози крові під час та після введення<sup>10</sup>.",
                                    "•	Запаковано в захисному середовищі. Ультрапастеризований продукт.",
                                    "ADA – American Diabetes Association <br> EASD – European Association for the Study of Diabetes.",
                                ],
                                links: [
                                    "<strong>* </strong>відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                                    "<strong>1.</strong> Evert A.B. et al. Diabetes Care 2013 Nov.; 36 (11): 3821–42. ",
                                    "<strong>2.</strong> Mann J.I. et al. NutrMetabCardiovascDis 2004; 14: 373–394. ",
                                    "<strong>3.</strong> Sanz-Paris A., Calvo L., Guallard A., Salazar I., Albero R.: High-fat versus high carbohydrate enteral formulae: effect on blood glucose, C-peptide, and ketones in patients with type 2 diabetes treated with insulin or sulfonylurea. Nutrition 14: 840–845, 1998.",
                                    "<strong>4.</strong> Liao et al. Theeffectisomaltuloseonbloodglucose and lipids for diabetic subjects. Diabetes 50: A366. 2001. Chin J. GastrointestSurg 2005; 8: 223–5.",
                                    "<strong>5.</strong> Kawai et al. Usefulnessofpalatinoseas a caloric sweetener for diabetic patients. HormMetabRes 1989; 21: 338–340.",
                                    "<strong>6.</strong> Jenkins D.J., Taylor R.H., Wolever T.M.: Thediabetic diet, dietary carbohydrate and differences in digestibility. Diabetologia 1982; 23: 477–484.",
                                    "<strong>7.</strong> Elia M., Engfer M.B., Green C.J., Silk D.B.A. Systematic review and meta-analysis: the clinical and physiological effectsoffibre-containingenteralformulae. AlimentPharmacolTher 2008; 27: 120–145.",
                                    "<strong>8.</strong> Anderson R.A. Chromium in the prevention and control of diabetes. DiabetesMetab 2000; 26: 22–7.",
                                    "<strong>9.</strong> Anderson R.A. Chromium, glucose intolerance and diabetes. J AmCollNutr 1998; 17: 548–55.",
                                    "<strong>10.</strong> Lansink M., Rouws C.H.F.C., Hofman Z. Improved Glucose Profile in Patients With Type 2 Diabetes With a New, High-Protein, Diabetes-Specific Tube Feed During 4 Hours of Continuous Feeding, Journal of Parenteral and Enteral Nutrition 41(6)",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, мальтодекстрин, рослинні олії (рапсова, соняшникова), казеїнат білка з коров'ячого <strong>молока</strong>, ізомальтулоза (джерело глюкози та фруктози), частково гідролізований білок із <strong>сої</strong>, харчові волокна (інулін, олігофруктоза, гуміарабік, полісахариди із сої, целюлоза, стійкий крохмаль), ароматизатор (ваніль),<strong> риб’ячий жир</strong>, регулятор кислотності (лимонна кислота), карбонат кальцію, хлорид калію, емульгатор (соєвий лецитин), цитрат натрію, цитрат калію, гідроксид магнію, каротиноїди (містить <strong>сою</strong>) (β-каротин, лютеїн, живиця лікопену із томатів), гідроксид калію, гідроортофосфат калію, хлорид холіну, L-аскорбат натрію, лактат заліза (II), ацетат DL-альфа токоферолу, сульфат цинку, ретинілацетат,  хлорид хрому (III), глюконат міді, сульфат марганцю (II), D-пантотенат кальцію, нікотинамід, селеніт натрію, ціанокобаламін, гідрохлорид тіаміну, D-біотин, фолієва кислота, холекальциферол, гідрохлорид піридоксину, рибофлавін, йодид калію, фторид натрію, молібдат натрію, фітоменадіон. Без ГМО. Без глютену. Містить сліди лактози. </p>",
                                ],
                                list: [""],
                                links: [""],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                    <thead>
                      <tr>
                        <th>Енергетична
                        цінність
                        </th>
                        <th>кДж/<br>ккал</th>
                        <th>625/150</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Жири, з них:</td>
                        <td>г</td>
                        <td>7,72</td>
                      </tr>
                      <tr>
                        <td><span>– насичені</span></td>
                        <td><span>г</span></td>
                        <td><span>0,82</span></td>
                      </tr>
                      <tr>
                        <td><span>– мононенасичені</span></td>
                        <td><span>г</span></td>
                        <td><span>4,63</span></td>
                      </tr>
                      <tr>
                        <td><span>– поліненасичені</span></td>
                        <td><span>г</span></td>
                        <td><span>2,28</span></td>
                      </tr>
                      <tr>
                        <td>Докозагексаєнова кислота </td>
                        <td>мг</td>
                        <td>20,0</td>
                      </tr>
                      <tr>
                        <td>Ейкозапентаєнова кислота </td>
                        <td>мг</td>
                        <td>29,9</td>
                      </tr>
                      <tr>
                        <td>Вуглеводи, з них:</td>
                        <td>г</td>
                        <td>11,7</td>
                      </tr>
                      <tr>
                        <td><span>– цукри</span></td>
                        <td><span>г</span></td>
                        <td><span>4,46</span></td>
                      </tr>
                      <tr>
                        <td><span>– лактоза</span></td>
                        <td><span>г</span></td>
                        <td><span><0,025</span></td>
                      </tr>
                      <tr>
                        <td>Харчові волокна</td>
                        <td>г</td>
                        <td>1,50</td>
                      </tr>
                      <tr>
                        <td>Білки</td>
                        <td>г</td>
                        <td>7,69</td>
                      </tr>
                      <tr>
                        <td>Сіль</td>
                        <td>г</td>
                        <td>0,33</td>
                      </tr>
                    </tbody>
                  </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Вітаміни</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Вітамін А</td>
                          <td>мкг RE</td>
                          <td>119</td>
                        </tr>
                        <tr>
                          <td>Вітамін D</td>
                          <td>мкг</td>
                          <td>1,02</td>
                        </tr>
                        <tr>
                          <td>Вітамін Е</td>
                          <td>мг <br>(α-TE)</td>
                          <td>1,02</td>
                        </tr>
                        <tr>
                          <td>Вітамін К</td>
                          <td>мкг</td>
                          <td>7,71</td>
                        </tr>
                        <tr>
                          <td>Тіамін</td>
                          <td>мг</td>
                          <td>0,23</td>
                        </tr>
                        <tr>
                          <td>Рибофлавін</td>
                          <td>мг</td>
                          <td>0,24</td>
                        </tr>
                        <tr>
                          <td>Ніацин <br> <span>(преформований)</span></td>
                          <td>мг</td>
                          <td>0,90 </td>
                        </tr>
                        <tr>
                          <td>Ніацин <br> <span>(включаючи триптофан)</span></td>
                          <td>NЕ мг</td>
                          <td>2,63</td>
                        </tr>
                        <tr>
                          <td>Пантотенова кислота</td>
                          <td>мг</td>
                          <td>0,77
                          </td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>6</sub></td>
                          <td>мг</td>
                          <td>0,24</td>
                        </tr>
                        <tr>
                          <td>Фолієва кислота</td>
                          <td> мкг</td>
                          <td>42,0</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>12</sub></td>
                          <td> мкг</td>
                          <td>0,72</td>
                        </tr>
                        <tr>
                          <td>Біотин</td>
                          <td> мкг</td>
                          <td>5,82</td>
                        </tr>
                        <tr>
                          <td>Вітамін С</td>
                          <td> мг</td>
                          <td>21,8</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Мінеральні речовини</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Натрій</td>
                          <td> мг</td>
                          <td>131</td>
                        </tr>
                        <tr>
                          <td>Калій</td>
                          <td>мг</td>
                          <td>200,0</td>
                        </tr>
                        <tr>
                          <td>Хлориди</td>
                          <td>мг</td>
                          <td>98,1</td>
                        </tr>
                        <tr>
                          <td>Кальцій</td>
                          <td>мг</td>
                          <td>75 </td>
                        </tr>
                        <tr>
                          <td>Фосфор</td>
                          <td>мг</td>
                          <td>82,4</td>
                        </tr>
                        <tr>
                          <td>Фосфати (PO4)</td>
                          <td>мг</td>
                          <td>252,0</td>
                        </tr>
                        <tr>
                          <td>Магній</td>
                          <td>мг</td>
                          <td>37,5</td>
                        </tr>
                        <tr>
                          <td>Залізо</td>
                          <td>мг</td>
                          <td>1,86</td>
                        </tr>
                        <tr>
                          <td>Цинк</td>
                          <td>мг</td>
                          <td>1,4</td>
                        </tr>
                        <tr>
                          <td>Мідь</td>
                          <td>мг</td>
                          <td>0,21</td>
                        </tr>
                        <tr>
                          <td>Марганець</td>
                          <td>мг</td>
                          <td>0,38</td>
                        </tr>
                        <tr>
                          <td>Фториди</td>
                          <td>мг</td>
                          <td>0,12</td>
                        </tr>
                        <tr>
                          <td>Молібден</td>
                          <td>мкг</td>
                          <td>11,7</td>
                        </tr>
                        <tr>
                          <td>Селен</td>
                          <td>мкг</td>
                          <td>8,70</td>
                        </tr>
                        <tr>
                          <td>Хром</td>
                          <td>мкг</td>
                          <td>14,0</td>
                        </tr>
                        <tr>
                          <td>Йод</td>
                          <td>мкг</td>
                          <td>15,5</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Інші</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Каротиноїди, з них:</td>
                          <td>мг</td>
                          <td>0,30</td>
                        </tr>
                        <tr>
                          <td><span>– лютеїн</span></td>
                          <td><span>мкг</span></td>
                          <td><span>40,5</span></td>
                        </tr>
                        <tr>
                          <td><span>– зеаксантин</span></td>
                          <td><span>мкг</span></td>
                          <td><span>0,30</span></td>
                        </tr>
                        <tr>
                          <td>Холін</td>
                          <td>мг</td>
                          <td>53,4</td>
                        </tr>
                        <tr>
                          <td>Осмолярність
                          </td>
                          <td>мОсмоль/л</td>
                          <td>395</td>
                        </tr>
                        <tr>
                          <td>Вода
                          </td>
                          <td>мл</td>
                          <td>77,5</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    "<p><strong>Важлива інформація:</strong> <br> Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Може бути використане  як єдине джерело харчування.</p>",
                                    "<p>При використанні суміші важливо контролювати та коригувати надходження рідини з метою забезпечення належного стану гідратації.  В травному тракті можлива коагуляція через взаємодію з іншими препаратами.</p>",
                                    "<p>З обережністю застосовувати для дітей  віком 12 років та підлітків, тільки під наглядом лікаря.</p>",
                                    "<p><strong>Протипоказання: </strong><br> Не використовувати для дітей віком до 12 років та / або пацієнтам, хворим на галактоземію. Не використовувати пацієнтам, які потребують дієти без вмісту харчових волокон. </p>",
                                    "<p><strong>Не є лікарським засобом.</strong></p>",
                                    "<p><strong>Форма випуску:</strong> суміш рідка у спадаючій пластиковій пляшці об’ємом 1000мл e.</p>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    "<p><strong>Спосіб застосування:</strong> <br> Перед застосуванням перевірити зовнішній вигляд продукту, добре збовтати. Не слід розбавляти продукт та додавати лікарські засоби. Застосовувати суміш кімнатної температури.</p>",
                                    "<p><strong>Строк введення:</strong> <br> При підключенні до системи введення (при асептичному застосуванні, закрита система) час введення продукту не може перевищувати 24 години. Якщо кришка була знята (використовується як відкрита система), час введення продукту не може перевищувати 8 годин.</p>",
                                ],
                            },
                        ],
                    },
                    // 10
                    {
                        titlePreviev: "Нутрізон Протеїн Інтенс",
                        titleSingle: "Нутрізон Протеїн Інтенс",
                        titleSingleEn: "Nutrison Protein Intense",
                        image: ["10.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p>Харчовий продукт для спеціальних медичних цілей: ентеральне харчування Нутрізон Протеїн Інтенс / Nutrison Protein Intense.</p>",
                                    "<p>Нутрізон Протеїн Інтенс призначений для дорослих та дітей від 12 років в критичних станах з підвищеними потребами в білку та помірними потребами в енергії.</p>",
                                    "<p>Для раннього ентерального харчування пацієнтів в інтенсивній терапії.</p>",
                                ],
                                list: [
                                    "• Призначений для нутритивної підтримки важкохворих пацієнтів у відділеннях інтенсивної терапії.",
                                    "• Модифікований склад цільного білка: поєднання молочних (казеїну – 25%, сироваткового –  35%) та рослинних (20% соєвого та 20% бобового) білків сприяє швидкому звільненню шлунку та доброму засвоєнню.",
                                    "• Відповідає міжнародним рекомендаціям з нутритивної підтримки в інтенсивній терапії та  рекомендаціям для досягнення рекомендованих показників вживання білка у пацієнтів в критичних станах.",
                                    "• Згідно останніх міжнародних рекомендацій важкохворі пацієнти в критичних станах повинні отримувати велику кількість білка та помірно підвищену кількість енергії, так як надлишок надходження високоенергетичних продуктів може негативно вплинути на перебіг захворювання.",
                                    "• Нутрізон Протеїн Інтенс містить риб’ячий жир в кількостях, оптимальних та рекомендованих для профілактики дефіциту та забезпечення стабільного стану у важкохворих пацієнтів",
                                    "• Низький вміст вуглеводів в даній суміші попереджує надлишкове надходження глюкози, оскільки пацієнти отримують глюкозу також шляхом введення інших розчинів інфузійно",
                                ],
                                links: [
                                    "<strong>*</strong> відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                                    "<strong>1.</strong> McClave SA, Taylor BE, Martindale RG, et al. Guidelines for the Provision and Assessment of Nutrition Support Therapy in the Adult Critically Ill Patient: Society of Critical Care Medicine (SCCM) and American Society for Parenteral and Enteral Nutrition (A.S.P.E.N.). Journal of Parenteral and Enteral Nutrition. 2016;40:159-211.",
                                    "<strong>2.</strong> Kreymann KG, Berger MM, Deutz NEP, et al. ESPEN Guidelines on Enteral Nutrition: Intensive care. Clin Nutr. 2006;25:210–223.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування*",
                                content: [
                                    "<p>Для раннього ентерального харчування важкохворих пацієнтів в відділенні інтенсивної терапії при мальнутриції (недостатності харчування).</p>",
                                    "<p>Може використовуватися для зондового харчування як єдине або додаткове джерело харчування в випадках, пов’язаних з нутритивною недостатністю у пацієнтів з підвищеними потребами білків в якості нутритивної підтримки в інтенсивній терапії.</p>",
                                ],
                                links: [
                                    "<strong>*</strong> відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href='https://www.espen.org/guidelines-home' target='_blank'>https://www.espen.org/guidelines-home</a>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, мальтодекстрин, білок з сироватки (з коров’ячого <strong>молока</strong>), рослинні олії (соняшникова олія, рапсова олія, олія із середньоланцюговими тригліцеридами (кокосова олія, пальмова олія)), казеїнат натрію (з коров’ячого <strong>молока</strong>), ізолят горохового білка, білок із сої, регулятор кислотності (лимонна кислота), <strong>риб’ячий</strong> жир, емульгатор (соєвий лецитин), гідроксид калію, хлорид калію, гідроксид кальцію, каротиноїди (містить <strong>сою</strong>) (β-каротин, лютеїн, живиця лікопену із томатів), хлорид холіну, цитрат натрію, гідроксид магнію, L-аскорбат натрію, лактат заліза (ІІ), сульфат цинку, сульфат марганцю (ІІ), глюконат міді, D-пантотенат кальцію, ацетат DL-альфа токоферолу, гідрохлорид тіаміну, гідрохлорид піридоксину, рибофлавін, фторид натрію, ретинілацетат, хлорид хрому (ІІІ), фолієва кислота, йодид калію, D-біотин, молібдат натрію, селеніт натрію, фітоменадіон, холекальциферол. Без ГМО. Без глютену. Алергени: містить молоко, сою та рибу.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                    <thead>
                      <tr>
                        <th>Енергетична
                        цінність
                        </th>
                        <th>кДж/<br>ккал</th>
                        <th>528/126</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Жири, з них:</td>
                        <td>г</td>
                        <td>4,9</td>
                      </tr>
                      <tr>
                        <td><span>– насичені</span></td>
                        <td><span>г</span></td>
                        <td><span>1,3</span></td>
                      </tr>
                      <tr>
                        <td>Вуглеводи, з них:</td>
                        <td>г</td>
                        <td>10,4</td>
                      </tr>
                      <tr>
                        <td><span>– цукри</span></td>
                        <td><span>г</span></td>
                        <td><span>0,8</span></td>
                      </tr>
                      <tr>
                        <td><span>– лактоза</span></td>
                        <td><span>г</span></td>
                        <td><span><0,025</span></td>
                      </tr>
                      <tr>
                        <td>Харчові волокна</td>
                        <td>г</td>
                        <td>0,09</td>
                      </tr>
                      <tr>
                        <td>Білки</td>
                        <td>г</td>
                        <td>10</td>
                      </tr>
                      <tr>
                        <td>Сіль</td>
                        <td>г</td>
                        <td>0,29</td>
                      </tr>
                    </tbody>
                  </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Вітаміни</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Вітамін А</td>
                          <td>мкг RE</td>
                          <td>102</td>
                        </tr>
                        <tr>
                          <td>Вітамін D</td>
                          <td>мкг</td>
                          <td>1,72</td>
                        </tr>
                        <tr>
                          <td>Вітамін Е</td>
                          <td>мг <br>(α-TE)</td>
                          <td>1,63</td>
                        </tr>
                        <tr>
                          <td>Вітамін К</td>
                          <td>мкг</td>
                          <td>6,6</td>
                        </tr>
                        <tr>
                          <td>Тіамін</td>
                          <td>мг</td>
                          <td>0,19</td>
                        </tr>
                        <tr>
                          <td>Рибофлавін</td>
                          <td>мг</td>
                          <td>0,29</td>
                        </tr>
                        <tr>
                          <td>Ніацин</td>
                          <td>мг NЕ</td>
                          <td>2,31</td>
                        </tr>
                        <tr>
                          <td>Пантотенова кислота</td>
                          <td>мг</td>
                          <td>0,66</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>6</sub></td>
                          <td>мг</td>
                          <td>0,21</td>
                        </tr>
                        <tr>
                          <td>Фолієва кислота</td>
                          <td> мкг</td>
                          <td>33,1</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>12</sub></td>
                          <td> мкг</td>
                          <td>0,52</td>
                        </tr>
                        <tr>
                          <td>Біотин</td>
                          <td> мкг</td>
                          <td>5</td>
                        </tr>
                        <tr>
                          <td>Вітамін С</td>
                          <td> мг</td>
                          <td>13,3</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Мінеральні речовини</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Натрій</td>
                          <td> мг</td>
                          <td>116</td>
                        </tr>
                        <tr>
                          <td>Калій</td>
                          <td>мг</td>
                          <td>218 </td>
                        </tr>
                        <tr>
                          <td>Хлориди</td>
                          <td>мг</td>
                          <td>96,4</td>
                        </tr>
                        <tr>
                          <td>Кальцій</td>
                          <td>мг</td>
                          <td>75 </td>
                        </tr>
                        <tr>
                          <td>Фосфор</td>
                          <td>мг</td>
                          <td>81,9</td>
                        </tr>
                        <tr>
                          <td>Магній</td>
                          <td>мг</td>
                          <td>22</td>
                        </tr>
                        <tr>
                          <td>Залізо</td>
                          <td>мг</td>
                          <td>2</td>
                        </tr>
                        <tr>
                          <td>Цинк</td>
                          <td>мг</td>
                          <td>1,45</td>
                        </tr>
                        <tr>
                          <td>Мідь</td>
                          <td>мг</td>
                          <td>0,22</td>
                        </tr>
                        <tr>
                          <td>Марганець</td>
                          <td>мг</td>
                          <td>0,35</td>
                        </tr>
                        <tr>
                          <td>Фториди</td>
                          <td>мг</td>
                          <td>0,13</td>
                        </tr>
                        <tr>
                          <td>Молібден</td>
                          <td>мкг</td>
                          <td>13</td>
                        </tr>
                        <tr>
                          <td>Селен</td>
                          <td>мкг</td>
                          <td>6,83</td>
                        </tr>
                        <tr>
                          <td>Хром</td>
                          <td>мкг</td>
                          <td>8,3</td>
                        </tr>
                        <tr>
                          <td>Йод</td>
                          <td>мкг</td>
                          <td>18,9</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Інші</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Каротиноїди</td>
                          <td>мг</td>
                          <td>0,2</td>
                        </tr>
                        <tr>
                          <td>Холін</td>
                          <td>мг</td>
                          <td>46</td>
                        </tr>
                        <tr>
                          <td>Осмолярність
                          </td>
                          <td>мОсмоль/л</td>
                          <td>275</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    "<p><strong>Важлива інформація:</strong> <br> Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Може бути використане як єдине джерело харчування. Не є лікарським засобом.</p>",
                                    "<p><strong>Протипоказання:</strong><br> Не використовувати для дітей віком до 12 років. Не використовувати хворим на галактоземію чи тим, які мають підвищену чутливість до окремих компонентів продукту. Забороняється вводити внутрішньовенно.</p>",
                                    "<p><strong>Форма випуску:</strong> рідка суміш у спадаючій пластиковій пляшці, об'ємом  500 мл e.</p>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    "<p><strong>Спосіб застосування:</strong> <br> Перед застосуванням перевірити зовнішній вигляд продукту, добре збовтати. Не слід розбавляти продукт та додавати лікарські засоби. Застосовувати суміш кімнатної температури.</p>",
                                ],
                            },
                        ],
                    },
                    //  // 7
                    //  {
                    //   titlePreviev: "Нутрізон Едванст Протізон",
                    //   titleSingle: "Нутрізон Едванст Протізон",
                    //   titleSingleEn: "Nutrison Advanced Protison",
                    //   image: ["7.png"],
                    //   accordions: [
                    //     {
                    //       isActive: false,
                    //       title: "Характеристики*",
                    //       content: [
                    //         "<p>Харчовий продукт для спеціальних медичних цілей: ентеральне харчування Нутрізон Едванст Протізон / Nutrison Advanced Protison – суміш рідка, повноцінна, збалансована, з високим вмістом білка, з харчовими волокнами, для дієтичного харчування при мальнутриції (нутритивній недостатності) при метаболічному стресі для пацієнтів від 3 років і старше та дорослих, для годування через зонд, готовий до споживання. Продукт містить сліди лактози.</p>",
                    //       ],
                    //       list: [
                    //         "• Призначений, у першу чергу, для пацієнтів з підвищеними потребами в білку з важкими травмами, опіками, сепсисом.",
                    //         "• Модифікований склад білка: поєднання молочних (казеїн – 25%, сироватковий – 35%) і рослинних (20% соєвий та 20% бобовий) білків сприяє швидкому звільненню шлунку та гарному засвоєнню.",
                    //         "• Згідно останніх рекомендацій, пацієнти з важкою травмою та опіками повинні отримувати велику кількість білка і помірно підвищену кількість енергії, оскільки надмірне надходження високоенергетичних продуктів може негативно впливати на перебіг захворювання.",
                    //         "• Містить комбінацію з 6 розчинних і нерозчинних харчових волокон MF6. Нерозчинні волокна нормалізують перистальтику кишківника (профілактика діареї та парезу), а розчинні волокна забезпечують пребіотичний ефект, оскільки є поживним середовищем для нормальної мікрофлори кишківника.",
                    //         "• Мікроелементи (хром, селен, мідь) забезпечують антиоксидантний захист й імуномоделюючу дію.",
                    //         "• Не містить клінічно значущих лактози, галактози, глютену, холестерину.",
                    //         "• Не містить генетично модифікованих компонентів.",
                    //       ],
                    //       links: [
                    //         "<strong>* </strong>відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                    //         "<strong>1.</strong> International Society for the Study of Fatty Acids and Lipids (ISSFAL) Report of th sub-committee on recommendations for intake of polysaturated fatty acids in healthy adults. June 2004.",
                    //         "<strong>2.</strong> Food and Agriculture Organization (FAO). Fats and fatty acids in human nutrition; report of an expert consultation. 10-14 November 2008; Geneva. FAO Food ans Nutrition Paper; 91.",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Показання до застосування*",
                    //       content: [
                    //         "<p>Для пацієнтів на етапі реабілітації в інтенсивній терапії, для пацієнтів із сепсисом, травмами, опіками у випадках нескомпрометованого ШКТ.</p>",
                    //         "<p>Може використовуватися для зондового харчування як єдине чи додаткове джерело харчування у випадках, пов’язаних із нутритивною недостатністю у пацієнтів, які потребують зондового харчування, на етапі реабілітації в інтенсивній терапії, для пацієнтів із сепсисом,  поліорганними травмами, опіками, раком, у післяопераційний період за гіперкатаболізму. Нутрізон Едванст Протізон як єдине джерело харчування показано пацієнтам із метаболічним стресом, високою потребою в білку, яким необхідна дієта, багата на клітковину.</p>",
                    //       ],
                    //       links: [
                    //         "<strons>*</strons> відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a>https://www.espen.org/guidelines-home</a>",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Склад",
                    //       content: [
                    //         "<p>Вода, мальтодекстрин, білок з сироватки (з коров’ячого <strong>молока</strong>), рослинні олії (соняшникова олія, рапсова олія, олія із середньоланцюговими тригліцеридами (кокосова олія, пальмоядрова олія)), казеїнат білка з коров’ячого <strong>молока</strong>, білок з гороху, харчові волокна (інулін, олігофруктоза, гуміарабік, полісахариди з <strong>сої</strong>, целюлоза, резистентний крохмаль), білок із <strong>сої, риб’ячий</strong> жир, емульгатор (<strong>соєвий</strong> лецитин), гідроксид калію, карбонат кальцію, гідроортофосфат магнію, хлорид кальцію, цитрат калію, каротиноїди (містить <strong>сою</strong>) (β-каротин, лютеїн, живиця лікопену з томатів), хлорид холіну, L-аскорбат натрію, гідроортофосфат кальцію, лактат заліза (II), сульфат цинку, нікотинамід, ретинілацетат, ацетат DL-альфа токоферолу, глюконат міді, сульфат марганцю (II), селеніт  натрію, D-пантотенат  кальцію,  холекальциферол, хлорид  хрому (ІІ),  D-біотин, гідрохлорид тіаміну, фолієва кислота, гідрохлорид піридоксину, рибофлавін, йодид калію, фторид натрію, молібдат натрію, фітоменадіон, ціанокобаламін. Без ГМО. Без глютену.</p>",
                    //       ],
                    //       tables: {
                    //         title: "Поживна цінність	на 100 мл",
                    //         list: [
                    //           `
                    //           <table>
                    //           <thead>
                    //             <tr>
                    //               <th>Енергетична
                    //               цінність
                    //               </th>
                    //               <th>кДж/<br>ккал</th>
                    //               <th>540/128 </th>
                    //             </tr>
                    //           </thead>
                    //           <tbody>
                    //             <tr>
                    //               <td>Жири, з них:</td>
                    //               <td>г</td>
                    //               <td>3,7 </td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– насичені</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>1,0  </span></td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– середньоланцюгові тригліцериди</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>0,5 </span></td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– мононенасичені</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>2,0 </span> </td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– поліненасичені</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>0,7  </span></td>
                    //             </tr>

                    //             <tr>
                    //               <td>Докозагексаєнова кислота (ДГК)</td>
                    //               <td>мг</td>
                    //               <td>20,4 </td>
                    //             </tr>
                    //             <tr>
                    //               <td>Ейкозапентаєнова кислота (ЕПК)</td>
                    //               <td>мг</td>
                    //               <td>30,0 </td>
                    //             </tr>
                    //             <tr>
                    //               <td>Вуглеводи, з них:</td>
                    //               <td>г</td>
                    //               <td>15,4 </td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– цукри</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>1,0 </span></td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– лактоза</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span><0,025 </span></td>
                    //             </tr>
                    //             <tr>
                    //               <td>Харчові волокна</td>
                    //               <td>г</td>
                    //               <td>1,5  </td>
                    //             </tr>
                    //             <tr>
                    //               <td>Білки</td>
                    //               <td>г</td>
                    //               <td>7,5 </td>
                    //             </tr>
                    //             <tr>
                    //               <td>Сіль</td>
                    //               <td>г</td>
                    //               <td>0,20 </td>
                    //             </tr>
                    //           </tbody>
                    //         </table>
                    //           `,
                    //           `
                    //           <table>
                    //             <thead>
                    //               <tr>
                    //                 <th colspan="3">Вітаміни</th>
                    //               </tr>
                    //             </thead>
                    //             <tbody>
                    //               <tr>
                    //                 <td>Вітамін А</td>
                    //                 <td>мкг</td>
                    //                 <td>95</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін D</td>
                    //                 <td>мкг</td>
                    //                 <td>1,7 </td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін Е</td>
                    //                 <td>мг <br>(α-TE)</td>
                    //                 <td>1,5 </td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін К</td>
                    //                 <td>мкг</td>
                    //                 <td>6,1</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Тіамін</td>
                    //                 <td>мг</td>
                    //                 <td>0,19</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Рибофлавін</td>
                    //                 <td>мг</td>
                    //                 <td>0,20</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Ніацин</td>
                    //                 <td>мг NЕ/ <br>мг</td>
                    //                 <td>2,3/ 0,58</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Пантотенова кислота</td>
                    //                 <td>мг</td>
                    //                 <td>0,66</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін В<sub>6</sub></td>
                    //                 <td>мг</td>
                    //                 <td>0,21</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Фолієва кислота</td>
                    //                 <td> мкг</td>
                    //                 <td>33</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін В<sub>12</sub></td>
                    //                 <td> мкг</td>
                    //                 <td>0,30</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Біотин</td>
                    //                 <td> мкг</td>
                    //                 <td>5,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін С</td>
                    //                 <td> мг</td>
                    //                 <td>13</td>
                    //               </tr>
                    //             </tbody>
                    //           </table>
                    //           `,
                    //           `
                    //           <table>
                    //             <thead>
                    //               <tr>
                    //                 <th colspan="3">Мінеральні речовини</th>
                    //               </tr>
                    //             </thead>
                    //             <tbody>
                    //               <tr>
                    //                 <td>Натрій</td>
                    //                 <td> мг</td>
                    //                 <td>81</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Калій</td>
                    //                 <td>мг</td>
                    //                 <td>150</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Хлориди</td>
                    //                 <td>мг</td>
                    //                 <td>80</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Кальцій</td>
                    //                 <td>мг</td>
                    //                 <td>112</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Фосфор</td>
                    //                 <td>мг</td>
                    //                 <td>91</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Магній</td>
                    //                 <td>мг</td>
                    //                 <td>22</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Залізо</td>
                    //                 <td>мг</td>
                    //                 <td>2,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Цинк</td>
                    //                 <td>мг</td>
                    //                 <td>1,5</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Мідь</td>
                    //                 <td>мг</td>
                    //                 <td>0,23</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Марганець</td>
                    //                 <td>мг</td>
                    //                 <td>0,41</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Фториди</td>
                    //                 <td>мг</td>
                    //                 <td>0,13</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Молібден</td>
                    //                 <td>мкг</td>
                    //                 <td>13</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Селен</td>
                    //                 <td>мкг</td>
                    //                 <td>7,5</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Хром</td>
                    //                 <td>мкг</td>
                    //                 <td>8,3</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Йод</td>
                    //                 <td>мкг</td>
                    //                 <td>17</td>
                    //               </tr>
                    //             </tbody>
                    //           </table>
                    //           `,
                    //           `
                    //           <table>
                    //             <thead>
                    //               <tr>
                    //                 <th colspan="3">Інші</th>
                    //               </tr>
                    //             </thead>
                    //             <tbody>
                    //               <tr>
                    //                 <td>Каротиноїди</td>
                    //                 <td>мг</td>
                    //                 <td>0,25</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Холін</td>
                    //                 <td>мг</td>
                    //                 <td>46</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Осмолярність
                    //                 </td>
                    //                 <td>мОсмоль/л</td>
                    //                 <td>270</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вода
                    //                 </td>
                    //                 <td>мл</td>
                    //                 <td>79</td>
                    //               </tr>
                    //             </tbody>
                    //           </table>
                    //           `,
                    //         ],
                    //       },
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Про продукт",
                    //       content: [
                    //         "<p><strong>Важлива інформація:</strong> <br> Тільки для ентерального застосування! Не застосовувати парентерально! Застосовувати тільки під наглядом лікаря! Може бути використане як єдине джерело харчування. З обережністю застосовувати для дітей віком від 3 до 6 років. Не є лікарським засобом.</p>",
                    //         "<p><strong>Протипоказання:</strong> <br> Не використовувати для дітей віком до 3 років. Не використовувати хворим на галактоземію. Не використовувати пацієнтам, які потребують дієти без вмісту харчових волокон. Не використовувати у разі підвищеної чутливості до окремих компонентів продукту. Забороняється вводити внутрішньовенно.</p>",
                    //         "<p><strong>Форма випуску:</strong> рідка суміш у спадаючій пластиковій пляшці, об'ємом 500 мл e.</p>",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "застосування",
                    //       content: [
                    //         "<p><strong>Спосіб застосування:</strong><br> Перед застосуванням перевірити зовнішній вигляд продукту, добре збовтати. Не слід розбавляти продукт та додавати лікарські засоби. Застосовувати суміш кімнатної температури.</p>",
                    //       ],
                    //     },
                    //   ],
                    // },
                    // 7
                    //  {
                    //   titlePreviev: "Нутрізон Протеїн Едванс",
                    //   titleSingle: "Нутрізон Протеїн Едванс",
                    //   titleSingleEn: "Nutrison Protein Advance",
                    //   image: ["13.png"],
                    //   accordions: [
                    //     {
                    //       isActive: false,
                    //       title: "Характеристики*",
                    //       content: [
                    //         "<p>Рідка, готова до вживання, спеціалізована, високобілкова суміш із сумішшю харчових волокон MF6 і помірно підвищеною енергетичною цінністю. Нутрізон Протеїн Едванс призначено для дорослих пацієнтів і дітей від 3 років у критичних станах, що мають підвищені потреби в білку і помірні потреби в енергії. Для пацієнтів на етапі реабілітації в інтенсивній терапії, для пацієнтів із сепсисом, травмами, опіками у випадках нескомпрометованого ШКТ.</p>",
                    //       ],
                    //       list: [
                    //         "• Призначений, у першу чергу, для пацієнтів з підвищеними потребами в білку з важкими травмами, опіками, сепсисом.",
                    //         "• Модифікований склад білка: поєднання молочних (казеїн – 25%, сироватковий – 35%) і рослинних (20% соєвий та 20% бобовий) білків сприяє швидкому звільненню шлунку та гарному засвоєнню.",
                    //         "• Згідно останніх рекомендацій, пацієнти з важкою травмою та опіками повинні отримувати велику кількість білка і помірно підвищену кількість енергії, оскільки надмірне надходження високоенергетичних продуктів може негативно впливати на перебіг захворювання.",
                    //         "• Містить комбінацію з 6 розчинних і нерозчинних харчових волокон MF6. Нерозчинні волокна нормалізують перистальтику кишківника (профілактика діареї та парезу), а розчинні волокна забезпечують пребіотичний ефект, оскільки є поживним середовищем для нормальної мікрофлори кишківника.",
                    //         "• Мікроелементи (хром, селен, мідь) забезпечують антиоксидантний захист й імуномоделюючу дію.",
                    //         "• Не містить клінічно значущих лактози, галактози, глютену, холестерину.",
                    //         "• Не містить генетично модифікованих компонентів.",
                    //       ],
                    //       links: [
                    //         "<strong>* </strong>відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                    //         "<strong>1.</strong> International Society for the Study of Fatty Acids and Lipids (ISSFAL) Report of th sub-committee on recommendations for intake of polysaturated fatty acids in healthy adults. June 2004.",
                    //         "<strong>2.</strong> Food and Agriculture Organization (FAO). Fats and fatty acids in human nutrition; report of an expert consultation. 10-14 November 2008; Geneva. FAO Food ans Nutrition Paper; 91.",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Показання до застосування*",
                    //       content: [
                    //         "<p>Для пацієнтів на етапі реабілітації в інтенсивній терапії, для пацієнтів із сепсисом, травмами, опіками у випадках нескомпрометованого ШКТ.</p>",
                    //         "<p>Може використовуватися для зондового харчування як єдине чи додаткове джерело харчування у випадках, пов’язаних із нутритивною недостатністю у пацієнтів, які потребують зондового харчування, на етапі реабілітації в інтенсивній терапії, для пацієнтів із сепсисом,  поліорганними травмами, опіками, раком, у післяопераційний період за гіперкатаболізму. Нутрізон Едванст Протізон як єдине джерело харчування показано пацієнтам із метаболічним стресом, високою потребою в білку, яким необхідна дієта, багата на клітковину.</p>",
                    //       ],
                    //       links: [
                    //         "<strons>*</strons> відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a>https://www.espen.org/guidelines-home</a>",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Склад",
                    //       content: [
                    //         "<p>Вода, мальтодекстрин, білок з сироватки (з коров’ячого <strong>молока</strong>), рослинні олії (соняшникова олія, рапсова олія, олія із середньоланцюговими тригліцеридами (кокосова олія, пальмоядрова олія)), казеїнат білка з коров’ячого <strong>молока</strong>, білок з гороху, харчові волокна (інулін, олігофруктоза, гуміарабік, полісахариди з <strong>сої</strong>, целюлоза, резистентний крохмаль), білок із <strong>сої, риб’ячий</strong> жир, емульгатор (<strong>соєвий</strong> лецитин), гідроксид калію, карбонат кальцію, гідроортофосфат магнію, хлорид кальцію, цитрат калію, каротиноїди (містить <strong>сою</strong>) (β-каротин, лютеїн, живиця лікопену з томатів), хлорид холіну, L-аскорбат натрію, гідроортофосфат кальцію, лактат заліза (II), сульфат цинку, нікотинамід, ретинілацетат, ацетат DL-альфа токоферолу, глюконат міді, сульфат марганцю (II), селеніт  натрію, D-пантотенат  кальцію,  холекальциферол, хлорид  хрому (ІІ),  D-біотин, гідрохлорид тіаміну, фолієва кислота, гідрохлорид піридоксину, рибофлавін, йодид калію, фторид натрію, молібдат натрію, фітоменадіон, ціанокобаламін. Без ГМО. Без глютену.</p>",
                    //       ],
                    //       tables: {
                    //         title: "Поживна цінність на 100 мл",
                    //         list: [
                    //           `
                    //           <table>
                    //           <thead>
                    //             <tr>
                    //               <th>Енергетична
                    //               цінність
                    //               </th>
                    //               <th>кДж/<br>ккал</th>
                    //               <th>540/128</th>
                    //             </tr>
                    //           </thead>
                    //           <tbody>
                    //             <tr>
                    //               <td>Жири, з них:</td>
                    //               <td>г</td>
                    //               <td>3,7 </td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– насичені</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>1,0  </span></td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– середньоланцюгові тригліцериди</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>0,5 </span></td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– мононенасичені</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>2,0 </span> </td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– поліненасичені</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>0,7  </span></td>
                    //             </tr>

                    //             <tr>
                    //               <td>Докозагексаєнова кислота (ДГК)</td>
                    //               <td>мг</td>
                    //               <td>20,4 </td>
                    //             </tr>
                    //             <tr>
                    //               <td>Ейкозапентаєнова кислота (ЕПК)</td>
                    //               <td>мг</td>
                    //               <td>30,0 </td>
                    //             </tr>
                    //             <tr>
                    //               <td>Вуглеводи, з них:</td>
                    //               <td>г</td>
                    //               <td>15,4 </td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– цукри</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>1,0 </span></td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– лактоза</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span><0,025 </span></td>
                    //             </tr>
                    //             <tr>
                    //               <td>Харчові волокна</td>
                    //               <td>г</td>
                    //               <td>1,5  </td>
                    //             </tr>
                    //             <tr>
                    //               <td>Білки</td>
                    //               <td>г</td>
                    //               <td>7,5 </td>
                    //             </tr>
                    //             <tr>
                    //               <td>Сіль</td>
                    //               <td>г</td>
                    //               <td>0,20 </td>
                    //             </tr>
                    //           </tbody>
                    //         </table>
                    //           `,
                    //           `
                    //           <table>
                    //             <thead>
                    //               <tr>
                    //                 <th colspan="3">Вітаміни</th>
                    //               </tr>
                    //             </thead>
                    //             <tbody>
                    //               <tr>
                    //                 <td>Вітамін А</td>
                    //                 <td>мкг</td>
                    //                 <td>95</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін D</td>
                    //                 <td>мкг</td>
                    //                 <td>1,7 </td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін Е</td>
                    //                 <td>мг <br>(α-TE)</td>
                    //                 <td>1,5 </td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін К</td>
                    //                 <td>мкг</td>
                    //                 <td>6,1</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Тіамін</td>
                    //                 <td>мг</td>
                    //                 <td>0,19</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Рибофлавін</td>
                    //                 <td>мг</td>
                    //                 <td>0,20</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Ніацин</td>
                    //                 <td>мг NЕ/ <br>мг</td>
                    //                 <td>2,3/ 0,58</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Пантотенова кислота</td>
                    //                 <td>мг</td>
                    //                 <td>0,66</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін В<sub>6</sub></td>
                    //                 <td>мг</td>
                    //                 <td>0,21</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Фолієва кислота</td>
                    //                 <td> мкг</td>
                    //                 <td>33</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін В<sub>12</sub></td>
                    //                 <td> мкг</td>
                    //                 <td>0,30</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Біотин</td>
                    //                 <td> мкг</td>
                    //                 <td>5,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін С</td>
                    //                 <td> мг</td>
                    //                 <td>13</td>
                    //               </tr>
                    //             </tbody>
                    //           </table>
                    //           `,
                    //           `
                    //           <table>
                    //             <thead>
                    //               <tr>
                    //                 <th colspan="3">Мінеральні речовини</th>
                    //               </tr>
                    //             </thead>
                    //             <tbody>
                    //               <tr>
                    //                 <td>Натрій</td>
                    //                 <td> мг</td>
                    //                 <td>81</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Калій</td>
                    //                 <td>мг</td>
                    //                 <td>150</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Хлориди</td>
                    //                 <td>мг</td>
                    //                 <td>80</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Кальцій</td>
                    //                 <td>мг</td>
                    //                 <td>112</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Фосфор</td>
                    //                 <td>мг</td>
                    //                 <td>91</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Магній</td>
                    //                 <td>мг</td>
                    //                 <td>22</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Залізо</td>
                    //                 <td>мг</td>
                    //                 <td>2,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Цинк</td>
                    //                 <td>мг</td>
                    //                 <td>1,5</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Мідь</td>
                    //                 <td>мг</td>
                    //                 <td>0,23</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Марганець</td>
                    //                 <td>мг</td>
                    //                 <td>0,41</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Фториди</td>
                    //                 <td>мг</td>
                    //                 <td>0,13</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Молібден</td>
                    //                 <td>мкг</td>
                    //                 <td>13</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Селен</td>
                    //                 <td>мкг</td>
                    //                 <td>7,5</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Хром</td>
                    //                 <td>мкг</td>
                    //                 <td>8,3</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Йод</td>
                    //                 <td>мкг</td>
                    //                 <td>17</td>
                    //               </tr>
                    //             </tbody>
                    //           </table>
                    //           `,
                    //           `
                    //           <table>
                    //             <thead>
                    //               <tr>
                    //                 <th colspan="3">Інші</th>
                    //               </tr>
                    //             </thead>
                    //             <tbody>
                    //               <tr>
                    //                 <td>Каротиноїди</td>
                    //                 <td>мг</td>
                    //                 <td>0,25</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Холін</td>
                    //                 <td>мг</td>
                    //                 <td>46</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Осмолярність
                    //                 </td>
                    //                 <td>мОсмоль/л</td>
                    //                 <td>270</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вода
                    //                 </td>
                    //                 <td>мл</td>
                    //                 <td>79</td>
                    //               </tr>
                    //             </tbody>
                    //           </table>
                    //           `,
                    //         ],
                    //       },
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Про продукт",
                    //       content: [
                    //         "<p><strong>Важлива інформація:</strong> <br> Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Може бути використане як єдине джерело харчування. З обережністю застосовувати для дітей віком від 3 до 6 років. Не є лікарським засобом.</p>",
                    //         "<p><strong>Протипоказання:</strong> <br> Не використовувати для дітей віком до 3 років. Не використовувати хворим на галактоземію. Не використовувати пацієнтам, які потребують дієти без вмісту харчових волокон. Не використовувати у разі підвищеної чутливості до окремих компонентів продукту. Забороняється вводити внутрішньовенно.</p>",
                    //         "<p><strong>Форма випуску:</strong> рідка суміш у спадаючій пластиковій пляшці, об'ємом 500 мл e.</p>",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "застосування",
                    //       content: [
                    //         "<p><strong>Спосіб застосування:</strong><br> Перед застосуванням перевірити зовнішній вигляд продукту, добре збовтати. Не слід розбавляти продукт та додавати лікарські засоби. Застосовувати суміш кімнатної температури.</p>",
                    //       ],
                    //     },
                    //   ],
                    // },
                    // 6
                    {
                        titlePreviev: "Нутрізон Едванст Діазон",
                        titleSingle: "Нутрізон Едванст Діазон",
                        titleSingleEn: "Nutrison Advanced Diason",
                        image: ["6.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p>Харчовий продукт для спеціальних медичних цілей: ентеральне харчування Нутрізон Едванст Діазон / Nutrison Advanced Diason – суміш рідка, повноцінна, збалансована, готова до вживання, з харчовими волокнами, для годування через зонд. Для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів з цукровим діабетом або гіперглікемією від 3 років і старше та дорослих. Продукт містить сліди лактози. Рідка, готова до застосування, ізокалорійна суміш (100 ккал/мл) для дітей старше 3 років і дорослих з діабетом 2 типу, стресорною гіперглікемією чи ризиком її виникнення та тих, які мають звичайні потреби в білку та енергії.</p>",
                                ],
                                list: [
                                    "• Має низький глікемічний індекс (17***).",
                                    "• Містить 100% соєвий білок. Соєвий білок позитивно впливає на пацієнтів з порушеною толерантністю до глюкози, у випадку гіперглікемії чи діабету.",
                                    "• Має знижений** вміст вуглеводів у вигляді фруктози (інсулінозалежне засвоєння) та крохмалю, який повільно розщеплюється і засвоюється, не викликаючи швидкого та різкого підвищення рівня глюкози у крові під час та після введення суміші.",
                                    "• Високий вміст мононенасичених жирних кислот для запобігання атеросклерозу. **",
                                    "• Високий вміст антиоксидантів (вітаміни С і Е, селен), які запобігають розвитку атеросклерозу. **",
                                    "• Містить комбінацію з 6 розчинних і нерозчинних харчових волокон MF6. Харчові волокна знижують глікемічний індекс. Нерозчинні волокна нормалізують перистальтику кишківника (профілактика діареї), а розчинні волокна забезпечують пребіотичний ефект, оскільки є поживним середовищем для нормальної мікрофлори кишківника.",
                                    "• Може містити сліди лактози, галактози, глютену, холестерину.",
                                    "• Не містить генетично модифікованих компонентів.",
                                ],
                                links: [
                                    "<strong>*</strong> у порівнянні зі стандартними формулами для ентерального харчування.",
                                    "<strong>**</strong> відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                                    "<strong>1.</strong> International Society for the Study of Fatty Acids and Lipids (ISSFAL) Report of th sub-committee on recommendations for intake of polysaturated fatty acids in healthy adults. June 2004.",
                                    "<strong>2.</strong> Food and Agriculture Organization (FAO). Fats and fatty acids in human nutrition; report of an expert consultation. 10-14 November 2008; Geneva. FAO Food ans Nutrition Paper; 91.",
                                    "<strong>***</strong> <a href='http://www.glycemicindex.com' target='_blank'>http://www.glycemicindex.com</a>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування*",
                                content: [
                                    "<p>Може бути використане для зондового застосування як єдине чи додаткове джерело харчування у дорослих і дітей від 3 років з діабетом 2 типу, стресорною гіперглікемією чи ризиком її виникнення. Під час підготовки до операції та у післяопераційний період. За критичних станів: опіків, сепсису, множинної травми, інсульту. У випадку захворювань шлунково-кишкового тракту (ШКТ): мукозитів, ентеритів різної етіології, зокрема спричинених променевою та хіміотерапією (холециститу, панкреатиту, фістул). За наявності часткових перешкод для проходження їжі: пухлин та травм голови і шиї, порушення ковтання і жування, стриктур та обструкції різних відділів шлунково-кишкового тракту. При станах, пов'язаних із втратою апетиту та/або відмовою від прийому їжі: онкологічних захворюваннях, неврологічних захворюваннях, психічних розладах, хворобах печінки, серцево-легеневій недостатності, ВІЛ-інфекції на стадії СНІДу. При недостатності харчування будь-якої етіології.</p>",
                                    "<p>Може бути використане для зондового харчування як єдине чи додаткове джерело харчування у випадках, пов'язаних з нутритивною недостатністю, у пацієнтів з діабетом 2 типу, стресорною гіперглікемією чи ризиком її виникнення, які потребують зондового харчування. Нутрізон Едванст Діазон, як єдине джерело харчування, показаний пацієнтам з діабетом 2 типу, стресорною гіперглікемією чи ризиком її виникнення з нормальною потребою в енергії та білку, яким необхідна дієта з низьким глікемічним індексом, багата на клітковину.</p>",
                                ],
                                links: [
                                    "<strong>*</strong> відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href='https://www.espen.org/guidelines-home' target='_blank'>https://www.espen.org/guidelines-home</a>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, крохмаль, білок із <strong>сої</strong>, рослинні олії (соняшникова олія, рапсова олія), фруктоза, харчові волокна (інулін, олігофруктоза, гуміарабік, полісахариди з сої, целюлоза, резистентний крохмаль), емульгатор (<strong>соєвий</strong> лецитин), цитрат калію, хлорид натрію, регулятор кислотності (лимонна кислота), хлорид калію, карбонат магнію, фосфат кальцію, каротиноїди (містить <strong>сою</strong>) (β-каротин, лютеїн, живиця лікопену з томатів), хлорид холіну, гідроортофосфат калію, гідроксид кальцію, L-аскорбат натрію, гідроксид калію, ацетат DL-альфа токоферолу, лактат заліза (II), сульфат цинку, нікотинамід, ретинілацетат, хлорид хрому (III), глюконат міді, сульфат марганцю (II), D-пантотенат кальцію, ціанокобаламін, селеніт натрію, D-біотин, фолієва кислота, холекальциферол, гідрохлорид тіаміну, гідрохлорид піридоксину, рибофлавін, фторид натрію, йодид калію, молібдат натрію, фітоменадіон. Без ГМО. Без глютену.</p>",
                                ],
                                list: [""],
                                links: [""],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                    <thead>
                      <tr>
                        <th>Енергетична
                        цінність
                        </th>
                        <th>кДж/<br>ккал</th>
                        <th>435/
                        103 </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Жири, з них:</td>
                        <td>г</td>
                        <td>4,2 </td>
                      </tr>
                      <tr>
                        <td><span>– насичені</span></td>
                        <td><span>г</span></td>
                        <td><span>0,5 </span></td>
                      </tr>
                      <tr>
                        <td><span>– мононенасичені</span></td>
                        <td><span>г</span></td>
                        <td><span>3,0</span> </td>
                      </tr>
                      <tr>
                        <td><span>– поліненасичені</span></td>
                        <td><span>г</span></td>
                        <td><span>0,7 </span></td>
                      </tr>

                      <tr>
                        <td>Вуглеводи, з них:</td>
                        <td>г</td>
                        <td>11,3 </td>
                      </tr>
                      <tr>
                        <td><span>– цукри</span></td>
                        <td><span>г</span></td>
                        <td><span>2,3 </span></td>
                      </tr>
                      <tr>
                        <td><span>– лактоза</span></td>
                        <td><span>г</span></td>
                        <td><span><0,006 </span></td>
                      </tr>
                      <tr>
                        <td>Харчові волокна</td>
                        <td>г</td>
                        <td>1,5  </td>
                      </tr>
                      <tr>
                        <td>Білки</td>
                        <td>г</td>
                        <td>4,3 </td>
                      </tr>
                      <tr>
                        <td>Сіль</td>
                        <td>г</td>
                        <td>0,25 </td>
                      </tr>
                    </tbody>
                  </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Вітаміни</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Вітамін А</td>
                          <td>мкг</td>
                          <td>82</td>
                        </tr>
                        <tr>
                          <td>Вітамін D</td>
                          <td>мкг</td>
                          <td>0,70</td>
                        </tr>
                        <tr>
                          <td>Вітамін Е</td>
                          <td>мг <br>(α-TE)</td>
                          <td>2,5 </td>
                        </tr>
                        <tr>
                          <td>Вітамін К</td>
                          <td>мкг</td>
                          <td>5,3</td>
                        </tr>
                        <tr>
                          <td>Тіамін</td>
                          <td>мг</td>
                          <td>0,15</td>
                        </tr>
                        <tr>
                          <td>Рибофлавін</td>
                          <td>мг</td>
                          <td>0,16</td>
                        </tr>
                        <tr>
                          <td>Ніацин</td>
                          <td>мг NЕ/ <br>мг</td>
                          <td>1,8/0,89</td>
                        </tr>
                        <tr>
                          <td>Пантотенова кислота</td>
                          <td>мг</td>
                          <td>0,53</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>6</sub></td>
                          <td>мг</td>
                          <td>0,17</td>
                        </tr>
                        <tr>
                          <td>Фолієва кислота</td>
                          <td> мкг</td>
                          <td>38</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>12</sub></td>
                          <td> мкг</td>
                          <td>0,50</td>
                        </tr>
                        <tr>
                          <td>Біотин</td>
                          <td> мкг</td>
                          <td>4,0</td>
                        </tr>
                        <tr>
                          <td>Вітамін С</td>
                          <td> мг</td>
                          <td>15</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Мінеральні речовини</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Натрій</td>
                          <td> мг</td>
                          <td>100</td>
                        </tr>
                        <tr>
                          <td>Калій</td>
                          <td>мг</td>
                          <td>150</td>
                        </tr>
                        <tr>
                          <td>Хлориди</td>
                          <td>мг</td>
                          <td>125</td>
                        </tr>
                        <tr>
                          <td>Кальцій</td>
                          <td>мг</td>
                          <td>80</td>
                        </tr>
                        <tr>
                          <td>Фосфор</td>
                          <td>мг</td>
                          <td>72</td>
                        </tr>
                        <tr>
                          <td>Магній</td>
                          <td>мг</td>
                          <td>23</td>
                        </tr>
                        <tr>
                          <td>Залізо</td>
                          <td>мг</td>
                          <td>1,6</td>
                        </tr>
                        <tr>
                          <td>Цинк</td>
                          <td>мг</td>
                          <td>1,2</td>
                        </tr>
                        <tr>
                          <td>Мідь</td>
                          <td>мг</td>
                          <td>0,18</td>
                        </tr>
                        <tr>
                          <td>Марганець</td>
                          <td>мг</td>
                          <td>0,33</td>
                        </tr>
                        <tr>
                          <td>Фториди</td>
                          <td>мг</td>
                          <td>0,10</td>
                        </tr>
                        <tr>
                          <td>Молібден</td>
                          <td>мкг</td>
                          <td>10</td>
                        </tr>
                        <tr>
                          <td>Селен</td>
                          <td>мкг</td>
                          <td>7,5</td>
                        </tr>
                        <tr>
                          <td>Хром</td>
                          <td>мкг</td>
                          <td>12</td>
                        </tr>
                        <tr>
                          <td>Йод</td>
                          <td>мкг</td>
                          <td>13</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Інші</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Каротиноїди</td>
                          <td>мг</td>
                          <td>0,20</td>
                        </tr>
                        <tr>
                          <td>Холін</td>
                          <td>мг</td>
                          <td>37</td>
                        </tr>
                        <tr>
                          <td>Осмолярність
                          </td>
                          <td>мОсмоль/л</td>
                          <td>300</td>
                        </tr>
                        <tr>
                          <td>Вода
                          </td>
                          <td>мл</td>
                          <td>84</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    "<p><strong>Важлива інформація:</strong> <br> Тільки для ентерального застосування! Не застосовувати парентерально! <strong>Застосовувати тільки під наглядом лікаря!</strong> Може бути використане як єдине джерело харчування. З обережністю застосовувати для дітей віком від 3 до 6 років. Не є лікарським засобом. </p>",
                                    "<p><strong>Протипоказання:</strong><br>  Не використовувати для дітей віком до 3 років. Не використовувати пацієнтам, які потребують дієти без вмісту харчових волокон. Не використовувати хворим на фруктоземію чи тих, які мають підвищену чутливість до окремих компонентів продукту. Забороняється вводити внутрішньовенно.</p>",
                                    "<p>Форма випуску: рідка суміш у спадаючій пластиковій пляшці, об'ємом 1000 мл e.</p>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    "<p><strong>Спосіб застосування:</strong><br> Перед застосуванням перевірити зовнішній вигляд продукту, добре збовтати. Не слід розбавляти продукт та додавати лікарські засоби. Застосовувати суміш кімнатної температури.</p>",
                                ],
                            },
                        ],
                    },
                    // 5
                    {
                        titlePreviev: "Нутрізон Едванст Кубізон",
                        titleSingle: "Нутрізон Едванст Кубізон",
                        titleSingleEn: "Nutrison Advanced Cubison",
                        image: ["5.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p>Харчовий продукт для спеціальних медичних цілей: ентеральне харчування Нутрізон Едванст Кубізон / Nutrison Advanced Cubison – суміш рідка, з високим вмістом білка, повноцінна, збалансована, готова до вживання, містить харчові волокна, аргінін і відповідні вітаміни та мікроелементи, для годування через зонд. Для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів з хронічними ранами від 3 років і старше та дорослих. Продукт містить сліди лактози.</p>",
                                ],
                                list: [
                                    "• Нутрізон Едванст Кубізон призначено, в першу чергу, для пацієнтів із підвищеними потребами в білку з важкими травмами, опіками, пролежнями, синдромом діабетичної стопи, трофічними виразками.",
                                    "• Високий вміст молочного білка – 100% казеїну, необхідного для загоєння ран.",
                                    "• Нутрізон Едванст Кубізон містить доданий аргінін, який є умовно незамінною амінокислотою, що відіграє важливу роль у загоєнні ран.",
                                    "• Містить комбінацію з 6 розчинних і нерозчинних харчових волокон MF6. Нерозчинні волокна нормалізують перистальтику кишківника (профілактика діареї та парезу), а розчинні волокна забезпечують пребіотичний ефект, оскільки є поживним середовищем для нормальної мікрофлори кишківника, джерелом коротколанцюгових жирних кислот (місцевий трофічний ефект – прискорення регенерації та загоєння слизової оболонки кишківника). Продукт підходить для пацієнтів, що не мають обмежень щодо прийому харчових волокон.",
                                    "• Має оптимальне співвідношення поліненасичених жирних кислот ω6:ω3, що сприяє посиленню антиоксидантного та імуномоделюючого ефекту.",
                                    "• Високий вміст 6 видів натуральних каротиноїдів, вітамінів групи B, C, E та мікроелементів (хром, селен, мідь) забезпечує антиоксидантний захист та імуномоделюючу дію.",
                                    "• Не містить клінічно значущих лактози, глютену, холестерину.",
                                ],
                                links: [
                                    "<strong>* </strong> згідно з науковими дослідженнями та рекомендаціями для дієтичного харчування пацієнтів з хронічними ранами, цей перелік не є вичерпним:",
                                    "<strong>1.</strong>  Cereda et al. A nutritional formula enriched with arginine, zinc, and antioxidants for the healing of pressure ulcers: a randomized trial, Annals of Internal Medicine, 2015; 162:167-174. ",
                                    "<strong>2.</strong>  Aquilani et al., Effect of calorie-protein supplementation on the cognitive recovery of patients with subacute stroke, Nutritional Neuroscience 2008 Vol. 11: 235-240.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування*",
                                content: [
                                    "<p>Може використовуватися для зондового харчування, як єдине чи додаткове джерело харчування, у випадках, пов'язаних з нутритивною недостатністю у пацієнтів, які потребують зондового харчування. Нутрізон Едванст Кубізон як єдине джерело харчування показано пацієнтам з підвищеною потребою в білку, яким необхідна дієта, багата на клітковину, з імуностимулюючими складовими.</p>",
                                    "<p>Стани, що пов'язані із втратою апетиту та/або відмовою від прийому їжі <sup>**</sup>:</p>",
                                ],
                                list: [
                                    "• лежачі хворі з пролежнями",
                                    "• з порушеннями загоєння ран",
                                    "• після інсульту в хронічній фазі та під час одужання",
                                    "• пацієнти з синдромом діабетичної стопи",
                                    "• після операції та в період реабілітації",
                                    "• з підвищеною потребою в білку і енергії. У випадку бульозного епідермолізу.",
                                    "• при нутритивній недостатності (мальнутриції).",
                                ],
                                links: [
                                    "<strong>* </strong>згідно з науковими дослідженнями та рекомендаціями для дієтичного харчування пацієнтів з хронічними ранами, цей перелік не є вичерпним:",
                                    "<strong>1.</strong> Cereda et al. A nutritional formula enriched with arginine, zinc, and antioxidants for the healing of pressure ulcers: a randomized trial, Annals of Internal Medicine, 2015; 162:167-174.",
                                    "<strong>2.</strong> Aquilani et al., Effect of calorie-protein supplementation on the cognitive recovery of patients with subacute stroke, NutritionalNeuroscience 2008 Vol. 11: 235-240.",
                                    "<strong>**</strong> Shukla J1, Chatterjee S, Thakur VS, Premachandran S, Checker R, Poduval TB. L-Arginine reverses radiation-induced immune dysfunction: the need for optimum treatment window. Radiat Res. 2009 Feb;171(2):180-7. doi: 10.1667/RR1241.1.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, мальтодекстрин, казеїнати білка з коров'ячого <strong>молока</strong>, рослинні олії (рапсова олія, соняшникова олія, олія із середньоланцюговими тригліцеридами (кокосова олія, пальмоядрова олія)), харчові волокна (полісахариди з <strong>сої</strong>, резистентний крохмаль, інулін, гуміарабік, целюлоза, олігофруктоза), L-аргінін, регулятор кислотності (лимонна кислота), емульгатор (<strong>соєвий</strong> лецитин), цитрат калію, хлорид калію, хлорид натрію, L-аскорбат натрію, каротиноїди (містить <strong>сою</strong>) (β-каротин, лютеїн, живиця лікопену з томатів), цитрат натрію, гідроортофосфат магнію, фосфат кальцію, хлорид холіну, гідроортофосфат калію, гідроксид кальцію, гідроксид магнію, ацетат DL-альфа токоферолу, гідроксид калію, лактат заліза (II), сульфат цинку, нікотинамід, ретинілацетат, глюконат міді, сульфат марганцю (II), D-пантотенат кальцію, D-біотин, фолієва кислота, гідрохлорид піридоксину, холекальциферол, гідрохлорид тіаміну, ціанокобаламін, рибофлавін, фторид натрію, селеніт натрію, йодид калію, фітоменадіон, хлорид хрому (III), молібдат натрію. Без ГМО. Без глютену.</p>",
                                ],
                                list: [""],
                                links: [""],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                    <thead>
                      <tr>
                        <th>Енергетична
                        цінність
                        </th>
                        <th>кДж/<br>ккал</th>
                        <th>435/104 </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Жири, з них:</td>
                        <td>г</td>
                        <td>3,3 </td>
                      </tr>
                      <tr>
                        <td><span>– насичені</span></td>
                        <td><span>г</span></td>
                        <td><span>1,2 </span></td>
                      </tr>
                      <tr>
                        <td><span>– середньоланцюгові тригліцериди</span></td>
                        <td><span>г</span></td>
                        <td><span>0,9 </span> </td>
                      </tr>
                      <tr>
                        <td><span>– мононенасичені</span></td>
                        <td><span>г</span></td>
                        <td><span>1,4 </span> </td>
                      </tr>
                      <tr>
                        <td><span>– поліненасичені</span></td>
                        <td><span>г</span></td>
                        <td><span>0,7  </span></td>
                      </tr>

                      <tr>
                        <td>Вуглеводи, з них:</td>
                        <td>г</td>
                        <td>12,5 </td>
                      </tr>
                      <tr>
                        <td><span>– цукри</span></td>
                        <td><span>г</span></td>
                        <td><span>1,0 </span></td>
                      </tr>
                      <tr>
                        <td><span>– лактоза</span></td>
                        <td><span>г</span></td>
                        <td><span><0,025 </span></td>
                      </tr>
                      <tr>
                        <td>Харчові волокна</td>
                        <td>г</td>
                        <td>1,5  </td>
                      </tr>
                      <tr>
                        <td>Білки, з них:</td>
                        <td>г</td>
                        <td>5,5 </td>
                      </tr>
                      <tr>
                        <td><span>L-аргінін</span></td>
                        <td><span>г</span></td>
                        <td><span>0,85 </span></td>
                      </tr>
                      <tr>
                        <td>Сіль</td>
                        <td>г</td>
                        <td>0,25</td>
                      </tr>
                    </tbody>
                  </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Вітаміни</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Вітамін А</td>
                          <td>мкг</td>
                          <td>82</td>
                        </tr>
                        <tr>
                          <td>Вітамін D</td>
                          <td>мкг</td>
                          <td>0,70 </td>
                        </tr>
                        <tr>
                          <td>Вітамін Е</td>
                          <td>мг <br>(α-TE)</td>
                          <td>7,5</td>
                        </tr>
                        <tr>
                          <td>Вітамін К</td>
                          <td>мкг</td>
                          <td>5,3</td>
                        </tr>
                        <tr>
                          <td>Тіамін</td>
                          <td>мг</td>
                          <td>0,15</td>
                        </tr>
                        <tr>
                          <td>Рибофлавін</td>
                          <td>мг</td>
                          <td>0,19</td>
                        </tr>
                        <tr>
                          <td>Ніацин</td>
                          <td>мг NЕ/ <br>мг</td>
                          <td>1,8/0,71</td>
                        </tr>
                        <tr>
                          <td>Пантотенова кислота</td>
                          <td>мг</td>
                          <td>0,53</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>6</sub></td>
                          <td>мг</td>
                          <td>0,20</td>
                        </tr>
                        <tr>
                          <td>Фолієва кислота</td>
                          <td> мкг</td>
                          <td>30</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>12</sub></td>
                          <td> мкг</td>
                          <td>0,24</td>
                        </tr>
                        <tr>
                          <td>Біотин</td>
                          <td> мкг</td>
                          <td>4,0</td>
                        </tr>
                        <tr>
                          <td>Вітамін С</td>
                          <td> мг</td>
                          <td>38</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Мінеральні речовини</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Натрій</td>
                          <td> мг</td>
                          <td>100</td>
                        </tr>
                        <tr>
                          <td>Калій</td>
                          <td>мг</td>
                          <td>150</td>
                        </tr>
                        <tr>
                          <td>Хлориди</td>
                          <td>мг</td>
                          <td>125</td>
                        </tr>
                        <tr>
                          <td>Кальцій</td>
                          <td>мг</td>
                          <td>80</td>
                        </tr>
                        <tr>
                          <td>Фосфор</td>
                          <td>мг</td>
                          <td>72</td>
                        </tr>
                        <tr>
                          <td>Магній</td>
                          <td>мг</td>
                          <td>23</td>
                        </tr>
                        <tr>
                          <td>Залізо</td>
                          <td>мг</td>
                          <td>1,6</td>
                        </tr>
                        <tr>
                          <td>Цинк</td>
                          <td>мг</td>
                          <td>2,0</td>
                        </tr>
                        <tr>
                          <td>Мідь</td>
                          <td>мг</td>
                          <td>0,20</td>
                        </tr>
                        <tr>
                          <td>Марганець</td>
                          <td>мг</td>
                          <td>0,38</td>
                        </tr>
                        <tr>
                          <td>Фториди</td>
                          <td>мг</td>
                          <td>0,10</td>
                        </tr>
                        <tr>
                          <td>Молібден</td>
                          <td>мкг</td>
                          <td>10</td>
                        </tr>
                        <tr>
                          <td>Селен</td>
                          <td>мкг</td>
                          <td>9,6</td>
                        </tr>
                        <tr>
                          <td>Хром</td>
                          <td>мкг</td>
                          <td>6,7</td>
                        </tr>
                        <tr>
                          <td>Йод</td>
                          <td>мкг</td>
                          <td>13</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Інші</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Каротиноїди</td>
                          <td>мг</td>
                          <td>0,23</td>
                        </tr>
                        <tr>
                          <td>Холін</td>
                          <td>мг</td>
                          <td>37</td>
                        </tr>
                        <tr>
                          <td>Осмолярність
                          </td>
                          <td>мОсмоль/л</td>
                          <td>315</td>
                        </tr>
                        <tr>
                          <td>Вода
                          </td>
                          <td>мл</td>
                          <td>83</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    "<p><strong>Важлива інформація:</strong> <br> Тільки для ентерального застосування! Не застосовувати парентерально! Застосовувати тільки під наглядом лікаря! Може бути використане як єдине джерело харчування. З обережністю застосовувати для дітей віком від 3 до 6 років. Не є лікарським засобом. </p>",
                                    "<p><strong>Протипоказання:</strong> <br> Не використовувати для дітей віком до 3 років. Не використовувати хворим на галактоземію. Не використовувати пацієнтам, які потребують дієти без вмісту харчових волокон. Не рекомендовано для застосування критично хворим пацієнтам. Не рекомендовано пацієнтам з підвищеною чутливістю до окремих компонентів продукту.Забороняється вводити внутрішньовенно. </p>",
                                    "<p><strong>Форма випуску:</strong> рідка суміш у спадаючій пластиковій пляшці, об'ємом 1000 мл e.</p>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    "<p><strong>Спосіб застосування:<strong><br> Перед застосуванням перевірити зовнішній вигляд продукту, добре збовтати. Не слід розбавляти продукт та додавати лікарські засоби. Застосовувати суміш кімнатної температури.</p>",
                                ],
                            },
                        ],
                    },
                    // 8
                    {
                        titlePreviev: "Нутрізон з харчовими волокнами",
                        titleSingle: "Нутрізон з харчовими волокнами",
                        titleSingleEn: "Nutrison Multi Fibre",
                        image: ["8.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p>Харчовий продукт для спеціальних медичних цілей: ентеральне харчування Нутрізон з харчовими волокнами / Nutrison Multi Fibre – суміш рідка, повноцінна, збалансована, з харчовими волокнами для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів, які потребують ентерального харчування, від 3 років і старше, а також для дорослих, для годування через зонд, готовий до вживання. Продукт містить сліди лактози.</p>",
                                ],
                                list: [
                                    "• Повноцінний, збалансований продукт для зондового харчування (1 ккал/мл).",
                                    "• Модифікований склад білка: поєднання молочних (казеїн – 25%, сироватковий – 35%) і рослинних (20% соєвий та 20% бобовий) білків сприяє швидкому звільненню шлунку та гарному засвоєнню.",
                                    "• Наявність середньоланцюгових тригліцеридів забезпечує легке засвоєння жирового компонента у випадку ферментативної (ліпазної) недостатності.",
                                    "• Має оптимальне співвідношення поліненасичених жирних кислот ω6:ω3, збагачений ейкозапентаєновою та докозагексаєновою кислотами, що забезпечує найбільший протизапальний і імуномодулюючий ефект.",
                                    "• Збагачення натуральними каротиноїдами, вітамінами B, C, E та мікроелементами (хром, селен, мідь) забезпечує антиоксидантний захист.",
                                    "• Містить комбінацію з 6 розчинних і нерозчинних харчових волокон MF6. Нерозчинні волокна нормалізують перистальтику кишківника (профілактика діареї та закрепів), а розчинні волокна забезпечують пребіотичний ефект, оскільки є поживним середовищем для нормальної мікрофлори кишківника, джерелом коротколанцюгових жирних кислот (місцевий трофічний ефект – прискорення регенерації та загоєння слизової оболонки кишківника). Продукт підходить для пацієнтів, що не мають обмежень щодо прийому харчових волокон.",
                                    "• Не містить глютену, холестерину.",
                                    "• Не містить генетично модифікованих компонентів.",
                                ],
                                links: [
                                    "<strong>* </strong>відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                                    "<strong>1.</strong> International Society for the Study of Fatty Acids and Lipids (ISSFAL) Report of th sub-committee on recommendations for intake of polysaturated fatty acids in healthy adults. June 2004.",
                                    "<strong>2.</strong> Food and Agriculture Organization (FAO). Fats and fatty acids in human nutrition; report of an expert consultation. 10-14 November 2008; Geneva. FAO Food ans Nutrition Paper; 91.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування*",
                                content: [
                                    "<p>Може бути використане для зондового харчування як єдине або додаткове джерело харчування у випадках, пов’язаних із нутритивною недостатністю у пацієнтів, які потребують зондового харчування. Нутрізон з харчовими волокнами як єдине джерело харчування показано пацієнтам з нормальною потребою в енергії та білку, яким необхідна дієта, багата на клітковину.</p>",
                                ],
                                list: [
                                    "<strong>До них належать:</strong>",
                                    "• пацієнти з недоїданням чи ризиком недоїдання",
                                    "• пацієнти з дисфагією",
                                    "• пацієнти з анорексією",
                                    "• пацієнти, які страждають на закреп або бактеріальну діарею, що потребують зондового харчування",
                                    "• виснажені пацієнти, які перенесли операцію в передопераційному періоді",
                                    "• виснажені пацієнти, що страждають на рак",
                                    "• пацієнти з хронічними захворюваннями",
                                ],
                                links: [
                                    "<strong>*</strong> відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href='https://www.espen.org/guidelines-home' target='_blank'>https://www.espen.org/guidelines-home</a>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, мальтодекстрин, рослинні олії (соняшникова олія, рапсова олія, олія з середньоланцюговими тригліцеридами (кокосова олія, пальмоядрова олія)), харчові волокна (<strong>соєві</strong> полісахариди, резистентний крохмаль, інулін, гуміарабік, целюлоза, олігофруктоза), білок з сироватки (з коров'ячого <strong> молока</strong>), казеїнат білка з коров'ячого <strong>молока</strong>, білок з гороху, білок із сої, емульгатор (<strong>соєвий</strong> лецитин), регулятор кислотності (лимонна кислота), хлорид натрію, <strong>риб'ячий жир</strong>, гідроксид калію, фосфат кальцію, гідроортофосфат калію, цитрат калію, каротиноїди (містить <strong>сою</strong>) (β-каротин, лютеїн, живиця лікопену з томатів), гідроксид кальцію, хлорид калію, хлорид холіну, гідроксид магнію, L-аскорбат натрію, гідроортофосфат магнію, лактат заліза (ІІ), сульфат цинку, нікотинамід, ретинілацетат, ацетат DL-альфа токоферолу, глюконат міді, сульфат марганцю (ІІ), селеніт натрію, D-пантотенат кальцію, хлорид хрому (ІІІ), холекальциферол, D-біотин, гідрохлорид тіаміну, фолієва кислота, гідрохлорид піридоксину, рибофлавін, йодид калію, фторид натрію, молібдат натрію, фітоменадіон, ціанокобаламін. Без ГМО. Без глютену.</p>",
                                ],
                                list: [""],
                                links: [""],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                    <thead>
                      <tr>
                        <th>Енергетична
                        цінність
                        </th>
                        <th>кДж/<br>ккал</th>
                        <th>430/
                        103 </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Жири, з них:</td>
                        <td>г</td>
                        <td>3,9</td>
                      </tr>
                      <tr>
                        <td><span>– насичені</span></td>
                        <td><span>г</span></td>
                        <td><span>1,0 </span></td>
                      </tr>
                      <tr>
                        <td><span>– мононенасичені</span></td>
                        <td><span>г</span></td>
                        <td><span>2,2 </span> </td>
                      </tr>
                      <tr>
                        <td><span>– поліненасичені</span></td>
                        <td><span>г</span></td>
                        <td><span>0,7 </span></td>
                      </tr>

                      <tr>
                        <td>Докозагексаєнова кислота (ДГК)</td>
                        <td>мг</td>
                        <td>13,6 </td>
                      </tr>
                      <tr>
                        <td>Ейкозапентаєнова кислота (ЕПК)</td>
                        <td>мг</td>
                        <td>20,0 </td>
                      </tr>
                      <tr>
                        <td>Вуглеводи, з них:</td>
                        <td>г</td>
                        <td>12,3 </td>
                      </tr>
                      <tr>
                        <td><span>– цукри</span></td>
                        <td><span>г</span></td>
                        <td><span>0,8 </span></td>
                      </tr>
                      <tr>
                        <td><span>– лактоза</span></td>
                        <td><span>г</span></td>
                        <td><span><0,025 </span></td>
                      </tr>
                      <tr>
                        <td>Харчові волокна</td>
                        <td>г</td>
                        <td>1,5 </td>
                      </tr>
                      <tr>
                        <td>Білки</td>
                        <td>г</td>
                        <td>4,0 </td>
                      </tr>
                      <tr>
                        <td>Сіль</td>
                        <td>г</td>
                        <td>0,25 </td>
                      </tr>
                    </tbody>
                  </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Вітаміни</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Вітамін А</td>
                          <td>мкг</td>
                          <td>82</td>
                        </tr>
                        <tr>
                          <td>Вітамін D</td>
                          <td>мкг</td>
                          <td>1,0 </td>
                        </tr>
                        <tr>
                          <td>Вітамін Е</td>
                          <td>мг <br>(α-TE)</td>
                          <td>1,3 </td>
                        </tr>
                        <tr>
                          <td>Вітамін К</td>
                          <td>мкг</td>
                          <td>5,3</td>
                        </tr>
                        <tr>
                          <td>Тіамін</td>
                          <td>мг</td>
                          <td>0,15</td>
                        </tr>
                        <tr>
                          <td>Рибофлавін</td>
                          <td>мг</td>
                          <td>0,16</td>
                        </tr>
                        <tr>
                          <td>Ніацин</td>
                          <td>мг NЕ/ <br>мг</td>
                          <td>1,8/ 0,90</td>
                        </tr>
                        <tr>
                          <td>Пантотенова кислота</td>
                          <td>мг</td>
                          <td>0,53</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>6</sub></td>
                          <td>мг</td>
                          <td>0,17</td>
                        </tr>
                        <tr>
                          <td>Фолієва кислота</td>
                          <td> мкг</td>
                          <td>27</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>12</sub></td>
                          <td> мкг</td>
                          <td>0,21</td>
                        </tr>
                        <tr>
                          <td>Біотин</td>
                          <td> мкг</td>
                          <td>4,0</td>
                        </tr>
                        <tr>
                          <td>Вітамін С</td>
                          <td> мг</td>
                          <td>10</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Мінеральні речовини</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Натрій</td>
                          <td> мг</td>
                          <td>100</td>
                        </tr>
                        <tr>
                          <td>Калій</td>
                          <td>мг</td>
                          <td>150</td>
                        </tr>
                        <tr>
                          <td>Хлориди</td>
                          <td>мг</td>
                          <td>125</td>
                        </tr>
                        <tr>
                          <td>Кальцій</td>
                          <td>мг</td>
                          <td>80 </td>
                        </tr>
                        <tr>
                          <td>Фосфор</td>
                          <td>мг</td>
                          <td>72</td>
                        </tr>
                        <tr>
                          <td>Магній</td>
                          <td>мг</td>
                          <td>23</td>
                        </tr>
                        <tr>
                          <td>Залізо</td>
                          <td>мг</td>
                          <td>1,6</td>
                        </tr>
                        <tr>
                          <td>Цинк</td>
                          <td>мг</td>
                          <td>1,2</td>
                        </tr>
                        <tr>
                          <td>Мідь</td>
                          <td>мг</td>
                          <td>0,18</td>
                        </tr>
                        <tr>
                          <td>Марганець</td>
                          <td>мг</td>
                          <td>0,33</td>
                        </tr>
                        <tr>
                          <td>Фториди</td>
                          <td>мг</td>
                          <td>0,10</td>
                        </tr>
                        <tr>
                          <td>Молібден</td>
                          <td>мкг</td>
                          <td>10</td>
                        </tr>
                        <tr>
                          <td>Селен</td>
                          <td>мкг</td>
                          <td>5,7</td>
                        </tr>
                        <tr>
                          <td>Хром</td>
                          <td>мкг</td>
                          <td>6,7</td>
                        </tr>
                        <tr>
                          <td>Йод</td>
                          <td>мкг</td>
                          <td>13</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Інші</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Каротиноїди</td>
                          <td>мг</td>
                          <td>0,20</td>
                        </tr>
                        <tr>
                          <td>Холін</td>
                          <td>мг</td>
                          <td>37</td>
                        </tr>
                        <tr>
                          <td>Осмолярність
                          </td>
                          <td>мОсмоль/л</td>
                          <td>250</td>
                        </tr>
                        <tr>
                          <td>Вода
                          </td>
                          <td>мл</td>
                          <td>83</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    "<p><strong>Важлива інформація:</strong> <br>  Тільки для ентерального застосування! Не застосовувати парентерально! Застосовувати тільки під наглядом лікаря! Може бути використане як єдине джерело харчування. З обережністю застосовувати для дітей віком від 3 до 6 років. Не є лікарським засобом. </p>",
                                    "<p><strong>Протипоказання:</strong> <br> Не використовувати для дітей віком до 3 років. Не використовувати хворим на галактоземію. Не використовувати у разі підвищеної чутливості до окремих компонентів продукту. Забороняється вводити внутрішньовенно.</p>",
                                    "<p><strong>Форма випуску:</strong> рідка суміш у спадаючій пластиковій пляшці об'ємом 1000 мл e.</p>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    "<p><strong>Спосіб застосування:</strong> Перед застосуванням перевірити зовнішній вигляд продукту, добре збовтати. Не слід розбавляти продукт та додавати лікарські засоби. Застосовувати суміш кімнатної температури.</p>",
                                ],
                            },
                        ],
                    },
                    // 2
                    {
                        titlePreviev: "Нутрізон Енергія",
                        titleSingle: "Нутрізон Енергія",
                        titleSingleEn: "Nutrison Energy",
                        image: ["2.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p>Харчовий продукт для спеціальних медичних цілей: ентеральне харчування Нутрізон Енергія / Nutrison Energy – суміш рідка, з високим вмістом енергії, повноцінна, збалансована, готова до вживання, для годування через зонд, для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів з підвищеною потребою в енергії  від 3 років і старше та дорослих.</p>",
                                ],
                                list: [
                                    "• Висококалорійний, повноцінний, збалансований продукт для зондового харчування (1,5 ккал/мл).",
                                    "• Високобілкова суміш  (6 г білка на 100 мл).",
                                    "• Модифікований склад білка: поєднання молочних (казеїн – 25%, сироватковий – 35%) і рослинних (20% соєвий та 20% бобовий) білків сприяє швидкому звільненню шлунку та доброму засвоєнню.",
                                    "• Наявність середньоланцюгових тригліцеридів (15%) забезпечує легке засвоєння жирового компонента у випадку ферментативної (ліпазної) недостатності.",
                                    "• Містить натуральні каротиноїди, вітамінами B, C, E та мікроелементи (хром, селен, мідь)  - забезпечує антиоксидантний захист.",
                                    "• Без глютену.",
                                    "• Не містить генетично модифікованих компонентів.",
                                    "• Запаковано в захисному середовищі. Продукт стерилізовано при ультрависокій температурі.",
                                ],
                                links: [
                                    "<strong>*</strong> відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                                    "<strong>1.</strong> International Society for the Study of Fatty Acids and Lipids (ISSFAL) Report of th sub-committee on recommendations for intake of polysaturated fatty acids in healthy adults. June 2004.",
                                    "<strong>2.</strong> Food and Agriculture Organization (FAO). Fats and fatty acids in human nutrition; report of an expert consultation. 10-14 November 2008; Geneva. FAO Food ans Nutrition Paper; 91.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування*",
                                content: [
                                    "<p>Може використовуватися для зондового харчування як єдине або додаткове джерело харчування у випадках, пов’язаних із нутритивною недостатністю у пацієнтів з підвищеною потребою в енергії. Нутрізон Енергія як єдине джерело харчування підходить пацієнтам з високими потребами у енергії та білках, яким необхідна дієта, зокрема, пацієнтам з недоїданням чи ризиком недоїдання, за необхідності, з обмеженням об'єму рідини, що подається. Застосовувати тільки під наглядом лікаря!</p>",
                                ],
                                links: [
                                    "<strong>*</strong> відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href='https://www.espen.org/guidelines-home' target='_blank'>https://www.espen.org/guidelines-home</a>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, мальтодекстрин, рослинні олії (соняшникова олія, рапсова олія, олія із середньоланцюговими тригліцеридами (кокосова олія, пальмоядрова олія)), білок з сироватки (з коров'ячого <strong>молока</strong>), рисове борошно, казеїнат білка з коров'ячого <strong>молока</strong>, білок із гороху, білок із сої, регулятор кислотності (лимонна кислота), емульгатор (<strong>соєвий</strong> лецитин), хлорид натрію, риб’ячий жир, цитрат калію, фосфат кальцію, гідроксид калію, гідроортофосфат калію, гідроксид кальцію, каротиноїди (містить сою) (β-каротин, лютеїн, живиця лікопену з томатів), хлорид холіну, хлорид калію, гідроксид магнію, L-аскорбат натрію, гідроортофосфат магнію, лактат заліза (II), сульфат цинку, нікотинамід, ретинілацетат, ацетат DL-альфа токоферолу, глюконат міді, сульфат марганцю (II), селеніт натрію, D-пантотенат кальцію, хлорид хрому (III), холекальциферол, D-біотин, гідрохлорид тіаміну, фолієва кислота, гідрохлорид піридоксину, рибофлавін, йодид калію, фторид натрію, молібдат натрію, фітоменадіон, ціанокобаламін. Без ГМО. Без глютену.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                    <thead>
                      <tr>
                        <th>Енергетична
                        цінність
                        </th>
                        <th>кДж/<br>ккал</th>
                        <th>630/
                        150 </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Жири, з них:</td>
                        <td>г</td>
                        <td>5,8 </td>
                      </tr>
                      <tr>
                        <td><span>– насичені</span></td>
                        <td><span>г</span></td>
                        <td><span>1,5 </span></td>
                      </tr>
                      <tr>
                        <td><span>– мононенасичені</span></td>
                        <td><span>г</span></td>
                        <td><span>3,3  </span> </td>
                      </tr>
                      <tr>
                        <td><span>– поліненасичені</span></td>
                        <td><span>г</span></td>
                        <td><span>1,1 </span></td>
                      </tr>
                      <tr>
                        <td>Докозагексаєнова кислота (ДГК)</td>
                        <td>мг</td>
                        <td>13,7</td>
                      </tr>
                      <tr>
                        <td>Ейкозапентаєнова кислота (ЕПК)</td>
                        <td>мг</td>
                        <td>20,0 </td>
                      </tr>
                      <tr>
                        <td>Вуглеводи, з них:</td>
                        <td>г</td>
                        <td>18,3 </td>
                      </tr>
                      <tr>
                        <td><span>– цукри</span></td>
                        <td><span>г</span></td>
                        <td><span>1,1 </span></td>
                      </tr>
                      <tr>
                        <td><span>– лактоза</span></td>
                        <td><span>г</span></td>
                        <td><span><0,025 </span></td>
                      </tr>
                      <tr>
                        <td>Харчові волокна</td>
                        <td>г</td>
                        <td><0,1 </td>
                      </tr>
                      <tr>
                        <td>Білки</td>
                        <td>г</td>
                        <td>6,0 </td>
                      </tr>
                      <tr>
                        <td>Сіль</td>
                        <td>г</td>
                        <td>0,34 </td>
                      </tr>
                    </tbody>
                  </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Вітаміни</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Вітамін А</td>
                          <td>мкг</td>
                          <td>123</td>
                        </tr>
                        <tr>
                          <td>Вітамін D</td>
                          <td>мкг</td>
                          <td>1,5 </td>
                        </tr>
                        <tr>
                          <td>Вітамін Е</td>
                          <td>мг <br>(α-TE)</td>
                          <td>1,9 </td>
                        </tr>
                        <tr>
                          <td>Вітамін К</td>
                          <td>мкг</td>
                          <td>8,0</td>
                        </tr>
                        <tr>
                          <td>Тіамін</td>
                          <td>мг</td>
                          <td>0,23</td>
                        </tr>
                        <tr>
                          <td>Рибофлавін</td>
                          <td>мг</td>
                          <td>0,24</td>
                        </tr>
                        <tr>
                          <td>Ніацин</td>
                          <td>мг NЕ/ <br>мг</td>
                          <td>2,7/1,3</td>
                        </tr>
                        <tr>
                          <td>Пантотенова кислота</td>
                          <td>мг</td>
                          <td>0,80</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>6</sub></td>
                          <td>мг</td>
                          <td>0,26</td>
                        </tr>
                        <tr>
                          <td>Фолієва кислота</td>
                          <td> мкг</td>
                          <td>40</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>12</sub></td>
                          <td> мкг</td>
                          <td>0,32</td>
                        </tr>
                        <tr>
                          <td>Біотин</td>
                          <td> мкг</td>
                          <td>6,0</td>
                        </tr>
                        <tr>
                          <td>Вітамін С</td>
                          <td> мг  </td>
                          <td>15</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Мінеральні речовини</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Натрій</td>
                          <td> мг</td>
                          <td>134</td>
                        </tr>
                        <tr>
                          <td>Калій</td>
                          <td>мг</td>
                          <td>201</td>
                        </tr>
                        <tr>
                          <td>Хлориди</td>
                          <td>мг</td>
                          <td>100</td>
                        </tr>
                        <tr>
                          <td>Кальцій</td>
                          <td>мг</td>
                          <td>108</td>
                        </tr>
                        <tr>
                          <td>Фосфор</td>
                          <td>мг</td>
                          <td>108</td>
                        </tr>
                        <tr>
                          <td>Магній</td>
                          <td>мг</td>
                          <td>34</td>
                        </tr>
                        <tr>
                          <td>Залізо</td>
                          <td>мг</td>
                          <td>2,4</td>
                        </tr>
                        <tr>
                          <td>Цинк</td>
                          <td>мг</td>
                          <td>1,8</td>
                        </tr>
                        <tr>
                          <td>Мідь</td>
                          <td>мг</td>
                          <td>0,27</td>
                        </tr>
                        <tr>
                          <td>Марганець</td>
                          <td>мг</td>
                          <td>0,50</td>
                        </tr>
                        <tr>
                          <td>Фториди</td>
                          <td>мг</td>
                          <td>0,15</td>
                        </tr>
                        <tr>
                          <td>Молібден</td>
                          <td>мкг</td>
                          <td>15</td>
                        </tr>
                        <tr>
                          <td>Селен</td>
                          <td>мкг</td>
                          <td>8,6</td>
                        </tr>
                        <tr>
                          <td>Хром</td>
                          <td>мкг</td>
                          <td>10</td>
                        </tr>
                        <tr>
                          <td>Йод</td>
                          <td>мкг</td>
                          <td>20</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Інші</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Каротиноїди</td>
                          <td>мг</td>
                          <td>0,30</td>
                        </tr>
                        <tr>
                          <td>Холін</td>
                          <td>мг</td>
                          <td>55</td>
                        </tr>
                        <tr>
                          <td>Осмолярність</td>
                          <td>мОсмоль/л</td>
                          <td>360</td>
                        </tr>
                        <tr>
                          <td>Вода</td>
                          <td>мл</td>
                          <td>78</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    "<p><strong>Важлива інформація:</strong> <br> Тільки для ентерального застосування! Не застосовувати парентерально! Застосовувати тільки під наглядом лікаря! Може бути використане як єдине джерело харчування. З обережністю застосовувати для дітей віком від 3 до 6 років. Не є лікарським засобом. </p>",
                                    "<p><strong>Протипоказання:</strong> <br> Не використовувати для дітей віком до 3 років. Не використовувати для хворих на галактоземію. Не рекомендовано для пацієнтів з підвищеною чутливістю до окремих компонентів продукту. Забороняється вводити внутрішньовенно.</p>",
                                    "<p><strong>Форма випуску:</strong> <br> рідка суміш у спадаючій пластиковій пляшці об'ємом 1000 мл e.</p>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    "<p><strong>Спосіб застосування:</strong><br> Перед застосуванням перевірити зовнішній вигляд продукту, добре збовтати. Не слід розбавляти продукт та додавати лікарські засоби. Застосовувати суміш кімнатної температури.</p>",
                                ],
                            },
                        ],
                    },
                    // 1
                    {
                        titlePreviev: "Нутрізон",
                        titleSingle: "Нутрізон",
                        titleSingleEn: "Nutrison",
                        image: ["1.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики*",
                                content: [
                                    "<p>Харчовий продукт для спеціальних медичних цілей: ентеральне харчування Нутрізон / Nutrison – суміш рідка, повноцінна, збалансована, готова до вживання, для годування через зонд, для дієтичного харчування при мальнутриції (нутритивній недостатності) для пацієнтів з підвищеною потребою в енергії  від 3 років і старше та дорослих.</p>",
                                ],
                                list: [
                                    "• Повноцінний, збалансований продукт для зондового харчування (1 ккал/мл). ",
                                    "• Модифікований склад білка: поєднання молочних (казеїн – 25%, сироватковий – 35%) і рослинних (20% соєвий та 20% бобовий) білків сприяє швидкому звільненню шлунку та доброму засвоєнню.",
                                    "• Наявність середньоланцюгових тригліцеридів забезпечує легке засвоєння жирового компонента у випадку ферментативної (ліпазної) недостатності.",
                                    "• Містить натуральні каротиноїди, вітаміни B, C, E та мікроелементи (хром, селен, мідь) - забезпечує антиоксидантний захист.",
                                    "• Не містить глютену.",
                                    "• Не містить генетично модифікованих компонентів.",
                                    "• Запаковано в захисному середовищі.Продукт стерилізовано при ультрависокій температурі.",
                                ],
                                links: [
                                    "<strong>* </strong> відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                                    "<strong>1.</strong>  International Society for the Study of Fatty Acids and Lipids (ISSFAL) Report of th sub-committee on recommendations for intake of polysaturated fatty acids in healthy adults. June 2004.",
                                    "<strong>2.</strong>  Food and Agriculture Organization (FAO). Fats and fatty acids in human nutrition; report of an expert consultation. 10-14 November 2008; Geneva. FAO Food ans Nutrition Paper; 91.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування*",
                                content: [
                                    "<p>Може використовуватися для зондового харчування, як єдине чи додаткове джерело харчування, у випадках, пов'язаних з нутритивною недостатністю у пацієнтів, які потребують зондового харчування. Нутрізон як єдине джерело харчування показано пацієнтам з нормальним рівнеменергії та білку.</p>",
                                ],
                                list: [
                                    "До них належать:",
                                    "• пацієнти з недоїданням чи ризиком недоїдання",
                                    "• пацієнти з дисфагією",
                                    "• пацієнти з анорексією",
                                    "• пацієнти з деменцією / недоумством",
                                    "• виснажені пацієнти в хірургії",
                                    "• пацієнти з хронічними захворюваннями",
                                    "• пацієнти з верхньою шлунково-кишковою непрохідністю та шлунково-кишковою функцією, що зберігається",
                                    "• пацієнти після операції на голові та шиї",
                                ],
                                links: [
                                    "* відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href='https://www.espen.org/guidelines-home' target='_blank'>https://www.espen.org/guidelines-home</a>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Вода, мальтодекстрин, рослинні олії (соняшникова олія, рапсова олія, олія із середньоланцюговими тригліцеридами (кокосова олія, пальмоядрова олія)), білок з сироватки (з коров'ячого молока), рисове борошно, казеїнат білка з коров'ячого молока, білок із гороху, білок із сої, регулятор кислотності (лимонна кислота), емульгатор (соєвий лецитин), хлорид натрію, риб’ячий жир, цитрат калію, фосфат кальцію, гідроксид калію, гідроортофосфат калію, гідроксид кальцію, каротиноїди (містить сою) (β-каротин, лютеїн, живиця лікопену з томатів), хлорид холіну, хлорид калію, гідроксид магнію, L-аскорбат натрію, гідроортофосфат магнію, лактат заліза (II), сульфат цинку, нікотинамід, ретинілацетат, ацетат DL-альфа токоферолу, глюконат міді, сульфат марганцю (II), селеніт натрію, D-пантотенат кальцію, хлорид хрому (III), холекальциферол, D-біотин, гідрохлорид тіаміну, фолієва кислота, гідрохлорид піридоксину, рибофлавін, йодид калію, фторид натрію, молібдат натрію, фітоменадіон, ціанокобаламін. Без ГМО. Без глютену.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                      <table>
                        <thead>
                          <tr>
                            <th>Енергетична
                            цінність
                            </th>
                            <th>кДж/
                            ккал</th>
                            <th>420/
                            100 </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Жири, з них:</td>
                            <td>г</td>
                            <td>3,9</td>
                          </tr>
                          <tr>
                            <td><span>– насичені</span></td>
                            <td><span>г</span></td>
                            <td><span>1,0</span></td>
                          </tr>
                          <tr>
                            <td><span>– мононенасичені</span></td>
                            <td><span>г</span></td>
                            <td><span>2,2</span> </td>
                          </tr>
                          <tr>
                            <td><span>– поліненасичені</span></td>
                            <td><span>г</span></td>
                            <td><span>0,7</span></td>
                          </tr>
                          <tr>
                            <td>Докозагексаєнова кислота (ДГК)</td>
                            <td>мг</td>
                            <td>13,6 </td>
                          </tr>
                          <tr>
                            <td>Ейкозапентаєнова кислота (ЕПК)</td>
                            <td>мг</td>
                            <td>20,0 </td>
                          </tr>
                          <tr>
                            <td>Вуглеводи, з них:</td>
                            <td>г</td>
                            <td>12,3 </td>
                          </tr>
                          <tr>
                            <td><span>– цукри</span></td>
                            <td><span>г</span></td>
                            <td><span>0,7</span></td>
                          </tr>
                          <tr>
                            <td><span>– лактоза</span></td>
                            <td><span>г</span></td>
                            <td><span><0,025</span></td>
                          </tr>
                          <tr>
                            <td>Харчові волокна</td>
                            <td>г</td>
                            <td><0,1 </td>
                          </tr>
                          <tr>
                            <td>Білки</td>
                            <td>г</td>
                            <td>4,0 </td>
                          </tr>
                          <tr>
                            <td>Сіль</td>
                            <td>г</td>
                            <td>0,26 </td>
                          </tr>
                        </tbody>
                      </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Вітаміни</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Вітамін А</td>
                          <td>мкг</td>
                          <td>82</td>
                        </tr>
                        <tr>
                          <td>Вітамін D</td>
                          <td>мкг</td>
                          <td>1,0 </td>
                        </tr>
                        <tr>
                          <td>Вітамін Е</td>
                          <td>мг <br>(α-TE)</td>
                          <td>1,3 </td>
                        </tr>
                        <tr>
                          <td>Вітамін К</td>
                          <td>мкг</td>
                          <td>5,3</td>
                        </tr>
                        <tr>
                          <td>Тіамін</td>
                          <td>мг</td>
                          <td>0,15</td>
                        </tr>
                        <tr>
                          <td>Рибофлавін</td>
                          <td>мг</td>
                          <td>0,16</td>
                        </tr>
                        <tr>
                          <td>Ніацин</td>
                          <td>мг NЕ/ <br>мг</td>
                          <td>1,8/ 0,91</td>
                        </tr>
                        <tr>
                          <td>Пантотенова кислота</td>
                          <td>мг</td>
                          <td>0,53</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>6</sub></td>
                          <td>мг</td>
                          <td>0,17 </td>
                        </tr>
                        <tr>
                          <td>Фолієва кислота</td>
                          <td> мкг</td>
                          <td> 27</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>12</sub></td>
                          <td> мкг</td>
                          <td> 0,21</td>
                        </tr>
                        <tr>
                          <td>Біотин</td>
                          <td> мкг</td>
                          <td>4,0</td>
                        </tr>
                        <tr>
                          <td>Вітамін С</td>
                          <td> мг  </td>
                          <td>10</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Мінеральні речовини</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Натрій</td>
                          <td> мг</td>
                          <td>100</td>
                        </tr>
                        <tr>
                          <td>Калій</td>
                          <td>мг</td>
                          <td>150</td>
                        </tr>
                        <tr>
                          <td>Хлориди</td>
                          <td>мг</td>
                          <td>125</td>
                        </tr>
                        <tr>
                          <td>Кальцій</td>
                          <td>мг</td>
                          <td>80</td>
                        </tr>
                        <tr>
                          <td>Фосфор</td>
                          <td>мг</td>
                          <td>72</td>
                        </tr>
                        <tr>
                          <td>Магній</td>
                          <td>мг</td>
                          <td>23</td>
                        </tr>
                        <tr>
                          <td>Залізо</td>
                          <td>мг</td>
                          <td>1,6</td>
                        </tr>
                        <tr>
                          <td>Цинк</td>
                          <td>мг</td>
                          <td>1,2</td>
                        </tr>
                        <tr>
                          <td>Мідь</td>
                          <td>мг</td>
                          <td>0,18</td>
                        </tr>
                        <tr>
                          <td>Марганець</td>
                          <td>мг</td>
                          <td>0,33</td>
                        </tr>
                        <tr>
                          <td>Фториди</td>
                          <td>мг</td>
                          <td>0,10</td>
                        </tr>
                        <tr>
                          <td>Молібден</td>
                          <td>мкг</td>
                          <td>10</td>
                        </tr>
                        <tr>
                          <td>Селен</td>
                          <td>мкг</td>
                          <td>5,7</td>
                        </tr>
                        <tr>
                          <td>Хром</td>
                          <td>мкг</td>
                          <td>6,7</td>
                        </tr>
                        <tr>
                          <td>Йод</td>
                          <td>мкг</td>
                          <td>13</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="3">Інші</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Каротиноїди</td>
                          <td>мг</td>
                          <td>0,20</td>
                        </tr>
                        <tr>
                          <td>Холін</td>
                          <td>мг</td>
                          <td>37</td>
                        </tr>
                        <tr>
                          <td>Осмолярність</td>
                          <td>мОсмоль/л</td>
                          <td>255</td>
                        </tr>
                        <tr>
                          <td>Вода</td>
                          <td>мл</td>
                          <td>85</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    "<p><strong>Важлива інформація: </strong> <br> Тільки для ентерального застосування! Не застосовувати парентерально! Застосовувати тільки під наглядом лікаря! Може бути використане як єдине джерело харчування. З обережністю застосовувати для дітей віком від 3 до 6 років. Не є лікарським засобом.</p>",
                                    "<p><strong>Протипоказання:</strong> <br> Не використовувати для дітей віком до 3 років. Не використовувати для хворих на галактоземію. Не рекомендовано для пацієнтів з підвищеною чутливістю до окремих компонентів продукту. Забороняється вводити внутрішньовенно.</p>",
                                    "<p><strong>Форма випуску:</strong> <br> рідка суміш у спадаючій пластиковій пляшці об'ємом 1000 мл e.</p>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    "<p><strong>Спосіб застосування:</strong><br> Перед застосуванням перевірити зовнішній вигляд продукту, добре збовтати. Не слід розбавляти продукт та додавати лікарські засоби. Застосовувати суміш кімнатної температури.</p>",
                                ],
                            },
                        ],
                    },
                    // 9
                    {
                        titlePreviev: "Нутрізон Паудер",
                        titleSingle: "Нутрізон Паудер",
                        titleSingleEn: "Nutrison Powder",
                        image: ["9.png"],
                        accordions: [
                            {
                                isActive: false,
                                title: "Характеристики",
                                content: [
                                    "<p>Харчовий продукт для спеціальних медичних цілей: ентеральне харчування Нутрізон Паудер / Nutrison Powder призначено для дорослих пацієнтів і дітей від 1 року зі звичайними потребами у білку та енергії. Суха, повноцінна, збалансована суміш, що застосовується як ентеральне харчування для введення до шлунково-кишкового тракту за допомогою зонда чи для перорального прийому.</p>",
                                ],
                                list: [
                                    "• Повноцінна, збалансована суміш, збагачена натуральними каротиноїдами.",
                                    "• Має насичений мінеральний та вітамінний склад.",
                                    "• Відсутність харчових волокон дозволяє використовувати Нутрізон Паудер у випадках, коли не показано стимуляції моторно-евакуаторної функції кишківника.",
                                    "• Не містить клінічно значущих лактози, глютену, холестерину.",
                                    "• Не містить генетично модифікованих компонентів.",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Показання до застосування*",
                                content: [
                                    "<p>Може бути використане для зондового та перорального застосування як єдине або додаткове джерело харчування для дорослих та дітей від 1 року.</p>",
                                    "<p>Під час підготовки до операції та у післяопераційний період. У випадку інсульту, захворювань шлунково-кишкового тракту (ШКТ): мукозитів, ентеритів різної етіології, зокрема спричинених променевою та хіміотерапією (холециститу, панкреатиту, фістул). За наявності часткових перешкод для проходження їжі: пухлин та травм голови і шиї, порушення ковтання і жування, стриктур та обструкції різних відділів шлунково-кишкового тракту. При станах, пов'язаних із втратою апетиту та/або відмовою від прийому їжі: онкологічних захворювань, неврологічних захворювань, психічних розладів, хвороб печінки, серцево-легеневої недостатності, ВІЛ-інфекції на стадії СНІДу. При недостатності харчування будь-якої етіології.</p>",
                                ],

                                links: [
                                    "<strong>*</strong> відповідно до загальнодоступних рекомендацій Європейської Асоціації Парентерального та Ентерального Харчування (ESPEN), що стосуються подібних категорій продуктів та населення з додатковими потребами нутритивної підтримки, визначеними лікарем. <a href='https://www.espen.org/guidelines-home' target='_blank'>https://www.espen.org/guidelines-home</a>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "Склад",
                                content: [
                                    "<p>Глюкозний сироп, казеїнат (з коров’ячого <strong>молока</strong>), рослинні олії (пальмова олія, кокосова олія, рапсова олія, соняшникова олія, олія із середньоланцюговими тригліцеридами (пальмова олія)), цитрат калію, емульгатор (<strong>соєвий</strong> лецитин), цитрат натрію, хлорид натрію, гідроортофосфат калію, магнію хлорид,  хлорид  холіну,  карбонат  кальцію, гідроортофосфат магнію, фосфат кальцію, L-аскорбат натрію, мальтодекстрин, ароматизатор (Ваніль), сульфат заліза (ІІ), L-аскорбінова кислота,сульфат цинку, нікотинамід, ацетат DL-альфа-токоферолу, сульфат міді (II), сульфат марганцю (II), D-пантотенат кальцію, гідрохлорид тіаміну, фторид натрію, DL-альфа-токоферол, гідрохлорид піридоксину, ретинілпальмітат, рибофлавін, сахароза, фолієва кислота, холекальциферол, хлорид хрому (III), молібдат натрію, каротиноїди (містить сою) (β-каротин, лютеїн, живиця лікопену з томатів), йодид калію, селеніт натрію, D-біотин, фітоменадіон, ціанокобаламін. Без ГМО. Без глютену.</p>",
                                ],
                                tables: {
                                    title: "Поживна цінність	на 100 мл",
                                    list: [
                                        `
                    <table>
                    <thead>
                      <tr>
                        <th>Енергетична
                        цінність
                        </th>
                        <th>кДж/<br>ккал</th>
                        <th>1943/
                        463</th>
                        <th>420/
                        100 </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Жири, з них:</td>
                        <td>г</td>
                        <td>18,2</td>
                        <td>3,9</td>
                      </tr>
                      <tr>
                        <td><span>– насичені</span></td>
                        <td><span>г</span></td>
                        <td><span>8,5</span></td>
                        <td><span>1,8</span></td>
                      </tr>
                      <tr>
                        <td>Вуглеводи, з них:</td>
                        <td>г</td>
                        <td>56,6</td>
                        <td>12,2</td>
                      </tr>
                      <tr>
                        <td><span>– цукри</span></td>
                        <td><span>г</span></td>
                        <td><span>8,7</span></td>
                        <td><span>1,9</span></td>
                      </tr>
                      <tr>
                        <td><span>– лактоза</span></td>
                        <td><span>г</span></td>
                        <td><span><0,14</span></td>
                        <td><span><0,030</span></td>
                      </tr>
                      <tr>
                        <td>Харчові волокна</td>
                        <td>г</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>Білки</td>
                        <td>г</td>
                        <td>18,2</td>
                        <td>3,9</td>
                      </tr>
                      <tr>
                        <td>Сіль</td>
                        <td>г</td>
                        <td>1,2</td>
                        <td>0,26 </td>
                      </tr>
                    </tbody>
                  </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="4">Вітаміни</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Вітамін А</td>
                          <td>мкг</td>
                          <td>381</td>
                          <td>82,4</td>
                        </tr>
                        <tr>
                          <td>Вітамін D</td>
                          <td>мкг</td>
                          <td>6,01</td>
                          <td>1,30</td>
                        </tr>
                        <tr>
                          <td>Вітамін Е</td>
                          <td>мг <br>(α-TE)</td>
                          <td>5,94</td>
                          <td>1,28</td>
                        </tr>
                        <tr>
                          <td>Вітамін К</td>
                          <td>мкг</td>
                          <td>24,4</td>
                          <td>5,28</td>
                        </tr>
                        <tr>
                          <td>Тіамін</td>
                          <td>мг</td>
                          <td>0,69</td>
                          <td>0,15</td>
                        </tr>
                        <tr>
                          <td>Рибофлавін</td>
                          <td>мг</td>
                          <td>0,74</td>
                          <td>0,16</td>
                        </tr>
                        <tr>
                          <td>Ніацин</td>
                          <td>мг NЕ/ <br>мг</td>
                          <td>8,30/4,26</td>
                          <td>1,79/0,92</td>
                        </tr>
                        <tr>
                          <td>Пантотенова кислота</td>
                          <td>мг</td>
                          <td>2,45</td>
                          <td>0,53</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>6</sub></td>
                          <td>мг</td>
                          <td>0,79</td>
                          <td>0,17</td>
                        </tr>
                        <tr>
                          <td>Фолієва кислота</td>
                          <td> мкг</td>
                          <td>123</td>
                          <td>26,6</td>
                        </tr>
                        <tr>
                          <td>Вітамін В<sub>12</sub></td>
                          <td> мкг</td>
                          <td>1,02</td>
                          <td>0,22</td>
                        </tr>
                        <tr>
                          <td>Біотин</td>
                          <td> мкг</td>
                          <td>19,7</td>
                          <td>4,27</td>
                        </tr>
                        <tr>
                          <td>Вітамін С</td>
                          <td> мг</td>
                          <td>59,5</td>
                          <td>12,9</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="4">Мінеральні речовини</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Натрій</td>
                          <td> мг</td>
                          <td>472</td>
                          <td>102</td>
                        </tr>
                        <tr>
                          <td>Калій</td>
                          <td>мг</td>
                          <td>706</td>
                          <td>153</td>
                        </tr>
                        <tr>
                          <td>Хлориди</td>
                          <td>мг</td>
                          <td>578</td>
                          <td>125</td>
                        </tr>
                        <tr>
                          <td>Кальцій</td>
                          <td>мг</td>
                          <td>370</td>
                          <td>80,1</td>
                        </tr>
                        <tr>
                          <td>Фосфор</td>
                          <td>мг</td>
                          <td>290</td>
                          <td>62,8</td>
                        </tr>
                        <tr>
                          <td>Магній</td>
                          <td>мг</td>
                          <td>69,3</td>
                          <td>15,0</td>
                        </tr>
                        <tr>
                          <td>Залізо</td>
                          <td>мг</td>
                          <td>7,38</td>
                          <td>1,59</td>
                        </tr>
                        <tr>
                          <td>Цинк</td>
                          <td>мг</td>
                          <td>5,54</td>
                          <td>1,2</td>
                        </tr>
                        <tr>
                          <td>Мідь</td>
                          <td>мг</td>
                          <td>0,83</td>
                          <td>0,18</td>
                        </tr>
                        <tr>
                          <td>Марганець</td>
                          <td>мг</td>
                          <td>0,93</td>
                          <td>0,20</td>
                        </tr>
                        <tr>
                          <td>Фториди</td>
                          <td>мг</td>
                          <td>0,48</td>
                          <td>0,10</td>
                        </tr>
                        <tr>
                          <td>Молібден</td>
                          <td>мкг</td>
                          <td>48,6</td>
                          <td>10,5</td>
                        </tr>
                        <tr>
                          <td>Селен</td>
                          <td>мкг</td>
                          <td>26,4</td>
                          <td>5,70</td>
                        </tr>
                        <tr>
                          <td>Хром</td>
                          <td>мкг</td>
                          <td>25,7</td>
                          <td>5,56</td>
                        </tr>
                        <tr>
                          <td>Йод</td>
                          <td>мкг</td>
                          <td>63,1</td>
                          <td>13,6</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                        `
                    <table>
                      <thead>
                        <tr>
                          <th colspan="4">Інші</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Каротиноїди</td>
                          <td>мг</td>
                          <td>0,74</td>
                          <td>0,16</td>
                        </tr>
                        <tr>
                          <td>Холін</td>
                          <td>мг</td>
                          <td>165</td>
                          <td>35,6</td>
                        </tr>
                        <tr>
                          <td>Осмолярність
                          </td>
                          <td>мОсмоль/л</td>
                          <td></td>
                          <td>320</td>
                        </tr>
                      </tbody>
                    </table>
                    `,
                                    ],
                                },
                            },
                            {
                                isActive: false,
                                title: "Про продукт",
                                content: [
                                    "<p><strong>Важлива інформація:</strong><br> Перед початком годування дитини необхідно проконсультуватися з лікарем-педіатром. Забороняється  використовувати  води з  колодязів та каптажних джерел для приготування дитячого харчування. Тільки для ентерального застосування! Не застосовувати парентерально! Застосовувати тільки під наглядом лікаря! Може бути використане як єдине джерело харчування. Не використовувати для дітей віком до 1 року. З обережністю застосовувати для дітей віком від 1 до 6 років. Можлива коагуляція у шлунково-кишковому тракті, наприклад, через взаємодію з лікарськими засобами. Необхідний ретельний моніторинг. Не є лікарським засобом.</p>",
                                    "<p><strong>Протипоказання:</strong><br> Не використовувати для дітей віком до 1 року. Не використовувати хворим на галактоземію. У віці від 1 до 6 років застосовувати з урахуванням вікової потреби та переносимості (травна та видільна системи маленьких дітей можуть бути недостатньо зрілими, аби адекватно впоратися з підвищеною кількістю білка). Забороняється вводити внутрішньовенно.</p>",
                                    "<p><strong>Форма випуску:</strong> порошкоподібна суміш у металевій банці, масою 430 г. В кожній банці є мірна ложка на 4,3 г.</p>",
                                ],
                            },
                            {
                                isActive: false,
                                title: "застосування",
                                content: [
                                    "<p><strong>Спосіб застосування:</strong><br> Перед  застосуванням  ретельно вимити руки, використовуйте чистий або стерильний посуд, переконайтеся,  що  верхня  частина  пакування  є  чистою. Налити охолоджену кип’ячену воду в стерильний контейнер і додайте назначену лікарем кількість порошку. Використовуйте лише мірну ложечку, що входить до пакування. Ретельно перемішати до повного розчинення порошку. Не слід додавати лікарські засоби до продукту. Застосовувати суміш кімнатної температури. Готуйте суміш на одну порцію годування. Готова суміш має час введення не довше 4 годин при кімнатній температурі. Завжди викидайте залишки суміші.</p>",
                                ],
                                list: [
                                    "<strong>Рекомендації щодо застосування:</strong>",
                                    "•	Продукт треба пити повільно (1 порцію протягом 20-30 хвилин) або між прийомами їжі.",
                                ],
                            },
                        ],
                    },

                    // 3
                    // {
                    //   titlePreviev: "Інфатріні",
                    //   titleSingle: "Інфатріні",
                    //   titleSingleEn: "Infatrini",
                    //   image: ["3.png"],
                    //   accordions: [
                    //     {
                    //       isActive: false,
                    //       title: "Характеристики",
                    //       content: [
                    //         "<p>Функціональне дитяче харчування Інфатріні / Infatrini для дітей від народження до досягнення маси тіла 9 кг або віку 18 місяців; готова до вживання, повноцінна, збалансована суміш з харчовими волокнами.</p>",
                    //       ],
                    //       list: [
                    //         "• Повноцінний, збалансований склад.",
                    //         "• Більше калорій у меншому об’ємі. В 1 мл – 1 ккал (майже на 50% більше, ніж у стандартній дитячій суміші<sup>1</sup>).",
                    //         "• Вміст білка: 2,6 г / 100 мл.",
                    //         "• Склад білка – 60% сироваткових білків і 40% казеїну – наближений до складу білків грудного молока<sup>2</sup>.",
                    //         "• Рівень нуклеотидів наближено до їх рівня у грудному молоці, що може позитивно впливати на становлення імунної відповіді у новонароджених, а також покращувати показники росту і розвитку.",
                    //         "• Вміст лактози наближено до її кількості у грудному молоці, що сприяє поліпшенню складу кишкової мікробіоти і всмоктування кальцію.",
                    //         "• Готова до вживання рідка суміш для зручності і безпеки використання.",
                    //         "• Запаковано в захисному середовищі. Продукт стерилізовано при ультрависокій температурі.",
                    //       ],
                    //       links: [
                    //         "<strong>1.</strong> Енергетична цінність Суміші молочної Nutrilon-6,6 ккал в 1  мл готової суміші.",
                    //         "<strong>2.</strong> Грудне молоко – найкраще харчування для дітей раннього віку. ",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Показання до застосування*",
                    //       content: [
                    //         "<p>Може бути єдиним джерелом харчування для дітей з народження до досягнення маси тіла 9 кг або віку 18 місяців чи доповненням до основної суміші.",
                    //         "<p>При затримці темпів фізичного розвитку, білково-енергетичної недостатності, підвищених втратах поживних речовин, пов'язаних з критичними станами (травмами, опіками), гострими та хронічними захворюваннями, гіперметаболізмом. При підвищених потребах у поживних речовинах, пов'язаних з перинатальним ураженням ЦНС, ДЦП, вродженими вадами серця, хірургічним втручанням, гострими і хронічними захворюваннями. У випадку недостатнього надходження поживних речовин, пов'язаного з тим, що дитина не може впоратися з кількістю запропонованого харчування.</p>",
                    //         "<p>Використовується для перорального прийому або введення через зонд. Дозування розраховується залежно від вікових потреб дитини в енергії та білку. Дозування має визначатися лише лікарем.</p>",
                    //       ],
                    //       links: [
                    //         "<strong>*</strong> відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                    //         "<strong>1.</strong> Dick A. van Waardenburg, Carlijn T. deBetue, Johannes B. vanGoudoever,Luc J. Zimmermann, Koen F. Joosten. Critically ill infants benefit from early administration of protein andenergy-enriched formula: A randomized controlled trial.",
                    //         "<strong>2.</strong> S. Evans, H. Twaissi, A. Daly, P. Davies_ & A. MacDonald. Should high-energy infant formula be given at full strength from its first day of usage?",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Склад",
                    //       content: [
                    //         "<p>Демінералізована вода, знежирене коров’яче молоко, мальтодекстрин, рослинні олії (рапсова олія, соняшникова олія, кокосова олія (містить соєвий лецитин), середньоланцюгові тригліцериди (кокосова та пальмоядрова олія), кукурудзяна олія, олія одноклітинних), лактоза (з коров’ячого <strong>молока</strong>), харчові волокна (галактоолігосахариди (з коров’ячого молочного цукру) (0,69%), фруктоолігосахариди (0,08%)), білок з сироватки (з коров’ячого <strong>молока</strong>), вершкове масло (з коров’ячого <strong>молока</strong>), цитрат кальцію, рафінована олія риби тунець,цитрат калію, регулятор кислотності (лимонна кислота), емульгатор (моно- та дигліцериди жирних кислот), фосфат кальцію, хлорид натрію, L-аскорбат натрію, інозитол, гідроксид кальцію, хлорид холіну, карбонат магнію, гідроксид калію, гідроортофосфат калію, таурин, лактат заліза (II), гідроксид натрію, ацетат DL-альфа-токоферолу, бета-каротин, сульфат цинку, цитидин-5'-монофосфат, L-карнітин, аденозин-5'-монофосфат, ретинілацетат, динатрієва сіль уридин-5'-монофосфату, динатрієва сіль інозин-5'-монофосфату, D-пантотенат кальцію, холекальциферол, нікотинамід, динатрієва сіль гуанозин-5'-монофосфату, глюконат міді, D-біотин, гідрохлорид тіаміну, селеніт натрію, йодид калію, рибофлавін, гідрохлорид піридоксину, фолієва кислота, фітоменадіон, сульфат марганцю (II), ціанокобаламін. Без ГМО. Без глютену.</p>",
                    //       ],
                    //       tables: {
                    //         title: "Поживна цінність	на 100 мл",
                    //         list: [
                    //           `
                    //           <table>
                    //           <thead>
                    //             <tr>
                    //               <th>Енергетична
                    //               цінність
                    //               </th>
                    //               <th>кДж/<br>ккал</th>
                    //               <th>420/101</th>
                    //             </tr>
                    //           </thead>
                    //           <tbody>
                    //             <tr>
                    //               <td>Жири, з них:</td>
                    //               <td>г</td>
                    //               <td>5,4</td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– насичені</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>2,2</span></td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– мононенасичені</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>2,1</span> </td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– поліненасичені</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>1,1 </span></td>
                    //             </tr>
                    //             <tr>
                    //               <td>Арахідонова кислота (АК)</td>
                    //               <td>мг</td>
                    //               <td>17,7</td>
                    //             </tr>
                    //             <tr>
                    //               <td>Докозагексаєнова кислота (ДГК)</td>
                    //               <td>мг</td>
                    //               <td>17,6</td>
                    //             </tr>
                    //             <tr>
                    //               <td>Вуглеводи, з них:</td>
                    //               <td>г</td>
                    //               <td>10,3</td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– цукри</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>5,7</span></td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– лактоза</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>5,2</span></td>
                    //             </tr>
                    //             <tr>
                    //               <td>Харчові волокна</td>
                    //               <td>г</td>
                    //               <td>0,6</td>
                    //             </tr>
                    //             <tr>
                    //               <td>Білки</td>
                    //               <td>г</td>
                    //               <td>2,6</td>
                    //             </tr>
                    //             <tr>
                    //               <td>Сіль</td>
                    //               <td>г</td>
                    //               <td>0,09</td>
                    //             </tr>
                    //           </tbody>
                    //         </table>
                    //           `,
                    //           `
                    //           <table>
                    //             <thead>
                    //               <tr>
                    //                 <th colspan="3">Вітаміни</th>
                    //               </tr>
                    //             </thead>
                    //             <tbody>
                    //               <tr>
                    //                 <td>Вітамін А</td>
                    //                 <td>мкгRЕ</td>
                    //                 <td>81</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін D</td>
                    //                 <td>мкг</td>
                    //                 <td>1,9</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін Е</td>
                    //                 <td>мг <br>(α-TE)</td>
                    //                 <td>2,1</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін К</td>
                    //                 <td>мкг</td>
                    //                 <td>6,7</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Тіамін</td>
                    //                 <td>мг</td>
                    //                 <td>0,15</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Рибофлавін</td>
                    //                 <td>мг</td>
                    //                 <td>0,20</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Ніацин</td>
                    //                 <td>мг NЕ/ <br>мг</td>
                    //                 <td>1,2/ 0,52</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Пантотенова кислота</td>
                    //                 <td>мг</td>
                    //                 <td>0,80</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін В<sub>6</sub></td>
                    //                 <td>мг</td>
                    //                 <td>0,11</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Фолієва кислота</td>
                    //                 <td> мкг</td>
                    //                 <td>16</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін В<sub>12</sub></td>
                    //                 <td> мкг</td>
                    //                 <td>0,30</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Біотин</td>
                    //                 <td> мкг</td>
                    //                 <td>4,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін С</td>
                    //                 <td> мг  </td>
                    //                 <td>14</td>
                    //               </tr>
                    //             </tbody>
                    //           </table>
                    //           `,
                    //           `
                    //           <table>
                    //             <thead>
                    //               <tr>
                    //                 <th colspan="3">Мінеральні речовини</th>
                    //               </tr>
                    //             </thead>
                    //             <tbody>
                    //               <tr>
                    //                 <td>Натрій</td>
                    //                 <td> мг</td>
                    //                 <td>37</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Калій</td>
                    //                 <td>мг</td>
                    //                 <td>95</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Хлориди</td>
                    //                 <td>мг</td>
                    //                 <td>62</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Кальцій</td>
                    //                 <td>мг</td>
                    //                 <td>100</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Фосфор</td>
                    //                 <td>мг</td>
                    //                 <td>50</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>PO4</td>
                    //                 <td>мг</td>
                    //                 <td>153</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Магній</td>
                    //                 <td>мг</td>
                    //                 <td>9,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Залізо</td>
                    //                 <td>мг</td>
                    //                 <td>1,2</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Цинк</td>
                    //                 <td>мг</td>
                    //                 <td>0,80</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Мідь</td>
                    //                 <td>мг</td>
                    //                 <td>0,065</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Марганець</td>
                    //                 <td>мг</td>
                    //                 <td>0,016</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Молібден</td>
                    //                 <td>мкг</td>
                    //                 <td><8</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Селен</td>
                    //                 <td>мкг</td>
                    //                 <td>2,2</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Хром</td>
                    //                 <td>мкг</td>
                    //                 <td><8</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Йод</td>
                    //                 <td>мкг</td>
                    //                 <td>18</td>
                    //               </tr>
                    //             </tbody>
                    //           </table>
                    //           `,
                    //           `
                    //           <table>
                    //             <thead>
                    //               <tr>
                    //                 <th colspan="3">Інші</th>
                    //               </tr>
                    //             </thead>
                    //             <tbody>
                    //               <tr>
                    //                 <td>Каротиноїди</td>
                    //                 <td>мг</td>
                    //                 <td>35</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Нуклеотиди</td>
                    //                 <td>мг</td>
                    //                 <td>4,3</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>L-карнітин</td>
                    //                 <td>мг</td>
                    //                 <td>55</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Холін</td>
                    //                 <td>мг</td>
                    //                 <td>17</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Інозитол</td>
                    //                 <td>мг</td>
                    //                 <td>25</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Таурин</td>
                    //                 <td>мг</td>
                    //                 <td>7,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Осмолярність
                    //                 </td>
                    //                 <td>мОсмоль/л</td>
                    //                 <td>305</td>
                    //               </tr>
                    //             </tbody>
                    //           </table>
                    //           `,
                    //         ],
                    //       },
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Про продукт",
                    //       content: [
                    //         "<p><strong>Важлива інформація:</strong> <br> Застосовувати тільки під наглядом лікаря, після повного розгляду всіх варіантів годування, включаючи грудне вигодовування. Тільки для ентерального застосування! Не застосовувати парентерально! Може застосовуватись як єдине джерело харчування для дітей від народження до 18 місяців або з масою тіла до 9 кг. Не є лікарським засобом.</p>",
                    //         "<p><strong>Протипоказання:</strong> <br> Алергія на білки коров'ячого молока. Непереносимість лактози. Галактоземія. Стани, за яких ентеральне харчування неможливе. Індивідуальна непереносимість компонентів. Забороняється вводити внутрішньовенно.</p>",
                    //         "<p><strong>Форма випуску:</strong> рідка суміш у пластиковій пляшечці, 24 пляшечки у картонній коробці об'ємом 24х125 мл e (3000 мл).</p>",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "застосування",
                    //       list: [
                    //         "<strong>Спосіб застосування:</strong>",
                    //         "•	Вимийте руки, використовуйте чистий або стерилізований посуд.",
                    //         "•	Перед застосуванням добре збовтати.",
                    //         "•	Перелийте суміш у стерилізовану пляшечку для годування або в контейнер для годування через зонд.",
                    //         "•	Застосовувати суміш кімнатної температури або підігріти до 37 °С .",
                    //         "•	Не використовуйте мікрохвильову піч для розігріву.",
                    //         "•	Завжди перевіряйте температуру суміші перед застосуванням. ",
                    //         "•	Суміш, що залишилась після застосування, необхідно вилити. •	Час введення через зонд не може перевищувати 4 годин.",
                    //         "•	Завжди викидайте невикористану суміш.",
                    //         "•	Тривалий або частий контакт напоїв та їжі із зубами збільшує ризик карієсу, тому якісна гігієна ротової порожнини важлива для немовлят та дітей",
                    //         "•	Слідкуйте за першими зубками малюка, особливо перед сном",
                    //         "•	При необхідності проконсультуйтесь з Вашим лікарем або стоматологом.",
                    //       ],
                    //       content2: [
                    //         "<p><strong>Рекомендації щодо застосування:</strong> <br> Харчовий продукт для спеціальних медичних цілей. Для дієтотерапії при захворюваннях, пов’язаних з мальнутрицією і відставанням фізичного розвитку. Сприяє наздоганяючому росту та нормалізації фізичного розвитку (ваги та зросту). Повноцінний, збалансований, готовий до вживання. Для дітей від народження до 18 місяців або з масою тіла до 9 кг з відставанням фізичного розвитку, підвищеними енергетичними потребами та/або з обмеженням споживання рідини.</p>",
                    //       ],
                    //     },
                    //   ],
                    // },
                    // 4
                    // {
                    //   titlePreviev: "Нутріні",
                    //   titleSingle: "Нутріні",
                    //   titleSingleEn: "Nutrini",
                    //   image: ["4.png"],
                    //   accordions: [
                    //     {
                    //       isActive: false,
                    //       title: "Характеристики",
                    //       content: [
                    //         "<p>Функціональне дитяче харчування: ентеральне харчування Нутріні/Nutrini – суміш рідка, повноцінна, збалансована, готова до вживання, без харчових волокон, при захворюваннях, пов’язаних з мальнутрицією і недостатнім зростанням, пов’язаним з недоїданням, для дітей від 1 до 6 років або з масою тіла від 8 до 20 кг для годування через зонд. Ізокалорійна суміш (1 ккал/1 мл) для базового ентерального харчування.</p>",
                    //       ],
                    //       list: [
                    //         "• Повноцінний, збалансований склад.",
                    //         "• Суміш для початкового чи базового ентерального харчування дітей.",
                    //         "• Склад білка – 60% сироваткових білків і 40% казеїну.",
                    //         "• Суміш для дітей, адаптована за віком, з урахуванням вікових потреб у макро- та мікронутрієнтах.",
                    //         "• Фізіологічна осмолярність для кращого засвоєння і переносимості.",
                    //         "• Не містить глютену, холестерину, харчових волокон і генетично модифікованих компонентів.",
                    //         "• Готова до вживання рідка суміш для зручності та безпеки використання.",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Показання до застосування*",
                    //       content: [
                    //         "<p>Може бути єдиним джерелом харчування для дітей віком від 1 до 6 років або масою тіла від 8 до 20 кг чи доповненням до основного раціону.</p>",
                    //         "<p>При білково-енергетичній недостатності, підвищених білково-енергетичних витратах (критичних станах, травмах, опіках, інфекційних захворюваннях, сепсисі, важких оперативних втручаннях, вроджених та набутих ураженнях ЦНС, серцево-судинної системи). Для пацієнтів на етапі передопераційної підготовки та післяопераційного ведення під час корекції вад розвитку (вад серця, вад щелепно-лицевої ділянки, шлунково-кишкового тракту, сечовивідної системи, тощо). Для дітей, які не можуть харчуватися самостійно чи відмовляються від прийому їжі (онкопатологія, ураження ЦНС, шлунково-кишкового тракту, тощо).</p>",
                    //         "<p>Використовується для перорального прийому чи введення через зонд.</p>",
                    //         "<p>Дозування розраховується лікарем залежно від вікових потреб дитини в енергіїта білку.</p>",
                    //       ],
                    //       links: [
                    //         "* відповідно до наукових досліджень та загальнодоступних рекомендацій для спеціалізованого харчування пацієнтів з обмеженою, ослабленою або порушеною здатністю приймати, перетравлювати, засвоювати звичайні харчові продукти або певні поживні речовини, що містяться в них, або їх метаболіти; цей перелік не є вичерпним:",
                    //         "1. Dick A. van Waardenburg, Carlijn T. deBetue, Johannes B. vanGoudoever,Luc J. Zimmermann, Koen F. Joosten. Critically ill infants benefit from early administration of protein andenergy-enriched formula: A randomized controlled trial.",
                    //         "2. S. Evans, H. Twaissi, A. Daly, P. Davies_ & A. MacDonald. Should high-energy infant formula be given at full strength from its first day of usage?",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Склад",
                    //       content: [
                    //         "<p>Вода, мальтодекстрин, рослинні олії (рапсова олія, соняшникова олія), концентрат білка з сироватки (з коров’ячого <strong>молока</strong>), казеїнат натрію (з коров’ячого <strong>молока</strong>), емульгатор (<strong>соєвий</strong> лецитин), <strong>риб’ячий</strong> жир, регулятор кислотності (лимонна кислота), гідроортофосфат калію, хлорид натрію, фосфат кальцію, хлорид калію, гідроксид кальцію, цитрат калію, L-аскорбат натрію, каротиноїди (містить сою) (β-каротин, лютеїн, живиця лікопену з томатів), хлорид холіну, гідроксид магнію, гідроксид калію, таурин, лактат заліза (II), сульфат цинку, L-карнітин, ретинілацетат, глюконат міді, нікотинамід, селеніт натрію, холекальциферол, сульфат марганцю (II), D-пантотенат кальцію, D-біотин, гідрохлорид тіаміну, ацетат DL-альфа токоферолу, рибофлавін, гідрохлорид піридоксину, фолієва кислота, хлорид хрому (III), йодид калію, фторид натрію, ціанокобаламін, молібдат натрію, фітоменадіон. Без ГМО. Без глютену.</p>",
                    //       ],
                    //       tables: {
                    //         title: "Поживна цінність	на 100 мл",
                    //         list: [
                    //           `
                    //           <table>
                    //           <thead>
                    //             <tr>
                    //               <th>Енергетична
                    //               цінність
                    //               </th>
                    //               <th>кДж/<br>ккал</th>
                    //               <th>420/
                    //               100 </th>
                    //             </tr>
                    //           </thead>
                    //           <tbody>
                    //             <tr>
                    //               <td>Жири, з них:</td>
                    //               <td>г</td>
                    //               <td>4,4</td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– насичені</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>0,5</span></td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– мононенасичені</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>2,6 </span> </td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– поліненасичені</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>1,3</span></td>
                    //             </tr>
                    //             <tr>
                    //               <td>Докозагексаєнова кислота (ДГК)</td>
                    //               <td>мг</td>
                    //               <td>35,7 </td>
                    //             </tr>
                    //             <tr>
                    //               <td>Ейкозапентаєнова кислота (ЕПК)</td>
                    //               <td>мг</td>
                    //               <td>8,41 </td>
                    //             </tr>
                    //             <tr>
                    //               <td>Вуглеводи, з них:</td>
                    //               <td>г</td>
                    //               <td>12,5</td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– цукри</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span>0,8</span></td>
                    //             </tr>
                    //             <tr>
                    //               <td><span>– лактоза</span></td>
                    //               <td><span>г</span></td>
                    //               <td><span><0,025 </span></td>
                    //             </tr>
                    //             <tr>
                    //               <td>Харчові волокна</td>
                    //               <td>г</td>
                    //               <td>0</td>
                    //             </tr>
                    //             <tr>
                    //               <td>Білки</td>
                    //               <td>г</td>
                    //               <td>2,5 </td>
                    //             </tr>
                    //             <tr>
                    //               <td>Сіль</td>
                    //               <td>г</td>
                    //               <td>0,15 </td>
                    //             </tr>
                    //           </tbody>
                    //         </table>
                    //           `,
                    //           `
                    //           <table>
                    //             <thead>
                    //               <tr>
                    //                 <th colspan="3">Вітаміни</th>
                    //               </tr>
                    //             </thead>
                    //             <tbody>
                    //               <tr>
                    //                 <td>Вітамін А</td>
                    //                 <td>мкг</td>
                    //                 <td>41</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін D</td>
                    //                 <td>мкг</td>
                    //                 <td>1,0 </td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін Е</td>
                    //                 <td>мг <br>(α-TE)</td>
                    //                 <td>1,3 </td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін К</td>
                    //                 <td>мкг</td>
                    //                 <td>4,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Тіамін</td>
                    //                 <td>мг</td>
                    //                 <td>0,15</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Рибофлавін</td>
                    //                 <td>мг</td>
                    //                 <td>0,16</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Ніацин</td>
                    //                 <td>мг NЕ/ <br>мг</td>
                    //                 <td>1,1/ 0,46</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін В<sub>6</sub></td>
                    //                 <td>мг</td>
                    //                 <td>0,33</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Фолієва кислота</td>
                    //                 <td> мкг</td>
                    //                 <td>15</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін В<sub>12</sub></td>
                    //                 <td> мкг</td>
                    //                 <td>0,25</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Біотин</td>
                    //                 <td> мкг</td>
                    //                 <td>4,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вітамін С</td>
                    //                 <td> мг  </td>
                    //                 <td>10</td>
                    //               </tr>
                    //             </tbody>
                    //           </table>
                    //           `,
                    //           `
                    //           <table>
                    //             <thead>
                    //               <tr>
                    //                 <th colspan="3">Мінеральні речовини</th>
                    //               </tr>
                    //             </thead>
                    //             <tbody>
                    //               <tr>
                    //                 <td>Натрій</td>
                    //                 <td> мг</td>
                    //                 <td>60</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Калій</td>
                    //                 <td>мг</td>
                    //                 <td>110</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Хлориди</td>
                    //                 <td>мг</td>
                    //                 <td>95</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Кальцій</td>
                    //                 <td>мг</td>
                    //                 <td>60</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Фосфор</td>
                    //                 <td>мг</td>
                    //                 <td>50</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Магній</td>
                    //                 <td>мг</td>
                    //                 <td>11</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Залізо</td>
                    //                 <td>мг</td>
                    //                 <td>1,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Цинк</td>
                    //                 <td>мг</td>
                    //                 <td>1,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Мідь</td>
                    //                 <td>мг</td>
                    //                 <td>0,08</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Марганець</td>
                    //                 <td>мг</td>
                    //                 <td>0,15</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Фториди</td>
                    //                 <td>мг</td>
                    //                 <td>0,07</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Молібден</td>
                    //                 <td>мкг</td>
                    //                 <td>4,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Селен</td>
                    //                 <td>мкг</td>
                    //                 <td>3,0</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Хром</td>
                    //                 <td>мкг</td>
                    //                 <td>3,5</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Йод</td>
                    //                 <td>мкг</td>
                    //                 <td>10</td>
                    //               </tr>
                    //             </tbody>
                    //           </table>
                    //           `,
                    //           `
                    //           <table>
                    //             <thead>
                    //               <tr>
                    //                 <th colspan="3">Інші</th>
                    //               </tr>
                    //             </thead>
                    //             <tbody>
                    //               <tr>
                    //                 <td>Каротиноїди</td>
                    //                 <td>мг</td>
                    //                 <td>0,10</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Холін</td>
                    //                 <td>мг</td>
                    //                 <td>2,0</td>
                    //               </tr>

                    //               <tr>
                    //                 <td>Таурин</td>
                    //                 <td>мг</td>
                    //                 <td>7,5</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Осмолярність
                    //                 </td>
                    //                 <td>мОсмоль/л</td>
                    //                 <td>200</td>
                    //               </tr>
                    //               <tr>
                    //                 <td>Вода
                    //                 </td>
                    //                 <td>мл</td>
                    //                 <td>85</td>
                    //               </tr>
                    //             </tbody>
                    //           </table>
                    //           `,
                    //         ],
                    //       },
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Про продукт",
                    //       content: [
                    //         "<p><strong>Важлива інформація:</strong> <br> Тільки для ентерального застосування! <strong>Не застосовувати парентерально!</strong> Застосовувати тільки під наглядом лікаря! Може бути використане як єдине джерело харчування дітей від 1 до 6 років або вагою від 8 до 20 кг. Не є лікарським засобом.</p>",
                    //         "<p><strong>Протипоказання:</strong>  Алергія на білки коров'ячого молока. Стани, при яких ентеральне харчування неможливе. Індивідуальна непереносимість компонентів. Забороняється вводити внутрішньовенно. Не використовувати для дітей віком до 1 року. Не використовувати для хворих на галактоземію.</p>",
                    //         "<p><strong>Форма випуску:</strong> рідка суміш у спадаючій пластиковій пляшці, об'ємом 500 мл e.</p>",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "застосування",
                    //       content: [
                    //         "<p><strong>Спосіб застосування:</strong><br> Перед застосуванням перевірити зовнішній вигляд продукту, добре збовтати. Не слід розбавляти продукт та додавати лікарські засоби. Застосовувати суміш кімнатної температури.</p>",
                    //       ],
                    //     },
                    //   ],
                    // },
                    //12
                    // {
                    //   titlePreviev: "Інфатріні Пептісорб",
                    //   titleSingle: "Інфатріні Пептісорб",
                    //   titleSingleEn: "Infatrini Peptisorb",
                    //   image: ["12.png"],
                    //   accordions: [
                    //     {
                    //       isActive: false,
                    //       title: "Характеристики*",
                    //       content: [
                    //         "<p>Функціональне дитяче харчування: Інфатріні Пептісорб / Infatrini Peptisorb для дітей від народження до 18 місяців або масою тіла до 9 кг.</p>",
                    //       ],
                    //       list: [
                    //         "• Cуміш рідка, повноцінна.",
                    //         "• Глибокий гідроліз сироваткового білка (2,6 г / 100 мл) - легко засвоюється для забезпечення підвищених потреб.",
                    //         "• Високоенергетична суміш. В 1 мл – 1 ккал (майже на 50% більше, ніж у стандартній дитячій суміші<sup>1</sup>).",
                    //         "• «Наднизький» вміст лактози (<0,10 г / 100 мл) - полегшує травлення, знижує газоутворення в кишківнику та коліки у випадку наявності лактазної недостатності.",
                    //         "• Містить нуклеотиди – 3,6 мг/100 мл, -, що може позитивно впливати на становлення імунної відповіді у новонароджених, всмоктування заліза а також покращувати показники росту і розвитку<sup>2, 4</sup>.",
                    //         "• Середньоланцюгові тригліцериди складають 52% жирів (2,8 г на 100 мл), що забезпечує легке засвоєння<sup>3</sup>.",
                    //         "• Готова до вживання рідка суміш для зручності і безпеки використання – підходить для годування з пляшечки або через зонд.",
                    //         "• Може застосовуватись як єдине джерело харчування для дітей від народження до 18 місяців або з масою тіла до 9 кг.",
                    //         "• Запаковано в захисному середовищі. Ультрапастеризований продукт.",
                    //       ],
                    //       links: [
                    //         "<strong>1.</strong> В порівнянні зі звичайно рекомендованою сумішшю для здорових дітей : Суміш молочна Nutrilon, енергетична цінність якої 6,6 ккал в 1 мл готової суміші.",
                    //         "<strong>2.</strong> Carver J. D., Walker W. A. The role of nucleotides in human nutrition. Nutr. Biochem. 1995; 6: 58–72.",
                    //         "<strong>3.</strong> Няньковський С.Л., Івахненко О.С., Яцула М.С., Львівський національний медичний університет ім. Данила Галицького, Синдром мальабсорбції з позицій сучасного педіатра-клініциста // На допомогу педіатру. – 2012. - № 6 (41). – С. 134-140.",
                    //         "<strong>4.</strong> О.Г. Шадрін, В.П. Місник, ДУ «Інститут педіатрії, акушерства та гінекології АМН України», м. Київ. Актуальні питання штучного вигодовування немовлят. // Дитячий лікар. – 2010. - №3 (5). – С. 13-17.",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Показання до застосування* ",
                    //       content: [
                    //         "<p>Для дітей від народження до 18 місяців або з масою тіла до 9 kg (кг) з затримкою фізичного розвитку, підвищеними енергетичними потребами та/або з обмеженнями споживання рідини, з харчовою непереносимістю та з харчовою алергією.</p>",
                    //       ],
                    //       list: [
                    //         "<strong>Ці стани можуть зустрічатися при :</strong>  ",
                    //         "• наявності дефіциту ферментів підшлункової залози, який може спостерігатися при хронічному панкреатиті, раку підшлункової залози, муковісцидозі або після обширних резекцій підшлункової залози",
                    //         "• запальних захворювання кишечника",
                    //         "• синдромі короткої кишки",
                    //         "• променевому ентериті, під час хіміотерапії та при трансплантації кісткового мозку",
                    //         "• розладах шлунково-кишкового тракту, пов’язаних із ВІЛ",
                    //         "• хронічних захворюваннях печінки",
                    //         "• інших порушеннях шлунково-кишкового тракту, спричинених критичними станами, оперативними втручаннями, неврологічними розладами",
                    //         "• використовується для перорального прийому або введення через зонд.",
                    //       ],
                    //       links: [
                    //         "Дозування розраховується залежно від вікових потреб дитини в енергії та білку. Дозування має визначатися лише лікарем.",
                    //         "<strong>* </strong>Rolandelli & Ullrich, 1997; Sullivan & Wall Alonso, 1998; Eatock et al, 2000; Roberts, 2001; Silk, 2001; Abou-Assi and O’Keefe, 2001 Griffiths et al, 1995; King et al, 1997; Heuschkel et al, 2000; Zachos et al, 2007 Cosnes et al, 1992; Goulet et al, 2004; Goulet, 2008; Goday, 2009 Beer et al, 1985; Bounous, 1989; Papadopoulou et al, 1997; Langdana et al, 2001; Deswarte-Wallace et al, 2001; Shaw & Lawson, 2007 Craig et al, 1997; de Luis Roman et al, 2001",
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Склад",
                    //       content: [
                    //         "<p>Демінералізована вода, глюкозний сироп, мальтодекстрин, рослинні олії (середньоланцюгові тригліцериди (з кокосової та/або пальмової олії), кукурудзяна, рапсова, соняшникова), гідролізований білок з сироватки (з коров’ячого <strong>молока</strong>), емульгатор (лимоннокислі ефіри моно- та дигліцеридів жирних кислот), гідроортофосфат калію, <strong>риб’ячий</strong> жир, хлорид кальцію, регулятор кислотності (лимонна кислота), фосфат кальцію, гідроксид калію, гідроксид кальцію, рослинна олія з Mortierella alpina, хлорид холіну, L-аскорбат натрію, інозитол, гідроортофосфат магнію, L-гістидин, таурин, L-тирозин, лактат заліза(II), гідроксид натрію, ацетат DL-альфа токоферолу, сульфат цинку, L-карнітин, цитидин-5'-монофосфат, L-аргінін, аденозин-5'-монофосфат, D-пантотенат кальцію, натрієва сіль уридин-5'-монофосфату, натрієва сіль інозин-5'-монофосфату, нікотинамід, глюконат міді, натрієва сіль гуанозин-5'-монофосфату, гідрохлорид тіаміну, рибофлавін, ретинілацетат, гідрохлорид піридоксину, йодид калію, сульфат марганцю(II), фолієва кислота, хлорид хрому(III), фітоменадіон, D-біотин, холекальциферол, селеніт натрію, ціанокобаламін. Без ГМО. Без глютену.</p>",
                    //       ],
                    //       tables: {
                    //         title: "Поживна цінність	на 100 мл",
                    //         list: [
                    //           `
                    //         <table>
                    //           <thead>
                    //             <tr>
                    //               <th>
                    //                 Енергетична
                    //                 цінність
                    //               </th>
                    //               <th>
                    //                 кДж/<br>ккал
                    //               </th>
                    //               <th>
                    //                 418/100
                    //               </th>
                    //             </tr>
                    //           </thead>
                    //           <tbody>
                    //             <tr>
                    //               <td>
                    //               Жири, з них:
                    //               </td>
                    //               <td>
                    //               г
                    //               </td>
                    //               <td>
                    //               5,4
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               <span>– насичені<span>
                    //               </td>
                    //               <td>
                    //               <span>г</span>
                    //               </td>
                    //               <td>
                    //               <span>3,8</span>
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               <span>– Середньоланцюгові тригліцериди<span>
                    //               </td>
                    //               <td>
                    //               <span>г</span>
                    //               </td>
                    //               <td>
                    //               <span>2,8</span>
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               <span>– мононенасичені<span>
                    //               </td>
                    //               <td>
                    //               <span>г</span>
                    //               </td>
                    //               <td>
                    //               <span>0,77</span>
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               <span>– поліненасичені<span>
                    //               </td>
                    //               <td>
                    //               <span>г</span>
                    //               </td>
                    //               <td>
                    //               <span>0,86</span>
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Арахідонова кислота (АК)
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //                 25,2
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Докозагексаєнова кислота (ДГК)
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //                 25,0
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Вуглеводи, з них:
                    //               </td>
                    //               <td>
                    //               г
                    //               </td>
                    //               <td>
                    //                 10,2
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               <span> – цукри</span>
                    //               </td>
                    //               <td>
                    //               <span>г</span>
                    //               </td>
                    //               <td>
                    //               <span>2,7</span>
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               <span> – лактоза</span>
                    //               </td>
                    //               <td>
                    //               <span>г</span>
                    //               </td>
                    //               <td>
                    //               <span><0,10</span>
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Харчові волокна
                    //               </td>
                    //               <td>
                    //               г
                    //               </td>
                    //               <td>
                    //               0
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Білки
                    //               </td>
                    //               <td>
                    //               г
                    //               </td>
                    //               <td>
                    //               2,6
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Сіль
                    //               </td>
                    //               <td>
                    //               г
                    //               </td>
                    //               <td>
                    //               0,09
                    //               </td>
                    //             </tr>
                    //           </tbody>
                    //         </table>
                    //         `,
                    //         `
                    //         <table>
                    //           <thead>
                    //             <tr>
                    //               <th colspan="3">Вітаміни</th>
                    //             </tr>
                    //           </thead>
                    //           <tbody>
                    //             <tr>
                    //               <td>
                    //               Вітамін А
                    //               </td>
                    //               <td>
                    //               мкгRE
                    //               </td>
                    //               <td>
                    //               88,0
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Вітамін D
                    //               </td>
                    //               <td>
                    //               мкг
                    //               </td>
                    //               <td>
                    //               2,4
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Вітамін Е
                    //               </td>
                    //               <td>мг <br>(α-TE)</td>
                    //               <td>
                    //               2,1
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Альфа-токоферол
                    //               </td>
                    //               <td>мг</td>
                    //               <td>
                    //               2,7
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Вітамін К
                    //               </td>
                    //               <td>
                    //               мкг
                    //               </td>
                    //               <td>
                    //               6,7
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Тіамін
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               0,15
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Рибофлавін
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               0,20
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Ніацин<br> <span>(преформований)</span>
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               0,80
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Ніацин <br><span>(включаючи триптофан)</span>
                    //               </td>
                    //               <td>
                    //               мг NE
                    //               </td>
                    //               <td>
                    //               1,67
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Пантотенова кислота
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               0,80
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Вітамін В<sub>6</sub>
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               0,11
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Фолієва кислота
                    //               </td>
                    //               <td>
                    //               мкг
                    //               </td>
                    //               <td>
                    //               16,0
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Фолати
                    //               </td>
                    //               <td>
                    //               мкг
                    //               </td>
                    //               <td>
                    //               26,7
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Вітамін В<sub>12</sub>
                    //               </td>
                    //               <td>
                    //               мкг
                    //               </td>
                    //               <td>
                    //               0,30
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Біотин
                    //               </td>
                    //               <td>
                    //               мкг
                    //               </td>
                    //               <td>
                    //               4,0
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Вітамін С
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               14,0
                    //               </td>
                    //             </tr>
                    //           </tbody>
                    //         </table>
                    //         `,
                    //         `
                    //         <table>
                    //           <thead>
                    //             <th colspan="3">Мінеральні речовини</th>
                    //           </thead>
                    //           <tbody>
                    //             <tr>
                    //               <td>
                    //               Натрій
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               37,0
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Калій
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               111,0
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Хлориди
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               75,0
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Кальцій
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               90,0
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Фосфор
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               45,0
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Магній
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               9,0
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Залізо
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               1,2
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Цинк
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               0,80
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Мідь
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               0,075
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Марганець
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               0,006
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Молібден
                    //               </td>
                    //               <td>
                    //               мкг
                    //               </td>
                    //               <td>
                    //               6,0
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Селен
                    //               </td>
                    //               <td>
                    //               мкг
                    //               </td>
                    //               <td>
                    //               3,75
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Хром
                    //               </td>
                    //               <td>
                    //               мкг
                    //               </td>
                    //               <td>
                    //               4,0
                    //               </td>
                    //             </tr>
                    //             <tr>
                    //               <td>
                    //               Йод
                    //               </td>
                    //               <td>
                    //               мкг
                    //               </td>
                    //               <td>
                    //               19,0
                    //               </td>
                    //             </tr>
                    //           </tbody>
                    //         </table>
                    //         `,
                    //           `
                    //         <table>
                    //           <thead>
                    //             <tr>
                    //               <th colspan="3">Інші</th>
                    //             </tr>
                    //           </thead>
                    //           <tbody>
                    //             <tr>
                    //               <td>
                    //               L-карнітин
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               2,0
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Холін
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               32,1
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Інозитол
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               25,0
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Таурин
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               7,0
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Нуклеотиди
                    //               </td>
                    //               <td>
                    //               мг
                    //               </td>
                    //               <td>
                    //               3,6
                    //               </td>
                    //             </tr>

                    //             <tr>
                    //               <td>
                    //               Осмолярність
                    //               </td>
                    //               <td>
                    //               мОсмоль/л
                    //               </td>
                    //               <td>
                    //               295
                    //               </td>
                    //             </tr>

                    //           </tbody>
                    //         </table>
                    //         `,
                    //         ],
                    //       },
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "Про продукт",
                    //       content: [
                    //         `
                    //         <strong>Важлива інформація: </strong><br>
                    //         Застосовувати тільки під наглядом лікаря, після повного розгляду всіх варіантів годування, включаючи  грудне вигодовування. Тільки для ентерального застосування! Не застосовувати парентерально! Може застосовуватись як єдине джерело харчування для дітей від народження до 18 місяців або з масою тіла до 9 кг. Не є лікарським засобом.
                    //         `,
                    //       ],
                    //       // list: [
                    //       //   "<strong>Застереження щодо застосування:</strong> ",
                    //       //   "•	Продукт рекомендовано вводити в раціон повільно, так як швидке всмоктування великої кількості продукту може спричинити блювання або діарею.",
                    //       // ],
                    //       content2: [
                    //         `
                    //         <p>
                    //         <strong>Форма випуску:</strong> <br>
                    //         Рідка суміш у пластиковій пляшечці об'ємом 200 мл <sup><strong>e</strong></sup>.
                    //         </p>
                    //       `,
                    //       ],
                    //     },
                    //     {
                    //       isActive: false,
                    //       title: "застосування",
                    //       content: [
                    //         `
                    //         <strong> Спосіб застосування: </strong>
                    //         <p>• Вимийте руки, використовуйте чистий або стерилізований посуд.</p>
                    //         <p>• Перед застосуванням добре збовтати.</p>
                    //         <p>• Перелийте суміш у стерилізовану пляшечку для годування або в контейнер для годування через зонд.</p>
                    //         <p>• Застосовувати суміш кімнатної температури або підігріти до +37 °С.</p>
                    //         <p>• Не використовуйте мікрохвильову піч для розігріву.</p>
                    //         <p>• Завжди перевіряйте температуру суміші перед застосуванням.</p>
                    //         <p><br><strong>Застереження щодо гігієни ротової порожнини:</strong> Тривалий або частий контакт напоїв та їжі із зубами збільшує ризик карієсу, тому якісна гігієна ротової порожнини важлива для немовлят та дітей. Слідкуйте за першими зубками малюка, особливо перед сном. При необхідності проконсультуйтесь з Вашим лікарем або стоматологом.</p>
                    //         `,
                    //       ],
                    //     },
                    //   ],
                    // },


                ],
            },
        },
        productsFG: [
            {
                id: 0,
                name: 'Суміш Infatrini',
                text: 'Від 0 до 18 місяців або вагою до 9 кг без тяжких порушень травлення',
                img: '17',
                size: 125,
                step: 25,
                counter: 0,
                kkalPerStep: 25,
                proteinePerStep: 0.65,
                type: 'мл',
                stepType: 'мл',
                minAge: 0,
                maxAge: 1.5,
                minWeight: 0,
                maxWeight: 9,
            },
            {
                id: 1,
                name: 'Суміш Infatrini Пептісорб',
                text: 'Від 0 до 18 місяців або вагою до 9 кг з мальдігестією, мальабсорбцією',
                img: '18',
                size: 200,
                step: 25,
                counter: 0,
                kkalPerStep: 25,
                proteinePerStep: 0.65,
                type: 'мл',
                stepType: 'мл',
                minAge: 0,
                maxAge: 1.5,
                minWeight: 0,
                maxWeight: 9,
            },
            {
                id: 8,
                name: 'Напій рідкий Fortini Multi Fibre',
                text: 'Від 1 року',
                img: '36',
                size: 200,
                step: 1,
                counter: 0,
                kkalPerStep: 306,
                proteinePerStep:6.6,
                type: 'мл',
                stepType: 'пляшк',
                minAge: 1,
                maxAge: 18,
                minWeight: 1,
                maxWeight: 85,
            },
            {
                id: 2,
                name: 'Суміш Nutrini',
                text: 'Від 1 до 6 років або вагою від 8 до 20 кг',
                img: '15',
                size: 500,
                step: 50,
                counter: 0,
                kkalPerStep: 50,
                proteinePerStep: 1.25,
                type: 'мл',
                stepType: 'мл',
                minAge: 1,
                maxAge: 6,
                minWeight: 8,
                maxWeight: 20
            },
            {
                id: 3,
                name: 'Суміш Nutrison Powder',
                text: 'Від 1 року',
                img: '16',
                size: 430,
                step: 1,
                counter: 0,
                kkalPerStep: 20,
                proteinePerStep: 0.78,
                type: 'г',
                stepType: 'лож',
                minAge: 1,
                maxAge: 18,
                minWeight: 0,
                maxWeight: 250,
            },
            {
                id: 4,
                name: 'Суміш Nutridrink Compact Fibre',
                text: 'Від 3 років',
                img: '19.1',
                size: 125,
                step: 1,
                counter: 0,
                kkalPerStep: 240,
                proteinePerStep: 9.5,
                type: 'мл',
                stepType: 'пляшк',
                minAge: 3,
                maxAge: 18,
                minWeight: 0,
                maxWeight: 250,
            },

            {
                id: 6,
                name: 'Суміш Nutrilon Мальабсорбція',
                text: 'Від народження (до 1 року можна   на повний раціон), з мальдігестією, мальабсорбцією',
                img: '5',
                size: 400,
                step: 100,
                counter: 0,
                kkalPerStep: 66,
                proteinePerStep: 1.8,
                type: 'г',
                stepType: 'мл',
                minAge: 0,
                maxAge: 3,
                minWeight: 0,
                maxWeight: 250,
            },

            {
                id: 7,
                name: 'Суміш Neocate',
                text: 'Від народження (до 1 року можна   на повний раціон), на основі вільних амінокислот',
                img: '20',
                size: 400,
                step: 100,
                counter: 0,
                kkalPerStep: 67,
                proteinePerStep: 1.8,
                type: 'г',
                stepType: 'мл',
                minAge: 0,
                maxAge: 18,
                minWeight: 0,
                maxWeight: 250,
            },
            {
                id: 5,
                name: 'Жирова емульсія Liquigen',
                text: 'Від народження',
                img: '27',
                size: 250,
                step: 5,
                counter: 0,
                kkalPerStep: 22.7,
                proteinePerStep: 0,
                type: 'мл',
                stepType: 'мл',
                minAge: 0,
                maxAge: 18,
                minWeight: 0,
                maxWeight: 250,
                info: "Для підвищення калорійності після корекції вмісту білків іншими продуктами"
            },
        ],
        productsDefPerDay: [
            {
                id: 0,
                name: 'Суміш молочна суха Nutrilon 1',
                text: 'Від 0 до 6 місяців',
                img: '10',
                link: '/production/9',
                minAge: 0,
                maxAge: 6,
            },
            {
                id: 1,
                name: 'Суміш молочна суха Nutrilon 2',
                text: 'Від 6 до 12 місяців',
                img: '11',
                link: '/production/10',
                minAge: 6,
                maxAge: 12,

            },
            {
                id: 2,
                name: 'Суміш молочна суха Nutrilon 3',
                text: 'Від 12 до 18 місяців',
                img: '12',
                link: '/production/19',
                minAge: 12,
                maxAge: 18,

            },
            {
                id: 3,
                name: 'Суміш молочна суха Nutrilon 4',
                text: 'Від 18 місяців',
                img: '13',
                link: '/production/20',
                minAge: 18,
                maxAge: 36,

            },
            {
                id: 4,
                name: 'Суміш молочна суха Nutrilon Гіпоалергенний 1',
                text: 'Від 0 до 6 місяців при схильності до АБКМ',
                img: '7',
                link: '/production/6',
                minAge: 0,
                maxAge: 6,

            },
            {
                id: 5,
                name: 'Суміш молочна суха Nutrilon Гіпоалергенний 2',
                text: 'Від 6 місяців при схильності до АБКМ',
                img: '8',
                link: '/production/7',
                minAge: 6,
                maxAge: 36,

            },
            {
                id: 6,
                name: 'Суміш молочна суха Nutrilon Пепті',
                text: 'Від 0 місяців при легких й середньотяжких проявах АБКМ',
                img: '2',
                link: '/production/1',
                minAge: 0,
                maxAge: 36,

            },
            {
                id: 7,
                name: 'Суміш молочна суха Nutrilon Мальабсорбція',
                text: 'Від 0 місяців при мальабсорбції або АБКМ з кольками й діареєю',
                img: '5',
                link: '/production/4',
                minAge: 0,
                maxAge: 36,

            },
            {
                id: 8,
                name: 'Суміш молочна суха Nutricia Neocate',
                text: 'Від 0 місяців при мальабсорбції або АБКМ будь-якої тяжкості',
                img: '20',
                link: '/production/16',
                minAge: 0,
                maxAge: 36,

            },
            {
                id: 9,
                name: 'Суміш молочна суха Nutrilon Безлактозний',
                text: 'Від 0 місяців при непереносимості лактози',
                img: '3',
                link: '/production/2',
                minAge: 0,
                maxAge: 36,

            },
            {
                id: 10,
                name: 'Суміш молочна суха Nutrilon Комфорт 1',
                text: 'Від 0 до 6 місяців при функціональних кольках або закрепах',
                img: '1',
                link: '/production/0',
                minAge: 0,
                maxAge: 6,

            },
            {
                id: 11,
                name: 'Суміш молочна суха Nutrilon Комфорт 2',
                text: 'Від 6 місяців при функціональних кольках або закрепах',
                img: '4',
                link: '/production/3',
                minAge: 6,
                maxAge: 36,

            },
            {
                id: 12,
                name: 'Суміш молочна суха Nutrilon Кисломолочний 1',
                text: 'Від 0 до 6 місяців при дисбіозі, діареї',
                img: '6',
                link: '/production/5',
                minAge: 0,
                maxAge: 6,

            },
            {
                id: 13,
                name: 'Суміш молочна суха Nutrilon Кисломолочний 2',
                text: 'Від 6 місяців при дисбіозі, діареї',
                img: '9',
                link: '/production/8',
                minAge: 6,
                maxAge: 36,

            },
            {
                id: 14,
                name: 'Суміш молочна суха Nutrilon Антирефлюкс',
                text: 'Від 0 місяців при зригуваннях будь-якої тяжкості',
                img: '11.1',
                link: '/production/11',
                minAge: 0,
                maxAge: 36,

            },
        ],
        registrationStage: '1',
        prevPopup: '',
        showFooter: true,
    },
    getters: {
        getClinicalProducts(state) {
            return state.clinicalProducts;
        },
        getProductsFG(state) {
            return state.productsFG;
        },
        getProductsDefPerDay(state) {
            return state.productsDefPerDay;
        },

        getMenuCtrl(state) {
            return state.menuCtrl
        },
        getShowFooter(state) {
            return state.showFooter
        },
        getRegistrationStage(state) {
            return state.registrationStage
        },
        getPrevPopup(state) {
            return state.prevPopup
        }
    },
    mutations: {
        updateData(state, val) {
            state.menuCtrl = val
        },
        changeFooterState(state, val) {
            state.showFooter = val
        },
        changeRegistrationStage(state, val) {
            state.registrationStage = val
        },
        changePrevPopup(state, val) {
            state.prevPopup = val
        }
    },
    actions: {
        setMenuData(context, val) {
            context.commit("updateData", val);
        },
        setFooterState(context, val) {
            context.commit("changeFooterState", val);
        },
        setRegistrationStage(context, val) {
            context.commit("changeRegistrationStage", val);
        },
        setPrevPopup(context, val) {
            context.commit("changePrevPopup", val);
        }
    },
});
